// Code generated by '@graphql-codegen'; DO NOT EDIT.
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** `Date` type as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: any;
};

export type AiGeneratedTalkingPointObj = {
  __typename?: 'AIGeneratedTalkingPointObj';
  placeholder?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  title: Scalars['String'];
};

export type AiLaunchContentObj = {
  __typename?: 'AILaunchContentObj';
  launchObjectives?: Maybe<Scalars['String']>;
  messaging?: Maybe<Scalars['String']>;
  positioningStrategy?: Maybe<Scalars['String']>;
};

export type AiSummaryOutput = {
  __typename?: 'AISummaryOutput';
  companyName?: Maybe<Scalars['String']>;
  strengths?: Maybe<Array<Scalars['String']>>;
  weaknesses?: Maybe<Array<Scalars['String']>>;
};

export enum AiContentTypes {
  ARRAY_CONTENT = 'ARRAY_CONTENT',
  NOT_FOUND = 'NOT_FOUND',
  OBJECT_CONTENT = 'OBJECT_CONTENT',
  STRING_CONTENT = 'STRING_CONTENT'
}

export enum AnnouncementsRecipientsTypes {
  MESSAGE_GROUP = 'MESSAGE_GROUP',
  NON_USER = 'NON_USER',
  USER = 'USER'
}

export enum AssetActionTypes {
  ADD_APPROVER = 'ADD_APPROVER',
  APPROVE_ASSET = 'APPROVE_ASSET',
  REMOVE_APPROVER = 'REMOVE_APPROVER',
  UNAPPROVE_ASSET = 'UNAPPROVE_ASSET'
}

export enum AssetTypes {
  ASSETS = 'ASSETS',
  COPY = 'COPY',
  SALES_ENABLEMENT = 'SALES_ENABLEMENT'
}

export type AddLaunchConnectionsInput = {
  competitorIds?: Maybe<Array<Scalars['String']>>;
  feedbackPostIds?: Maybe<Array<Scalars['String']>>;
  insightIds?: Maybe<Array<Scalars['String']>>;
  launchId: Scalars['String'];
  personaIds?: Maybe<Array<Scalars['String']>>;
  productBoardItemIds?: Maybe<Array<Scalars['String']>>;
  productIntegrationTaskIds?: Maybe<Array<Scalars['String']>>;
};

export type AddLaunchPhaseApproversInput = {
  approvers?: Maybe<Array<UpdateApproversInput>>;
  invitedApprovers?: Maybe<Array<InvitedApproversEmailInput>>;
  launchId: Scalars['String'];
  phaseId: Scalars['String'];
};

export type AddLaunchPhaseInput = {
  approvers?: Maybe<Array<UpdateApproversInput>>;
  endDate: Scalars['DateTime'];
  invitedApprovers?: Maybe<Array<InvitedApproversEmailInput>>;
  launchId: Scalars['String'];
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
};

export type AddPhaseApproversInput = {
  approvers?: Maybe<Array<UpdateApproversInput>>;
  id: Scalars['String'];
  invitedApprovers?: Maybe<Array<InvitedApproversEmailInput>>;
};

export type AddPhaseInput = {
  daysAfterLaunch: Scalars['Float'];
  defaultApprovers?: Maybe<Array<UpdateApproversInput>>;
  durationInDays: Scalars['Float'];
  invitedApprovers?: Maybe<Array<InvitedApproversEmailInput>>;
  launchTier: LaunchTiers;
  launchTypeId: Scalars['String'];
  name: Scalars['String'];
};

export type AddProductBoardItemDependencyInput = {
  blockedById: Scalars['String'];
  blockingId: Scalars['String'];
};

export type AddProductBoardItemDependencyResultDto = {
  __typename?: 'AddProductBoardItemDependencyResultDto';
  blockedByItem: ProductBoardItemObj;
  blockingItem: ProductBoardItemObj;
};

export type AdminCreateOrganizationInput = {
  allowUsersFromSameDomain?: Maybe<Scalars['Boolean']>;
  hasPaidSubscription?: Maybe<Scalars['Boolean']>;
  isActive: Scalars['Boolean'];
  isUnderFreeTrial?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  organizationEmailDomain?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  users?: Maybe<Array<AdminCreateUserInOrganizationInput>>;
};

export type AdminCreateUserInOrganizationInput = {
  role: UserRolesInOrganizationTypes;
  userId: Scalars['String'];
};

export type AdminUpdateOrganizationInput = {
  admin?: Maybe<Scalars['String']>;
  allowUsersFromSameDomain?: Maybe<Scalars['Boolean']>;
  billingEmailId?: Maybe<Scalars['String']>;
  billingVersion?: Maybe<Scalars['String']>;
  chatGTMEnabled?: Maybe<Scalars['Boolean']>;
  companyType?: Maybe<OrganizationTypeOfCompany>;
  hasPaidSubscription?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  isDemo?: Maybe<Scalars['Boolean']>;
  isUnderFreeTrial?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationEmailDomain?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  users?: Maybe<Array<AdminUpdateUserInOrganizationInput>>;
};

export type AdminUpdateUserInOrganizationInput = {
  inviteAccepted: Scalars['Boolean'];
  role: UserRolesInOrganizationTypes;
  userId: Scalars['String'];
};

export type AiCopywritingSectionObj = {
  __typename?: 'AiCopywritingSectionObj';
  isCompletedMarketingOrAssetGeneration: Scalars['Boolean'];
};

export type AiPromptInput = {
  finalString?: Maybe<Scalars['String']>;
  json?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  prompt: Scalars['String'];
};

export type AiPromptObj = {
  __typename?: 'AiPromptObj';
  finalString?: Maybe<Scalars['String']>;
  json?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  prompt: Scalars['String'];
};

export type AiSettingsObj = {
  __typename?: 'AiSettingsObj';
  brandGuidelines?: Maybe<Scalars['String']>;
  companyDescription: Scalars['String'];
  companyName: Scalars['String'];
  companyWebsite: Scalars['String'];
  tone: Scalars['String'];
};

export type AmplitudeIntegrationObj = {
  __typename?: 'AmplitudeIntegrationObj';
  events?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  organizationId: Scalars['String'];
  ownerId: Scalars['String'];
  password: Scalars['String'];
  username: Scalars['String'];
};

export type AnnouncementObj = {
  __typename?: 'AnnouncementObj';
  destinations: Array<NotificationDestinations>;
  gtmTimeline?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  integrationChannel?: Maybe<Scalars['String']>;
  launch: LaunchObj;
  launchModuleIds: Array<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  missionControlStatus?: Maybe<Scalars['Boolean']>;
  organizationId: Scalars['String'];
  owner: UserObj;
  recipients: RecipientObj;
  recipientsData: Array<RecipientDataObj>;
  repeatOn?: Maybe<Scalars['DateTime']>;
  repeatType: RepeatNotificationTypes;
  sendAs: NotificationSendAsTypes;
  status: NotificationStatus;
  subject: Scalars['String'];
};

export type AnnouncementRecipientObj = {
  __typename?: 'AnnouncementRecipientObj';
  id: Scalars['String'];
  type: AnnouncementsRecipientsTypes;
  value: Scalars['String'];
};

export type ApproveAssetInput = {
  assetId: Scalars['String'];
  organizationId: Scalars['String'];
  userId: Scalars['String'];
};

export type ApproveAssetResponseObj = {
  __typename?: 'ApproveAssetResponseObj';
  email: Scalars['String'];
  sent: Scalars['Boolean'];
};

export type ApproverDetailsObj = {
  __typename?: 'ApproverDetailsObj';
  hasApproved: Scalars['Boolean'];
  userDetails: UserObj;
};

export type AskForDemoInput = {
  comment?: Maybe<Scalars['String']>;
};

export type AssetApproverInput = {
  hasApproved?: Maybe<Scalars['Boolean']>;
  userId: Scalars['String'];
};

export type AssetApproverObj = {
  __typename?: 'AssetApproverObj';
  hasApproved?: Maybe<Scalars['Boolean']>;
  userDetails?: Maybe<UserObj>;
  userId?: Maybe<Scalars['String']>;
};

export type AssetFile = {
  format?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  size?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type AssetFilterOptionsObj = {
  __typename?: 'AssetFilterOptionsObj';
  approvalStatuses: Array<LaunchModuleApprovalStatus>;
  approverOptions: Array<UserFilterOptionObj>;
  launchOptions: Array<LaunchFilterOptionObj>;
  ownerOptions: Array<UserFilterOptionObj>;
  tagOptions: Array<TagFilterOptionObj>;
  types: Array<AssetTypes>;
};

export type AssetObj = {
  __typename?: 'AssetObj';
  approvalStatus?: Maybe<Scalars['String']>;
  approverDetails?: Maybe<Array<AssetApproverObj>>;
  assets?: Maybe<Array<UserInputAssetFilesObj>>;
  brandAsset: Scalars['Boolean'];
  id: Scalars['String'];
  lastEditBy?: Maybe<UserObj>;
  lastEditDetails?: Maybe<LastEditDetailsObj>;
  launchIds?: Maybe<Array<Scalars['String']>>;
  launches?: Maybe<Array<LaunchObj>>;
  name?: Maybe<Scalars['String']>;
  opened?: Maybe<Scalars['Boolean']>;
  orderIndex: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  owner: UserObj;
  tags?: Maybe<Array<TagObj>>;
  tagsIds?: Maybe<Array<Scalars['String']>>;
  type: AssetTypes;
  userInput?: Maybe<Scalars['String']>;
};

export type AssetsFile = {
  format?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  size?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type AssignTagToTasksInput = {
  tagId: Scalars['String'];
  tasksIds: Array<Scalars['String']>;
};

export type AssignTagsToEntitiesInput = {
  entitiesIds: Array<Scalars['String']>;
  tagsIds: Array<Scalars['String']>;
};

export type AttachIntegrationTasksToProductBoardItemInput = {
  integrationSubTaskIds?: Maybe<Array<Scalars['String']>>;
  integrationTaskIds: Array<Scalars['String']>;
  itemId: Scalars['String'];
};

export type AttachmentsFileInput = {
  format: Scalars['String'];
  name: Scalars['String'];
  size: Scalars['String'];
  url: Scalars['String'];
};

export type AttachmentsFileObj = {
  __typename?: 'AttachmentsFileObj';
  format: Scalars['String'];
  name: Scalars['String'];
  size: Scalars['String'];
  url: Scalars['String'];
};

export type AttachmentsInput = {
  content?: Maybe<Scalars['String']>;
  userAttachments?: Maybe<Array<AttachmentsFileInput>>;
};

export type AttachmentsObj = {
  __typename?: 'AttachmentsObj';
  content?: Maybe<Scalars['String']>;
  userAttachments?: Maybe<Array<AttachmentsFileObj>>;
};

export type AvgG2ScoreHistory = {
  fetchedAt: Scalars['DateTime'];
  score: Scalars['Float'];
};

export enum BattlecardsDocsSortKeys {
  A_Z = 'A_Z',
  COMPANY_TAGS = 'COMPANY_TAGS',
  NEWEST_FIRST = 'NEWEST_FIRST',
  PRODUCT_LINE_TAGS = 'PRODUCT_LINE_TAGS',
  Z_A = 'Z_A'
}

export enum BattlecardsGroupByKeys {
  COMPANY_TAGS = 'COMPANY_TAGS',
  PRODUCT_LINE_TAGS = 'PRODUCT_LINE_TAGS'
}

export type CdpAccountCreateInput = {
  accountValue?: Maybe<Scalars['Float']>;
  annualRevenue?: Maybe<Scalars['Float']>;
  domain: Scalars['String'];
  employees?: Maybe<Scalars['Float']>;
  industry?: Maybe<Scalars['String']>;
  isEnriched?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Scalars['String']>;
  manual?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  source?: Maybe<CdpDataSource>;
  type?: Maybe<Scalars['String']>;
};

export type CdpAccountFilterOptionObj = {
  __typename?: 'CDPAccountFilterOptionObj';
  label: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type CdpAccountItemsFilterInput = {
  accountValueGte?: Maybe<Scalars['Float']>;
  accountValueLte?: Maybe<Scalars['Float']>;
  annualRevenueGte?: Maybe<Scalars['Float']>;
  annualRevenueLte?: Maybe<Scalars['Float']>;
  createdAtGte?: Maybe<Scalars['DateTime']>;
  createdAtLte?: Maybe<Scalars['DateTime']>;
  domain?: Maybe<Scalars['String']>;
  employeesGte?: Maybe<Scalars['Float']>;
  employeesLte?: Maybe<Scalars['Float']>;
  industry?: Maybe<Array<Scalars['String']>>;
  isEnriched?: Maybe<Scalars['Boolean']>;
  manual?: Maybe<Scalars['Boolean']>;
  query?: Maybe<Scalars['String']>;
  region?: Maybe<Array<Scalars['String']>>;
  source?: Maybe<Array<CdpDataSource>>;
  type?: Maybe<Array<Scalars['String']>>;
  updatedAtGte?: Maybe<Scalars['DateTime']>;
  updatedAtLte?: Maybe<Scalars['DateTime']>;
};

export type CdpAccountItemsFilterObj = {
  __typename?: 'CDPAccountItemsFilterObj';
  accountValueGte?: Maybe<Scalars['Float']>;
  accountValueLte?: Maybe<Scalars['Float']>;
  annualRevenueGte?: Maybe<Scalars['Float']>;
  annualRevenueLte?: Maybe<Scalars['Float']>;
  createdAtGte?: Maybe<Scalars['DateTime']>;
  createdAtLte?: Maybe<Scalars['DateTime']>;
  employeesGte?: Maybe<Scalars['Float']>;
  employeesLte?: Maybe<Scalars['Float']>;
  industry?: Maybe<Array<Scalars['String']>>;
  isEnriched?: Maybe<Scalars['Boolean']>;
  manual?: Maybe<Scalars['Boolean']>;
  query?: Maybe<Scalars['String']>;
  region?: Maybe<Array<Scalars['String']>>;
  source?: Maybe<Array<CdpDataSource>>;
  type?: Maybe<Array<Scalars['String']>>;
  updatedAtGte?: Maybe<Scalars['DateTime']>;
  updatedAtLte?: Maybe<Scalars['DateTime']>;
};

export type CdpAccountItemsSortInput = {
  accountValue?: Maybe<FieldSortInput>;
  annualRevenue?: Maybe<FieldSortInput>;
  createdAt?: Maybe<FieldSortInput>;
  domain?: Maybe<FieldSortInput>;
  employees?: Maybe<FieldSortInput>;
  industry?: Maybe<FieldSortInput>;
  name?: Maybe<FieldSortInput>;
  region?: Maybe<FieldSortInput>;
  type?: Maybe<FieldSortInput>;
};

export type CdpAccountObj = {
  __typename?: 'CDPAccountObj';
  accountId?: Maybe<Scalars['String']>;
  accountValue?: Maybe<Scalars['Float']>;
  annualRevenue?: Maybe<Scalars['Float']>;
  contacts: Array<CdpContactObj>;
  createdAt: Scalars['DateTime'];
  deals: Array<CdpDealObj>;
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  employees?: Maybe<Scalars['Float']>;
  feedbackPosts?: Maybe<Array<FeedbackPostDto>>;
  id: Scalars['String'];
  industry?: Maybe<Scalars['String']>;
  insights?: Maybe<Array<InsightObj>>;
  isEnriched?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Scalars['String']>;
  manual?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  productBoardItems?: Maybe<Array<ProductBoardItemObj>>;
  region?: Maybe<Scalars['String']>;
  source?: Maybe<CdpDataSource>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CdpAccountUpdateInput = {
  accountValue?: Maybe<Scalars['Float']>;
  annualRevenue?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  employees?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  industry?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type CdpContactCreateInput = {
  accountId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  manual?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  source?: Maybe<CdpDataSource>;
};

export type CdpContactItemsFilterInput = {
  accountIds?: Maybe<Array<Scalars['String']>>;
  contactIds?: Maybe<Array<Scalars['String']>>;
  createdAtGte?: Maybe<Scalars['DateTime']>;
  createdAtLte?: Maybe<Scalars['DateTime']>;
  industry?: Maybe<Array<Scalars['String']>>;
  isEnriched?: Maybe<Scalars['Boolean']>;
  manual?: Maybe<Scalars['Boolean']>;
  ownerIds?: Maybe<Array<Scalars['String']>>;
  query?: Maybe<Scalars['String']>;
  role?: Maybe<Array<Scalars['String']>>;
  source?: Maybe<Array<CdpDataSource>>;
  stage?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Array<Scalars['String']>>;
  updatedAtGte?: Maybe<Scalars['DateTime']>;
  updatedAtLte?: Maybe<Scalars['DateTime']>;
};

export type CdpContactItemsSortInput = {
  createdAt?: Maybe<FieldSortInput>;
  email?: Maybe<FieldSortInput>;
  name?: Maybe<FieldSortInput>;
  role?: Maybe<FieldSortInput>;
  stage?: Maybe<FieldSortInput>;
};

export type CdpContactObj = {
  __typename?: 'CDPContactObj';
  account?: Maybe<CdpAccountObj>;
  contactId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deals: Array<CdpDealObj>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  feedbackPosts?: Maybe<Array<FeedbackPostDto>>;
  id: Scalars['String'];
  industry?: Maybe<Scalars['String']>;
  insights?: Maybe<Array<InsightObj>>;
  manual?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<CdpOwnerObj>;
  ownerId?: Maybe<Scalars['String']>;
  productBoardItems?: Maybe<Array<ProductBoardItemObj>>;
  region?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  source?: Maybe<CdpDataSource>;
  stage?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CdpContactUpdateInput = {
  accountId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  industry?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type CdpDealCreateInput = {
  name?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
};

export type CdpDealItemsFilterInput = {
  accountIds?: Maybe<Array<Scalars['String']>>;
  amountGte?: Maybe<Scalars['Float']>;
  amountLte?: Maybe<Scalars['Float']>;
  closedDateGte?: Maybe<Scalars['DateTime']>;
  closedDateLte?: Maybe<Scalars['DateTime']>;
  createdDateGte?: Maybe<Scalars['DateTime']>;
  createdDateLte?: Maybe<Scalars['DateTime']>;
  manual?: Maybe<Scalars['Boolean']>;
  ownerIds?: Maybe<Array<Scalars['String']>>;
  query?: Maybe<Scalars['String']>;
  source?: Maybe<Array<CdpDataSource>>;
  stage?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Array<Scalars['String']>>;
};

export type CdpDealItemsSortInput = {
  amount?: Maybe<FieldSortInput>;
  closedDate?: Maybe<FieldSortInput>;
  createdAt?: Maybe<FieldSortInput>;
  createdDate?: Maybe<FieldSortInput>;
  name?: Maybe<FieldSortInput>;
  stage?: Maybe<FieldSortInput>;
  type?: Maybe<FieldSortInput>;
};

export type CdpDealObj = {
  __typename?: 'CDPDealObj';
  account?: Maybe<CdpAccountObj>;
  accountId?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  closedDate?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  createdDate?: Maybe<Scalars['DateTime']>;
  dealId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  manual?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  owner?: Maybe<CdpOwnerObj>;
  ownerId?: Maybe<Scalars['String']>;
  source?: Maybe<CdpDataSource>;
  stage?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CdpOwnerCreateInput = {
  email?: Maybe<Scalars['String']>;
  manual?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  source?: Maybe<CdpDataSource>;
};

export type CdpOwnerItemsFilterInput = {
  createdAtGte?: Maybe<Scalars['DateTime']>;
  createdAtLte?: Maybe<Scalars['DateTime']>;
  manual?: Maybe<Scalars['Boolean']>;
  query?: Maybe<Scalars['String']>;
  source?: Maybe<Array<CdpDataSource>>;
  type?: Maybe<Scalars['String']>;
  updatedAtGte?: Maybe<Scalars['DateTime']>;
  updatedAtLte?: Maybe<Scalars['DateTime']>;
};

export type CdpOwnerItemsSortInput = {
  createdAt?: Maybe<FieldSortInput>;
  email?: Maybe<FieldSortInput>;
  name?: Maybe<FieldSortInput>;
};

export type CdpOwnerObj = {
  __typename?: 'CDPOwnerObj';
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  manual?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  ownerId?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  source?: Maybe<CdpDataSource>;
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export enum CdpDataSource {
  CSV = 'CSV',
  HUBSPOT = 'HUBSPOT',
  INTERCOM = 'INTERCOM',
  MANUAL = 'MANUAL',
  SALESFORCE = 'SALESFORCE',
  SLACK = 'SLACK'
}

export enum ChannelEventType {
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  UPDATED = 'UPDATED'
}

export enum ChannelType {
  EARNED = 'EARNED',
  OWNED = 'OWNED',
  PAID = 'PAID'
}

export enum CommentParentType {
  ASSET = 'ASSET',
  INSIGHT = 'INSIGHT',
  LAUNCH_MODULE = 'LAUNCH_MODULE',
  LAUNCH_TASKS = 'LAUNCH_TASKS',
  PRODUCT_BOARD_ITEM = 'PRODUCT_BOARD_ITEM'
}

export enum CompletionType {
  CONTINUE_WRITING = 'CONTINUE_WRITING',
  CORRECT_GRAMMAR = 'CORRECT_GRAMMAR',
  SUMMARIZE = 'SUMMARIZE'
}

export enum CopilotOnBoardingSteps {
  COPILOT_ON_BOARDING_ASSETS_STEP = 'COPILOT_ON_BOARDING_ASSETS_STEP',
  COPILOT_ON_BOARDING_OBJECTIVES_STEP = 'COPILOT_ON_BOARDING_OBJECTIVES_STEP',
  COPILOT_ON_BOARDING_PERSONAS_STEP = 'COPILOT_ON_BOARDING_PERSONAS_STEP',
  COPILOT_ON_BOARDING_SHARE_STEP = 'COPILOT_ON_BOARDING_SHARE_STEP',
  COPILOT_ON_BOARDING_STRATEGY_STEP = 'COPILOT_ON_BOARDING_STRATEGY_STEP',
  COPILOT_ON_BOARDING_TASKS_STEP = 'COPILOT_ON_BOARDING_TASKS_STEP',
  COPILOT_ON_BOARDING_TIMELINE_STEP = 'COPILOT_ON_BOARDING_TIMELINE_STEP'
}

export enum CopysmithGroupTypes {
  ADVERTISING = 'ADVERTISING',
  ARTICLE_AND_BLOG = 'ARTICLE_AND_BLOG',
  BRANDING_AND_WEB = 'BRANDING_AND_WEB',
  OTHER = 'OTHER'
}

export enum CopysmithPromptsType {
  FACEBOOK_AD = 'FACEBOOK_AD',
  GOOGLE_AD = 'GOOGLE_AD',
  INSTAGRAM_AD = 'INSTAGRAM_AD',
  LINKEDIN_AD = 'LINKEDIN_AD',
  PRODUCT_DESCRIPTION = 'PRODUCT_DESCRIPTION',
  SEO_METATAG = 'SEO_METATAG',
  SOCIAL_MEDIA_CAPTIONS = 'SOCIAL_MEDIA_CAPTIONS',
  TAGLINES = 'TAGLINES'
}

export enum CopysmithPromptTypes {
  KEYWORDS_ARRAY = 'KEYWORDS_ARRAY',
  KEYWORDS_STRING = 'KEYWORDS_STRING',
  RICH_TEXT = 'RICH_TEXT',
  SINGLE_TEXT = 'SINGLE_TEXT',
  TONE = 'TONE'
}

export enum CopysmithTemplateTypes {
  AD_HEADLINES = 'AD_HEADLINES',
  AD_IDEAS = 'AD_IDEAS',
  AIDA_FRAMEWORK = 'AIDA_FRAMEWORK',
  AMAZON_PRODUCT_DESCRIPTION = 'AMAZON_PRODUCT_DESCRIPTION',
  ARTICLE_SUMMARY = 'ARTICLE_SUMMARY',
  BEFORE_AFTER_BRIDGE = 'BEFORE_AFTER_BRIDGE',
  BLOG_IDEAS = 'BLOG_IDEAS',
  BLOG_INTRO = 'BLOG_INTRO',
  BLOG_OUTLINE = 'BLOG_OUTLINE',
  BLOG_TITLE = 'BLOG_TITLE',
  BRAND_ESSENCE = 'BRAND_ESSENCE',
  BULLET_POINT_EXPANDER = 'BULLET_POINT_EXPANDER',
  CAROUSEL_AD = 'CAROUSEL_AD',
  COMMAND_COPY = 'COMMAND_COPY',
  CONTENT_ENHANCER = 'CONTENT_ENHANCER',
  CONTENT_EXPANDER = 'CONTENT_EXPANDER',
  CONTENT_IDEAS = 'CONTENT_IDEAS',
  CONTENT_REWRITER = 'CONTENT_REWRITER',
  CREATIVE_STORY = 'CREATIVE_STORY',
  EBAY_PRODUCT_DESCRIPTION = 'EBAY_PRODUCT_DESCRIPTION',
  EDITOR = 'EDITOR',
  ETSY_PRODUCT_DESCRIPTION = 'ETSY_PRODUCT_DESCRIPTION',
  EVENT_PRESS_RELEASE = 'EVENT_PRESS_RELEASE',
  FACEBOOK_AD = 'FACEBOOK_AD',
  FAQ_IDEAS = 'FAQ_IDEAS',
  FLIPKART_PRODUCTION_DESCRIPTION = 'FLIPKART_PRODUCTION_DESCRIPTION',
  GOOGLE_AD = 'GOOGLE_AD',
  GROWTH_IDEAS = 'GROWTH_IDEAS',
  HOME_DEPOT = 'HOME_DEPOT',
  INSTAGRAM_AD = 'INSTAGRAM_AD',
  INSTAGRAM_PRODUCTION_DESCRIPTION = 'INSTAGRAM_PRODUCTION_DESCRIPTION',
  LANDING_PAGES = 'LANDING_PAGES',
  LINKEDIN_AD_TEXT = 'LINKEDIN_AD_TEXT',
  LISTICLE = 'LISTICLE',
  LOWES_PRODUCT_DESCRIPTION = 'LOWES_PRODUCT_DESCRIPTION',
  OVERSTOCK_PRODUCT_DESCRIPTION = 'OVERSTOCK_PRODUCT_DESCRIPTION',
  PAIN_BENEFIT_SOLUTION = 'PAIN_BENEFIT_SOLUTION',
  PITCH_YOURSELF = 'PITCH_YOURSELF',
  PRODUCT_DESCRIPTION = 'PRODUCT_DESCRIPTION',
  PRODUCT_DESCRIPTION_V2 = 'PRODUCT_DESCRIPTION_V2',
  PRODUCT_FEATURE_BULLETS = 'PRODUCT_FEATURE_BULLETS',
  PRODUCT_REVIEW_REPLIES = 'PRODUCT_REVIEW_REPLIES',
  PRODUCT_TITLE = 'PRODUCT_TITLE',
  SALES_EMAIL_GENERATOR = 'SALES_EMAIL_GENERATOR',
  SALES_EMAIL_SUBJECT_LINES = 'SALES_EMAIL_SUBJECT_LINES',
  SEO_METATAG = 'SEO_METATAG',
  SHORT_EMAIL_MARKETING_TEMPLATE = 'SHORT_EMAIL_MARKETING_TEMPLATE',
  SOCIAL_MEDIA_CAPTIONS = 'SOCIAL_MEDIA_CAPTIONS',
  TAGLINES = 'TAGLINES',
  UNIQUE_VALUE_PROPOSITION = 'UNIQUE_VALUE_PROPOSITION',
  WAYFAIR_PRODUCT_DESCRIPTION = 'WAYFAIR_PRODUCT_DESCRIPTION',
  YOUTUBE_VIDEO_DESCRIPTION = 'YOUTUBE_VIDEO_DESCRIPTION'
}

export enum CopysmithToneOptions {
  ADVENTUROUS = 'ADVENTUROUS',
  FRIENDLY = 'FRIENDLY',
  FUNNY = 'FUNNY',
  LUXURIOUS = 'LUXURIOUS',
  NEUTRAL = 'NEUTRAL',
  PROFESSIONAL = 'PROFESSIONAL'
}

export enum CopywriteV2GroupType {
  ADS = 'ADS',
  LAUNCH_COMMS = 'LAUNCH_COMMS',
  OTHER = 'OTHER',
  PRODUCT_DESCRIPTIONS = 'PRODUCT_DESCRIPTIONS',
  SALES_COMMS = 'SALES_COMMS',
  WEBSITE_AND_BLOG = 'WEBSITE_AND_BLOG'
}

export enum CopywriteV2TemplateType {
  BILLBOARD_AD = 'BILLBOARD_AD',
  FACEBOOK_AD = 'FACEBOOK_AD',
  GOOGLE_AD = 'GOOGLE_AD',
  INSTAGRAM_AD = 'INSTAGRAM_AD',
  LANDING_PAGE_COPY = 'LANDING_PAGE_COPY',
  LAUNCH_BLOG_POST = 'LAUNCH_BLOG_POST',
  LAUNCH_EMAIL = 'LAUNCH_EMAIL',
  LINKEDIN_AD = 'LINKEDIN_AD',
  OUTBOUND_SALES_EMAIL = 'OUTBOUND_SALES_EMAIL',
  PODCAST_SPOT_SCRIPT = 'PODCAST_SPOT_SCRIPT',
  PRESS_RELEASE = 'PRESS_RELEASE',
  PRINT_AD = 'PRINT_AD',
  PRODUCT_BLURB = 'PRODUCT_BLURB',
  RADIO_SPOT_SCRIPT = 'RADIO_SPOT_SCRIPT',
  SOCIAL_POST = 'SOCIAL_POST',
  THOUGHT_LEADERSHIP_BLOG_TOPICS = 'THOUGHT_LEADERSHIP_BLOG_TOPICS',
  TV_SPOT_SCRIPT = 'TV_SPOT_SCRIPT'
}

export enum CrmIntegrationStatuses {
  CREATING = 'CREATING',
  INTEGRATED = 'INTEGRATED',
  LOADING_DATA = 'LOADING_DATA',
  NOT_INTEGRATED = 'NOT_INTEGRATED'
}

export enum CrmObjectType {
  CUSTOM = 'CUSTOM',
  STANDARD = 'STANDARD'
}

export enum CrmOptions {
  HUBSPOT = 'HUBSPOT',
  MICROSOFT_DYNAMICS = 'MICROSOFT_DYNAMICS',
  PIPEDRIVE = 'PIPEDRIVE',
  SALESFORCE = 'SALESFORCE'
}

export type CalendarPageSettingsObj = {
  __typename?: 'CalendarPageSettingsObj';
  live: Scalars['Boolean'];
};

export type CampaignPlanningSectionObj = {
  __typename?: 'CampaignPlanningSectionObj';
  isCompletedConfigureTemplate: Scalars['Boolean'];
  isCompletedCreateFirstLaunch: Scalars['Boolean'];
};

export type ChannelObj = {
  __typename?: 'ChannelObj';
  channelTemplateId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['String'];
  logoSrc?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  timeframes: Array<ChannelTimeframeObj>;
  type: ChannelType;
};

export type ChannelPreferencesObj = {
  __typename?: 'ChannelPreferencesObj';
  earned?: Maybe<Array<PreferenceObj>>;
  owned?: Maybe<Array<PreferenceObj>>;
  paid?: Maybe<Array<PreferenceObj>>;
};

export type ChannelRecommendationRuleObj = {
  __typename?: 'ChannelRecommendationRuleObj';
  haveGtm?: Maybe<Scalars['Boolean']>;
  pricingImpact?: Maybe<Scalars['Boolean']>;
  strategicApproaches: Array<Scalars['String']>;
};

export type ChannelTemplateObj = {
  __typename?: 'ChannelTemplateObj';
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  name: Scalars['String'];
  recommended: Scalars['Boolean'];
  startDate?: Maybe<Scalars['DateTime']>;
  type: ChannelType;
};

export type ChannelTemplatesObj = {
  __typename?: 'ChannelTemplatesObj';
  name: Scalars['String'];
  type: ChannelType;
};

export type ChannelTimeframeObj = {
  __typename?: 'ChannelTimeframeObj';
  budget?: Maybe<Scalars['Float']>;
  description: Scalars['String'];
  endDate: Scalars['Timestamp'];
  id: Scalars['String'];
  name: Scalars['String'];
  startDate: Scalars['Timestamp'];
};

export type ChannelTimeframesSubscriptionResponse = {
  __typename?: 'ChannelTimeframesSubscriptionResponse';
  channelId: Scalars['String'];
  event: ChannelEventType;
  timeframe: ChannelTimeframeObj;
};

export type ChannelsSubscriptionResponse = {
  __typename?: 'ChannelsSubscriptionResponse';
  channel: ChannelObj;
  event: ChannelEventType;
};

export enum ChecklistFeature {
  CAMPAINGS = 'CAMPAINGS',
  COMPETITIVE_INTEL = 'COMPETITIVE_INTEL',
  CONTENT_GENERATION = 'CONTENT_GENERATION',
  ROADMAPS_AND_RELEASES = 'ROADMAPS_AND_RELEASES',
  VOICE_OF_CUSTOMER = 'VOICE_OF_CUSTOMER',
  WORKSPACE_CONFIG = 'WORKSPACE_CONFIG'
}

export type ChecklistObj = {
  __typename?: 'ChecklistObj';
  aiCopywriting?: Maybe<AiCopywritingSectionObj>;
  campaignPlanning?: Maybe<CampaignPlanningSectionObj>;
  competitiveIntel?: Maybe<CompetitiveIntelSectionObj>;
  createdAt: Scalars['DateTime'];
  organizationId: Scalars['String'];
  roadmapping?: Maybe<RoadmappingSectionObj>;
  selectedFeatures?: Maybe<Array<ChecklistFeature>>;
  updatedAt: Scalars['DateTime'];
  voiceOfCustomer?: Maybe<VoiceOfCustomerSectionObj>;
  winloss?: Maybe<WinLossAnalysisSectionObj>;
  workspaceConfig?: Maybe<WorkspaceConfigSectionObj>;
};

export type ClariCopilotInsightIntegrationItemsPaginationInput = {
  cursor?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
};

export type ClearbitCompanyCategoryObj = {
  __typename?: 'ClearbitCompanyCategoryObj';
  industry?: Maybe<Scalars['String']>;
  industryGroup?: Maybe<Scalars['String']>;
  naicsCode?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  sicCode?: Maybe<Scalars['String']>;
  subIndustry?: Maybe<Scalars['String']>;
};

export type ClearbitCompanyFacebookObj = {
  __typename?: 'ClearbitCompanyFacebookObj';
  handle?: Maybe<Scalars['String']>;
};

export type ClearbitCompanyGeoObj = {
  __typename?: 'ClearbitCompanyGeoObj';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stateCode?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  subPremise?: Maybe<Scalars['String']>;
};

export type ClearbitCompanyLinkedInObj = {
  __typename?: 'ClearbitCompanyLinkedInObj';
  handle?: Maybe<Scalars['String']>;
};

export type ClearbitCompanyMetricsObj = {
  __typename?: 'ClearbitCompanyMetricsObj';
  alexaGlobalRank?: Maybe<Scalars['String']>;
  alexaUsRank?: Maybe<Scalars['String']>;
  annualRevenue?: Maybe<Scalars['String']>;
  employees?: Maybe<Scalars['String']>;
  employeesRange?: Maybe<Scalars['String']>;
  estimatedAnnualRevenue?: Maybe<Scalars['String']>;
  fiscalYearEnd?: Maybe<Scalars['String']>;
  marketCap?: Maybe<Scalars['String']>;
  raised?: Maybe<Scalars['String']>;
  trafficRank?: Maybe<Scalars['String']>;
};

export type ClearbitCompanyObj = {
  __typename?: 'ClearbitCompanyObj';
  category: ClearbitCompanyCategoryObj;
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  domainAliases?: Maybe<Array<Scalars['String']>>;
  facebook: ClearbitCompanyFacebookObj;
  foundedYear?: Maybe<Scalars['Float']>;
  geo: ClearbitCompanyGeoObj;
  id: Scalars['String'];
  legalName?: Maybe<Scalars['String']>;
  linkedin: ClearbitCompanyLinkedInObj;
  location?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  metrics: ClearbitCompanyMetricsObj;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  site: ClearbitCompanySiteObj;
  tags?: Maybe<Array<Scalars['String']>>;
  tech?: Maybe<Array<Scalars['String']>>;
  techCategories?: Maybe<Array<Scalars['String']>>;
  ticker?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Scalars['String']>;
  twitter: ClearbitCompanyTwitterObj;
  type?: Maybe<Scalars['String']>;
  utcOffset?: Maybe<Scalars['Float']>;
};

export type ClearbitCompanySiteObj = {
  __typename?: 'ClearbitCompanySiteObj';
  emailAddresses?: Maybe<Array<Scalars['String']>>;
  phoneNumbers?: Maybe<Array<Scalars['String']>>;
};

export type ClearbitCompanyTwitterObj = {
  __typename?: 'ClearbitCompanyTwitterObj';
  handle?: Maybe<Scalars['String']>;
};

export type ClearbitModuleCompanyObj = {
  __typename?: 'ClearbitModuleCompanyObj';
  city?: Maybe<Scalars['String']>;
  clearbitId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  employees?: Maybe<Scalars['Float']>;
  estimatedAnnualRevenue?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  industry?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  marketCap?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  raised?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type CommentObj = {
  __typename?: 'CommentObj';
  assets: Array<UserInputAssetFilesObj>;
  author: UserObj;
  authorId: Scalars['String'];
  conversationId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  json: Scalars['String'];
  mentionedUsersIds?: Maybe<Array<Scalars['String']>>;
  organizationId: Scalars['String'];
  parentCommentId?: Maybe<Scalars['String']>;
  parentId: Scalars['String'];
  replyTo: Scalars['String'];
  saved?: Maybe<Scalars['Boolean']>;
  text: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CompanyInfoFromWebsiteObj = {
  __typename?: 'CompanyInfoFromWebsiteObj';
  brandGuidelines?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  personas?: Maybe<Array<CompanyPersonaFromWebsiteObj>>;
  productLineTags?: Maybe<Array<CompanyProductLineFromWebsiteObj>>;
};

export type CompanyObj = {
  __typename?: 'CompanyObj';
  attachments?: Maybe<AttachmentsObj>;
  battlecardScreenshots?: Maybe<Array<Screenshots>>;
  city?: Maybe<Scalars['String']>;
  clearbitId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  employees?: Maybe<Scalars['String']>;
  estimatedAnnualRevenue?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  keyPeople?: Maybe<Array<KeyPeople>>;
  launchIds?: Maybe<Array<Scalars['String']>>;
  legalName?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  marketCap?: Maybe<Scalars['String']>;
  messagingSummary?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  publicPageConfig: CompanyPublicPageConfigDto;
  raised?: Maybe<Scalars['String']>;
  rssFeed?: Maybe<Array<RssFeedUrlObj>>;
  salesforceAccountName?: Maybe<Scalars['String']>;
  salesforceCompetitorObjectName?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<TagObj>>;
  talkingPoints?: Maybe<Array<TalkingPoints>>;
  twitter?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type CompanyPersonaFromWebsiteObj = {
  __typename?: 'CompanyPersonaFromWebsiteObj';
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CompanyProductLineFromWebsiteObj = {
  __typename?: 'CompanyProductLineFromWebsiteObj';
  description?: Maybe<Scalars['String']>;
  label: Scalars['String'];
};

export type CompanyPublicPageConfigDto = {
  __typename?: 'CompanyPublicPageConfigDto';
  live: Scalars['Boolean'];
  viewsCount: Scalars['Float'];
};

export type CompanyRatingsOutput = {
  __typename?: 'CompanyRatingsOutput';
  noOfReviews?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

export type CompanyTagGroup = {
  __typename?: 'CompanyTagGroup';
  color: Scalars['String'];
  count?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isPreBuilt: Scalars['Boolean'];
  label: Scalars['String'];
  organizationId: Scalars['String'];
  type: TagTypes;
};

export type CompetitiveIntelSectionObj = {
  __typename?: 'CompetitiveIntelSectionObj';
  isCompletedCreateBattleCard: Scalars['Boolean'];
};

export type CompetitiveIntelligenceFeatureObj = {
  __typename?: 'CompetitiveIntelligenceFeatureObj';
  categoryId?: Maybe<Scalars['String']>;
  categoryName?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['Boolean']>;
  competitor?: Maybe<Scalars['Boolean']>;
  competitorBattlecardId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isAIGenerated?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
};

export type CompetitorCompanyFilterOptionObj = {
  __typename?: 'CompetitorCompanyFilterOptionObj';
  label: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type CompetitorCompanyNewsArticleObj = {
  __typename?: 'CompetitorCompanyNewsArticleObj';
  companyDomain: Scalars['String'];
  companyLogo?: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  providerName?: Maybe<Scalars['String']>;
  publishedDate: Scalars['DateTime'];
  sourceUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CompetitorNamesObj = {
  __typename?: 'CompetitorNamesObj';
  id: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ConfigureHubspotCrmIntegrationInput = {
  createIdeasAutomatically?: Maybe<Scalars['Boolean']>;
  crmObjectId: Scalars['String'];
  crmObjectPropertyId?: Maybe<Scalars['String']>;
  dealStage?: Maybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  feedbackBoardId?: Maybe<Scalars['String']>;
  owner?: Maybe<DealOwnerInput>;
  startDate: Scalars['DateTime'];
};

export type ConfigureMicrosoftDynamicsCrmIntegrationInput = {
  createIdeasAutomatically?: Maybe<Scalars['Boolean']>;
  crmCustomObjectPropertyId?: Maybe<Scalars['String']>;
  crmObjectId: Scalars['String'];
  crmObjectPropertyId: Scalars['String'];
  dealStage?: Maybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  owner?: Maybe<Array<DealOwnerInput>>;
  startDate: Scalars['DateTime'];
};

export type ConfigureSalesforceCrmIntegrationInput = {
  createIdeasAutomatically?: Maybe<Scalars['Boolean']>;
  crmCustomObjectPropertyId?: Maybe<Scalars['String']>;
  crmObjectId: Scalars['String'];
  crmObjectPropertyId: Scalars['String'];
  dealStage?: Maybe<Array<Scalars['String']>>;
  endDate: Scalars['DateTime'];
  feedbackBoardId?: Maybe<Scalars['String']>;
  owner?: Maybe<Array<DealOwnerInput>>;
  startDate: Scalars['DateTime'];
};

export type ConfigureWinLossSalesforceCrmIntegrationInput = {
  competitorFields?: Maybe<CrmObjectPropertyInput>;
  competitorObject: CrmObjectInput;
  dealNotesFields?: Maybe<Array<CrmObjectPropertyInput>>;
  dealNotesObject?: Maybe<CrmObjectInput>;
  lostReasonFields?: Maybe<Array<CrmObjectPropertyInput>>;
  lostReasonObject: CrmObjectInput;
};

export type ConfigureWinlossHubspotCrmIntegrationInput = {
  competitorFields?: Maybe<CrmObjectPropertyInput>;
  competitorObject: CrmObjectInput;
  dealNotesFields?: Maybe<Array<CrmObjectPropertyInput>>;
  dealNotesObject?: Maybe<CrmObjectInput>;
  lostReasonFields?: Maybe<Array<CrmObjectPropertyInput>>;
  lostReasonObject: CrmObjectInput;
};

export type ContextualChatDto = {
  additionalInstructions?: Maybe<Scalars['String']>;
  battleCardId?: Maybe<Scalars['String']>;
  chatType?: Maybe<ContextualChatTypes>;
  insightId?: Maybe<Scalars['String']>;
  insightsFilter?: Maybe<FilterInsightsInput>;
  personaId?: Maybe<Scalars['String']>;
  previousConversations?: Maybe<Array<PreviousConversationsDto>>;
  question: Scalars['String'];
  roadmapId?: Maybe<Scalars['String']>;
};

export enum ContextualChatTypes {
  BATTLE_CARD_ALL = 'BATTLE_CARD_ALL',
  BATTLE_CARD_INDIVIDUAL = 'BATTLE_CARD_INDIVIDUAL',
  INSIGHTS = 'INSIGHTS',
  INSIGHT_INDIVIDUAL = 'INSIGHT_INDIVIDUAL',
  PERSONA_ALL = 'PERSONA_ALL',
  PERSONA_INDIVIDUAL = 'PERSONA_INDIVIDUAL',
  ROADMAP_ALL = 'ROADMAP_ALL',
  ROADMAP_INDIVIDUAL = 'ROADMAP_INDIVIDUAL'
}

export type Cookie = {
  __typename?: 'Cookie';
  userId?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  organizationSlug?: Maybe<Scalars['String']>;
};

export type CopilotLaunchTypePreferenceObj = {
  __typename?: 'CopilotLaunchTypePreferenceObj';
  defaultLaunchTier?: Maybe<LaunchTiers>;
  launchType: LaunchTypeObj;
  templates: Array<TemplateObj>;
};

export type CopilotPreferencesObj = {
  __typename?: 'CopilotPreferencesObj';
  generatedAssets?: Maybe<Scalars['Boolean']>;
  generatedChannels?: Maybe<Scalars['Boolean']>;
  generatedTasks?: Maybe<Scalars['Boolean']>;
  lastOnBoardingStep?: Maybe<Scalars['String']>;
  preferBuildAssets?: Maybe<Scalars['Boolean']>;
  preferBuildChannels?: Maybe<Scalars['Boolean']>;
  preferBuildTasks?: Maybe<Scalars['Boolean']>;
};

export type CopyPersonaInput = {
  id: Scalars['String'];
};

export type CopysmithAiContentObj = {
  __typename?: 'CopysmithAIContentObj';
  arrayContent?: Maybe<Array<Scalars['String']>>;
  contentType?: Maybe<AiContentTypes>;
  id?: Maybe<Scalars['Float']>;
  objectContent?: Maybe<Scalars['String']>;
  stringContent?: Maybe<Scalars['String']>;
};

export type CopysmithAiFavoriteInput = {
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  templateIds?: Maybe<Array<Scalars['String']>>;
};

export type CopysmithAiFavoriteObj = {
  __typename?: 'CopysmithAIFavoriteObj';
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  templateIds?: Maybe<Array<Scalars['String']>>;
};

export type CopysmithAiPromptInput = {
  EtsyProductName?: Maybe<Scalars['String']>;
  article?: Maybe<Scalars['String']>;
  audience?: Maybe<Scalars['String']>;
  brandKeywords?: Maybe<Array<Scalars['String']>>;
  companyDescription?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyUrl?: Maybe<Scalars['String']>;
  contentTitle?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['String']>;
  cta?: Maybe<Scalars['String']>;
  delivery?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  draft?: Maybe<Scalars['String']>;
  exampleParagraph?: Maybe<Scalars['String']>;
  experience?: Maybe<Scalars['String']>;
  goal?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  inputParagraph?: Maybe<Scalars['String']>;
  inputReview?: Maybe<Scalars['String']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  leadCompanyName?: Maybe<Scalars['String']>;
  leadGoals?: Maybe<Scalars['String']>;
  leadIndustry?: Maybe<Scalars['String']>;
  leadName?: Maybe<Scalars['String']>;
  negativeKeywordArray?: Maybe<Array<Scalars['String']>>;
  plot?: Maybe<Scalars['String']>;
  point1?: Maybe<Scalars['String']>;
  point2?: Maybe<Scalars['String']>;
  point3?: Maybe<Scalars['String']>;
  productCharacteristics?: Maybe<Scalars['String']>;
  productDescription?: Maybe<Scalars['String']>;
  productKeywords?: Maybe<Array<Scalars['String']>>;
  productName?: Maybe<Scalars['String']>;
  purpose?: Maybe<Scalars['String']>;
  targetAudience?: Maybe<Scalars['String']>;
  targetKeywords?: Maybe<Scalars['String']>;
  templateType?: Maybe<CopysmithTemplateTypes>;
  title?: Maybe<Scalars['String']>;
  tone?: Maybe<CopysmithToneOptions>;
  topic?: Maybe<Scalars['String']>;
  what?: Maybe<Scalars['String']>;
  when?: Maybe<Scalars['String']>;
  where?: Maybe<Scalars['String']>;
  who?: Maybe<Scalars['String']>;
  why?: Maybe<Scalars['String']>;
  yourCompanyName?: Maybe<Scalars['String']>;
  yourIndustry?: Maybe<Scalars['String']>;
  yourName?: Maybe<Scalars['String']>;
};

export type CopysmithAiPromptObj = {
  __typename?: 'CopysmithAIPromptObj';
  description?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  placeholder?: Maybe<Scalars['String']>;
  promptType?: Maybe<CopysmithPromptTypes>;
  required?: Maybe<Scalars['Boolean']>;
};

export type CopysmithAiTemplateObj = {
  __typename?: 'CopysmithAITemplateObj';
  groupType?: Maybe<CopysmithGroupTypes>;
  id?: Maybe<Scalars['String']>;
  prompts?: Maybe<Array<CopysmithAiPromptObj>>;
  templateType?: Maybe<CopysmithTemplateTypes>;
};

export type CopywriteV2CampaignPromptInput = {
  additionalInput?: Maybe<Scalars['String']>;
  companyDescription?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyURL?: Maybe<Scalars['String']>;
  competitorIds?: Maybe<Array<Scalars['String']>>;
  insightIds?: Maybe<Array<Scalars['String']>>;
  keywords?: Maybe<Scalars['String']>;
  personaIds?: Maybe<Array<Scalars['String']>>;
  productDescription: Scalars['String'];
  productIdeaIds?: Maybe<Array<Scalars['String']>>;
  productName: Scalars['String'];
  roadmapIds?: Maybe<Array<Scalars['String']>>;
  templateTypes?: Maybe<Array<CopywriteV2TemplateType>>;
  tone?: Maybe<Scalars['String']>;
};

export type CopywriteV2ContentObj = {
  __typename?: 'CopywriteV2ContentObj';
  additionalPrompt?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  finalPrompt?: Maybe<Scalars['String']>;
  templateType: CopywriteV2TemplateType;
};

export type CopywriteV2FavoriteObj = {
  __typename?: 'CopywriteV2FavoriteObj';
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  templateIds?: Maybe<Array<Scalars['String']>>;
};

export type CopywriteV2TemplateObj = {
  __typename?: 'CopywriteV2TemplateObj';
  example: Scalars['String'];
  format: Scalars['String'];
  groupType?: Maybe<CopywriteV2GroupType>;
  guidelines: Scalars['String'];
  id: Scalars['String'];
  label: Scalars['String'];
  templateType?: Maybe<CopywriteV2TemplateType>;
  variant: Scalars['Float'];
};

export type CopywriteV2TemplatePromptInput = {
  additionalInput?: Maybe<Scalars['String']>;
  companyDescription?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyURL?: Maybe<Scalars['String']>;
  competitorIds?: Maybe<Array<Scalars['String']>>;
  insightIds?: Maybe<Array<Scalars['String']>>;
  keywords?: Maybe<Scalars['String']>;
  personaIds?: Maybe<Array<Scalars['String']>>;
  productDescription: Scalars['String'];
  productIdeaIds?: Maybe<Array<Scalars['String']>>;
  productName: Scalars['String'];
  roadmapIds?: Maybe<Array<Scalars['String']>>;
  templateType: CopywriteV2TemplateType;
  tone?: Maybe<Scalars['String']>;
};

export type CreateAiCopywritingSectionInput = {
  isCompletedMarketingOrAssetGeneration?: Maybe<Scalars['Boolean']>;
};

export type CreateAnnouncementInput = {
  destinations: Array<NotificationDestinations>;
  includeGtmTimeline?: Maybe<Scalars['Boolean']>;
  includeLaunchProgress?: Maybe<Scalars['Boolean']>;
  includeMeasurements?: Maybe<Scalars['Boolean']>;
  integrationChannel?: Maybe<Scalars['String']>;
  launchAssetsIds?: Maybe<Array<Scalars['String']>>;
  launchId: Scalars['String'];
  launchModulesIds?: Maybe<Array<Scalars['String']>>;
  message?: Maybe<Scalars['String']>;
  recipients: CreateRecipientsInput;
  repeatOn?: Maybe<Scalars['DateTime']>;
  repeatType?: Maybe<RepeatNotificationTypes>;
  sendAs?: Maybe<NotificationSendAsTypes>;
  status?: Maybe<NotificationStatus>;
  subject: Scalars['String'];
};

export type CreateAssetInput = {
  approvalStatus?: Maybe<LaunchModuleApprovalStatus>;
  approvers?: Maybe<Array<AssetApproverInput>>;
  assets?: Maybe<Array<AssetFile>>;
  brandAsset?: Maybe<Scalars['Boolean']>;
  canGenerateWithAI?: Maybe<Scalars['Boolean']>;
  launchIds?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Scalars['String']>;
  orderIndex?: Maybe<Scalars['String']>;
  tagsIds?: Maybe<Array<Scalars['String']>>;
  templateModuleId?: Maybe<Scalars['String']>;
  type: AssetTypes;
  userInput?: Maybe<Scalars['String']>;
};

export type CreateCampaignPlanningSectionInput = {
  isCompletedConfigureTemplate?: Maybe<Scalars['Boolean']>;
  isCompletedCreateFirstLaunch?: Maybe<Scalars['Boolean']>;
};

export type CreateChannelInput = {
  channelTemplateId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  launchId: Scalars['String'];
  logoSrc?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: ChannelType;
};

export type CreateChannelTemplate = {
  name: Scalars['String'];
  type: ChannelType;
};

export type CreateChannelTimeframeInput = {
  budget?: Maybe<Scalars['Float']>;
  channelId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  endDate: Scalars['Timestamp'];
  launchId: Scalars['String'];
  name: Scalars['String'];
  startDate: Scalars['Timestamp'];
};

export type CreateChecklistInput = {
  aiCopywriting?: Maybe<CreateAiCopywritingSectionInput>;
  campaignPlanning?: Maybe<CreateCampaignPlanningSectionInput>;
  competitiveIntel?: Maybe<CreateCompetitiveIntelSectionInput>;
  roadmapping?: Maybe<CreateRoadmappingSectionInput>;
  selectedFeatures?: Maybe<Array<ChecklistFeature>>;
  voiceOfCustomer?: Maybe<CreateVoiceOfCustomerSectionInput>;
  winloss?: Maybe<CreateWinLossAnalysisSectionInput>;
  workspaceConfig?: Maybe<CreateWorkspaceConfigSectionInput>;
};

export type CreateCommentInput = {
  assets?: Maybe<Array<AssetsFile>>;
  conversationId?: Maybe<Scalars['String']>;
  json: Scalars['String'];
  mentionedUsersIds?: Maybe<Array<Scalars['String']>>;
  parentCommentId?: Maybe<Scalars['String']>;
  parentId: Scalars['String'];
  parentType: CommentParentType;
  text: Scalars['String'];
};

export type CreateCompetitiveIntelSectionInput = {
  isCompletedCreateBattleCard?: Maybe<Scalars['Boolean']>;
};

export type CreateCompetitiveIntelligenceFeaturesInput = {
  categoryId?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['Boolean']>;
  competitor?: Maybe<Scalars['Boolean']>;
  competitorBattlecardId: Scalars['String'];
  competitorBattlecardUrl?: Maybe<Scalars['String']>;
  isAIGenerated?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type CreateCompletionInput = {
  text: Scalars['String'];
  type: CompletionType;
};

export type CreateCopywriteV2FavoriteInput = {
  organizationId?: Maybe<Scalars['String']>;
  templateIds?: Maybe<Array<Scalars['String']>>;
};

export type CreateDefaultChannelsInput = {
  budget?: Maybe<Scalars['Float']>;
  launchId: Scalars['String'];
  rejectedChannels?: Maybe<Array<Scalars['String']>>;
  strategicApproach?: Maybe<StrategicApproach>;
};

export type CreateDefaultLaunchAssetsInput = {
  launchId: Scalars['String'];
  rejectedAssets?: Maybe<Array<Scalars['String']>>;
};

export type CreateDefaultLaunchTasksInput = {
  launchId: Scalars['String'];
  rejectedTasks?: Maybe<Array<Scalars['String']>>;
};

export type CreateDemoOrganizationInput = {
  email: Scalars['String'];
  name: Scalars['String'];
};

export type CreateExportBattlecardsConfigurationInput = {
  crm?: Maybe<CrmOptions>;
};

export type CreateFeatureTableCategoryInput = {
  competitorBattlecardId?: Maybe<Scalars['String']>;
  competitorBattlecardUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateFeedbackBoardInput = {
  heading?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notifyingUserIds?: Maybe<Array<Scalars['String']>>;
  productLineTagId: Scalars['String'];
  sendNotification?: Maybe<Scalars['Boolean']>;
  subHeading?: Maybe<Scalars['String']>;
};

export type CreateFeedbackCommentInput = {
  internal?: Maybe<Scalars['Boolean']>;
  notifySubscribers?: Maybe<Scalars['Boolean']>;
  postId: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  subscribeToUpdates?: Maybe<Scalars['Boolean']>;
  text: Scalars['String'];
};

export type CreateFeedbackCustomColumnInput = {
  boardId: Scalars['String'];
  name: Scalars['String'];
  type: FeedbackCustomColumnType;
};

export type CreateFeedbackPostAsAdminInput = {
  boardId: Scalars['String'];
  dealIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  importance?: Maybe<FeedbackPostImportance>;
  productBoardItemsIds?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<FeedbackPostStatus>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

export type CreateFeedbackPostInput = {
  dealIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  importance?: Maybe<FeedbackPostImportance>;
  productBoardItemsIds?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<FeedbackPostStatus>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

export type CreateFeedbackPostsAsAdminInput = {
  boardId: Scalars['String'];
  posts: Array<CreateFeedbackPostInput>;
};

export type CreateFeedbackPostsViewFilterInput = {
  accountsFilter?: Maybe<CdpAccountItemsFilterInput>;
  assigneeIds?: Maybe<Array<Scalars['String']>>;
  boardId?: Maybe<Scalars['String']>;
  isAIGenerated?: Maybe<Scalars['Boolean']>;
  isInternal?: Maybe<Scalars['Boolean']>;
  maxVotes?: Maybe<Scalars['Float']>;
  minVotes?: Maybe<Scalars['Float']>;
  productBoardItemIds?: Maybe<Array<Scalars['String']>>;
  query?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<FeedbackPostStatus>>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};

export type CreateFeedbackPostsViewInput = {
  filter?: Maybe<CreateFeedbackPostsViewFilterInput>;
  name: Scalars['String'];
  sort?: Maybe<CreateFeedbackPostsViewSortInput>;
  view?: Maybe<FeedbackBoardView>;
  visibleProperties?: Maybe<Array<Scalars['String']>>;
};

export type CreateFeedbackPostsViewSortInput = {
  sort: SortOrder;
  sortBy: FeedbackPostsSortBy;
};

export type CreateFeedbackUserInput = {
  avatarSrc?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
};

export type CreateGtmTimelineInput = {
  channelTemplates?: Maybe<Array<CreateChannelTemplate>>;
  templateMilestones?: Maybe<Array<CreateTemplateMilestone>>;
};

export type CreateInsightInput = {
  accountId?: Maybe<Scalars['String']>;
  assigneeId?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  competitorIds?: Maybe<Array<Scalars['String']>>;
  contactId?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  feedbackPostIds?: Maybe<Array<Scalars['String']>>;
  launchIds?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Scalars['String']>;
  personasIds?: Maybe<Array<Scalars['String']>>;
  productBoardItemsIds?: Maybe<Array<Scalars['String']>>;
  registeredOn?: Maybe<Scalars['DateTime']>;
  tags?: Maybe<Array<Scalars['String']>>;
  taskIds?: Maybe<Array<Scalars['String']>>;
  user?: Maybe<Scalars['String']>;
};

export type CreateInsightIntegrationInput = {
  apiKey: Scalars['String'];
  apiSecret: Scalars['String'];
  integrationSource: InsightsIntegrations;
};

export type CreateInsightsViewFilterInput = {
  accountIds?: Maybe<Array<Scalars['String']>>;
  assigneeIds?: Maybe<Array<Scalars['String']>>;
  competitorIds?: Maybe<Array<Scalars['String']>>;
  contactIds?: Maybe<Array<Scalars['String']>>;
  conversationTypes?: Maybe<Array<Scalars['String']>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtGte?: Maybe<Scalars['DateTime']>;
  endRegisteredOn?: Maybe<Scalars['DateTime']>;
  feedbackPostIds?: Maybe<Array<Scalars['String']>>;
  launchIds?: Maybe<Array<Scalars['String']>>;
  personaIds?: Maybe<Array<Scalars['String']>>;
  productBoardItemIds?: Maybe<Array<Scalars['String']>>;
  query?: Maybe<Scalars['String']>;
  source?: Maybe<Array<InsightSourceFilter>>;
  startRegisteredOn?: Maybe<Scalars['DateTime']>;
  summaryUpdatedAtGte?: Maybe<Scalars['DateTime']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  tagsUpdatedAtGte?: Maybe<Scalars['DateTime']>;
  taskIds?: Maybe<Array<Scalars['String']>>;
};

export type CreateInsightsViewInput = {
  filter?: Maybe<CreateInsightsViewFilterInput>;
  name: Scalars['String'];
  sort?: Maybe<CreateInsightsViewSortInput>;
  visibleProperties?: Maybe<Array<Scalars['String']>>;
};

export type CreateInsightsViewSortInput = {
  sort: SortOrder;
  sortBy: InsightsSortBy;
};

export type CreateIntegrationInput = {
  apiKey?: Maybe<Scalars['String']>;
  productName: TasksIntegrationProductName;
  refreshToken?: Maybe<Scalars['String']>;
};

export type CreateKpiInput = {
  currentValue?: Maybe<Scalars['Float']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  format?: Maybe<KpiMetrics>;
  launchId?: Maybe<Scalars['String']>;
  objectiveId?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  qualitativeStatus?: Maybe<OkrQualitativeStatus>;
  targetValue?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
};

export type CreateLaunchConnectionsInput = {
  competitorIds?: Maybe<Array<Scalars['String']>>;
  feedbackPostIds?: Maybe<Array<Scalars['String']>>;
  insightIds?: Maybe<Array<Scalars['String']>>;
  personasIds?: Maybe<Array<Scalars['String']>>;
  productBoardItemIds?: Maybe<Array<Scalars['String']>>;
  productIntegrationTaskIds?: Maybe<Array<Scalars['String']>>;
};

export type CreateLaunchInput = {
  budget?: Maybe<Scalars['Float']>;
  connections?: Maybe<CreateLaunchConnectionsInput>;
  description?: Maybe<Scalars['String']>;
  launchDate: Scalars['DateTime'];
  launchTier: LaunchTiers;
  launchTypeId: Scalars['String'];
  name: Scalars['String'];
  productIntegrationSubTaskIds?: Maybe<Array<Scalars['String']>>;
  productIntegrationTaskIds?: Maybe<Array<Scalars['String']>>;
  tagsIds?: Maybe<Array<Scalars['String']>>;
  templateId: Scalars['String'];
  templateModuleIds?: Maybe<Array<Scalars['String']>>;
};

export type CreateLaunchModuleInput = {
  approvalStatus?: Maybe<LaunchModuleApprovalStatus>;
  canGenerateWithAI?: Maybe<Scalars['Boolean']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  editor?: Maybe<EditorsTypes>;
  gptPrompt?: Maybe<GptPromptsType>;
  hint?: Maybe<Scalars['String']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  launchId: Scalars['String'];
  launchSectionId: Scalars['String'];
  lockingDetails?: Maybe<LockingDetailsInput>;
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  tagsIds?: Maybe<Array<Scalars['String']>>;
  templateModuleId?: Maybe<Scalars['String']>;
  userInput?: Maybe<UserInput>;
};

export type CreateLaunchTypeInput = {
  name: Scalars['String'];
};

export type CreateMeasurementIntegrationMetricInput = {
  eventName: Scalars['String'];
  filters?: Maybe<Array<MeasurementIntegrationMetricFilterInput>>;
  integrationType: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type CreateMessageGroupInput = {
  emails?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  nonUserIds?: Maybe<Array<Scalars['String']>>;
  userIds?: Maybe<Array<Scalars['String']>>;
};

export type CreateMilestoneInput = {
  description?: Maybe<Scalars['String']>;
  endDate: Scalars['Timestamp'];
  launchId: Scalars['String'];
  name: Scalars['String'];
  startDate: Scalars['Timestamp'];
  type: MilestoneType;
};

export type CreateNewUserInOrganizationInput = {
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  role: UserRolesInOrganizationTypes;
  userId?: Maybe<Scalars['String']>;
};

export type CreateOrRemoveLaunchSectionInput = {
  launchId: Scalars['String'];
  sectionName: Scalars['String'];
};

export type CreateOrganizationInput = {
  allowUsersFromSameDomain?: Maybe<Scalars['Boolean']>;
  companyType?: Maybe<OrganizationTypeOfCompany>;
  launchesPerYear?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationEmailDomain?: Maybe<Scalars['String']>;
  origin?: Maybe<OrganizationOrigins>;
  peopleRange?: Maybe<Scalars['String']>;
  users?: Maybe<Array<CreateUserInOrganizationInput>>;
};

export type CreateOrganizationMultipleTemplateInput = {
  files: Array<CreateOrganizationUploadedTemplateInput>;
};

export type CreateOrganizationUploadedTemplateInput = {
  fileType: Scalars['String'];
  name: Scalars['String'];
  path: Scalars['String'];
};

export type CreatePersonaDemographicsCategoryInput = {
  name?: Maybe<Scalars['String']>;
  personaId: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type CreatePersonaInput = {
  age?: Maybe<Array<Scalars['Float']>>;
  avatar?: Maybe<Scalars['String']>;
  launchesIds?: Maybe<Array<Scalars['String']>>;
  messagingLibraryIds?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Scalars['String']>;
  occupation?: Maybe<Scalars['String']>;
  primary?: Maybe<Scalars['Boolean']>;
  tagsIds?: Maybe<Array<Scalars['String']>>;
};

export type CreatePersonaNoteInput = {
  personaId: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type CreateProductBoardCustomColumnInput = {
  name: Scalars['String'];
  type: ProductBoardCustomColumnType;
};

export type CreateProductBoardFactorInput = {
  name: Scalars['String'];
  scale: ProductBoardFactorScales;
  weight: Scalars['Int'];
};

export type CreateProductBoardItemInput = {
  assigneeId?: Maybe<Scalars['String']>;
  competitorIds?: Maybe<Array<Scalars['String']>>;
  dealIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  feedbackPostIds?: Maybe<Array<Scalars['String']>>;
  insightIds?: Maybe<Array<Scalars['String']>>;
  launchIds?: Maybe<Array<Scalars['String']>>;
  parentItemId?: Maybe<Scalars['String']>;
  personaIds?: Maybe<Array<Scalars['String']>>;
  priority?: Maybe<RoadmapItemPriority>;
  releaseId?: Maybe<Scalars['String']>;
  roadmapId: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  statusId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

export type CreateProductBoardItemsViewFilterInput = {
  assigneeIds?: Maybe<Array<Scalars['String']>>;
  competitorIds?: Maybe<Array<Scalars['String']>>;
  endDateGte?: Maybe<Scalars['DateTime']>;
  endDateLte?: Maybe<Scalars['DateTime']>;
  feedbackPostIds?: Maybe<Array<Scalars['String']>>;
  insightIds?: Maybe<Array<Scalars['String']>>;
  launchIds?: Maybe<Array<Scalars['String']>>;
  parentItemId?: Maybe<Scalars['String']>;
  personaIds?: Maybe<Array<Scalars['String']>>;
  productLineTagIds?: Maybe<Array<Scalars['String']>>;
  query?: Maybe<Scalars['String']>;
  releaseIds?: Maybe<Array<Scalars['String']>>;
  roadmapIds?: Maybe<Array<Scalars['String']>>;
  statusIds?: Maybe<Array<Scalars['String']>>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};

export type CreateProductBoardItemsViewInput = {
  filter?: Maybe<CreateProductBoardItemsViewFilterInput>;
  groupBy?: Maybe<ProductBoardItemsGroupBy>;
  name: Scalars['String'];
  orderIndexes?: Maybe<Array<ProductBoardItemsViewItemOrderIndexInput>>;
  sort?: Maybe<ProductBoardItemsSortInput>;
  view?: Maybe<ProductBoardView>;
  visibleProperties: Array<Scalars['String']>;
};

export type CreateProductBoardReleaseInput = {
  description?: Maybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  itemIds?: Maybe<Array<Scalars['String']>>;
  launchIds?: Maybe<Array<Scalars['String']>>;
  milestoneIds?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  ownerId?: Maybe<Scalars['String']>;
  productLineTagId: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
};

export type CreateProductBoardRoadmapInput = {
  name: Scalars['String'];
  productLineTagId: Scalars['String'];
};

export type CreateProductBoardStatusInput = {
  description: Scalars['String'];
  iconColor: Scalars['String'];
  name: Scalars['String'];
};

export type CreatePublicPageInput = {
  coverImage?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  headerDescription?: Maybe<Scalars['String']>;
  isProductIdeasLive?: Maybe<Scalars['Boolean']>;
  isReleaseNotesLive?: Maybe<Scalars['Boolean']>;
  live?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type CreateRecipientsInput = {
  emails?: Maybe<Array<Scalars['String']>>;
  messageGroupIds?: Maybe<Array<Scalars['String']>>;
  nonUserIds?: Maybe<Array<Scalars['String']>>;
  userIds?: Maybe<Array<Scalars['String']>>;
};

export type CreateReleaseNoteInput = {
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  image?: Maybe<Scalars['String']>;
  internal?: Maybe<Scalars['Boolean']>;
  launchId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  tagsIds?: Maybe<Array<Scalars['String']>>;
};

export type CreateReleaseNotesSubscriberInput = {
  email: Scalars['String'];
  feedbackPostId?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
};

export type CreateRetroInput = {
  emailBody?: Maybe<Scalars['String']>;
  emailSubject?: Maybe<Scalars['String']>;
  isAnonymous?: Maybe<Scalars['Boolean']>;
  launchId?: Maybe<Scalars['String']>;
  recipients: CreateRecipientsInput;
};

export type CreateRoadmappingSectionInput = {
  isCompletedConnectCRM?: Maybe<Scalars['Boolean']>;
  isCompletedConnectTasksIntegration?: Maybe<Scalars['Boolean']>;
  isCompletedCreateRoadmapItem?: Maybe<Scalars['Boolean']>;
  isCompletedImportRoadmapData?: Maybe<Scalars['Boolean']>;
};

export type CreateSectionInput = {
  name: Scalars['String'];
  templateModuleIds: Array<Scalars['String']>;
};

export type CreateSurveyInput = {
  emailBody?: Maybe<Scalars['String']>;
  emailSignature?: Maybe<Scalars['String']>;
  inputs?: Maybe<Array<CreateSurveyInputObj>>;
  name: Scalars['String'];
  surveyType?: Maybe<SurveyTypes>;
};

export type CreateSurveyInputObj = {
  key: Scalars['String'];
  listValues?: Maybe<Array<Scalars['String']>>;
  textValue?: Maybe<Scalars['String']>;
};

export type CreateSurveyRecipientData = {
  email: Scalars['String'];
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
};

export type CreateSurveyRecipientsInput = {
  recipients?: Maybe<Array<CreateSurveyRecipientData>>;
  surveyId: Scalars['String'];
};

export type CreateTagInput = {
  color?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  type: TagTypes;
};

export type CreateTaskInput = {
  assets?: Maybe<Array<AssetFile>>;
  assigneeId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  externalSubTaskId?: Maybe<Scalars['String']>;
  externalTaskId?: Maybe<Scalars['String']>;
  launchId?: Maybe<Scalars['String']>;
  launchModuleId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<TaskStatusTypes>;
  tagsIds?: Maybe<Array<Scalars['String']>>;
  templateModuleId?: Maybe<Scalars['String']>;
  type?: Maybe<TaskTypes>;
};

export type CreateTemplateFromLaunchInput = {
  description?: Maybe<Scalars['String']>;
  includeModules: Scalars['Boolean'];
  includeNonModules: Scalars['Boolean'];
  launchId: Scalars['String'];
  templateName: Scalars['String'];
};

export type CreateTemplateInput = {
  createdBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  launchTier?: Maybe<LaunchTiers>;
  launchTypeId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  personaIds?: Maybe<Array<Scalars['String']>>;
  phaseIds?: Maybe<Array<Scalars['String']>>;
  templateGtmTimeline?: Maybe<CreateGtmTimelineInput>;
  templateOkrs?: Maybe<Array<CreateTemplateOkr>>;
  templateSections?: Maybe<Array<CreateSectionInput>>;
  templateTasks?: Maybe<Array<CreateTemplateTask>>;
  type?: Maybe<Scalars['String']>;
};

export type CreateTemplateKpi = {
  currentValue?: Maybe<Scalars['Float']>;
  format?: Maybe<KpiMetrics>;
  name?: Maybe<Scalars['String']>;
  targetValue?: Maybe<Scalars['Float']>;
};

export type CreateTemplateMilestone = {
  defaultEndDateDuration?: Maybe<Scalars['Float']>;
  defaultStartDateDuration?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  type: MilestoneType;
};

export type CreateTemplateModuleInput = {
  editor: EditorsTypes;
  name: Scalars['String'];
  templateModuleTasks?: Maybe<Array<CreateTemplateTask>>;
  type?: Maybe<TemplateModulesTypes>;
  userInput?: Maybe<UserInput>;
};

export type CreateTemplateOkr = {
  templateKpis?: Maybe<Array<CreateTemplateKpi>>;
  title?: Maybe<Scalars['String']>;
};

export type CreateTemplateTask = {
  defaultDueDateDuration?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<TaskTypes>;
};

export type CreateTestimonialInput = {
  company?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  insightSource?: Maybe<InsightSource>;
  name?: Maybe<Scalars['String']>;
  quote?: Maybe<Scalars['String']>;
  registeredOn?: Maybe<Scalars['DateTime']>;
  status?: Maybe<TestimonialStatus>;
  tags?: Maybe<Array<Scalars['String']>>;
};

export type CreateTestimonialsFromInsightsInput = {
  testimonials: Array<CreateTestimonialInput>;
};

export type CreateUserInOrganizationInput = {
  role: UserRolesInOrganizationTypes;
  userId: Scalars['String'];
};

export type CreateUserInput = {
  appsumoInvoiceUuid?: Maybe<Scalars['String']>;
  appsumoPlanId?: Maybe<Scalars['String']>;
  appsumoUuid?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  isEmailVerified?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notificationPreferences?: Maybe<NotificationPreferencesInput>;
  password?: Maybe<Scalars['String']>;
  primaryOnboardingGoal?: Maybe<OnboardingGoal>;
  profileImage?: Maybe<Scalars['String']>;
};

export type CreateVoiceOfCustomerSectionInput = {
  isClickedConfigurePublicBoard?: Maybe<Scalars['Boolean']>;
  isClickedConnectIntegration?: Maybe<Scalars['Boolean']>;
};

export type CreateWinLossAnalysisSectionInput = {
  isCompletedWinLossSync?: Maybe<Scalars['Boolean']>;
};

export type CreateWorkspaceConfigSectionInput = {
  isWorkspaceConfigured?: Maybe<Scalars['Boolean']>;
};

export type CrmIntegrationCreatedSubscriptionInput = {
  /** Currently, each organization can only have one type of each CRM, and that CRM type can be used as an index for integration. */
  crm: CrmOptions;
};

export type CrmIntegrationExportBattlecardsConfigObj = {
  __typename?: 'CrmIntegrationExportBattlecardsConfigObj';
  battlecardIds?: Maybe<Array<Scalars['String']>>;
  objectName?: Maybe<Scalars['String']>;
};

export type CrmIntegrationFilterObj = {
  __typename?: 'CrmIntegrationFilterObj';
  dealStage?: Maybe<Array<Scalars['String']>>;
  owner?: Maybe<Array<DealOwnerObj>>;
};

export type CrmIntegrationInput = {
  /** Currently, each organization can only have one type of each CRM, and that CRM type can be used as an index for integration. */
  crm: CrmOptions;
};

export type CrmIntegrationOAuthUrlInput = {
  crm: CrmOptions;
  customerUrl?: Maybe<Scalars['String']>;
};

export type CrmIntegrationObj = {
  __typename?: 'CrmIntegrationObj';
  crm: CrmOptions;
  exportBattlecards?: Maybe<CrmIntegrationExportBattlecardsConfigObj>;
  id: Scalars['String'];
  organizationId: Scalars['String'];
  productGaps?: Maybe<CrmIntegrationProductGapsConfigObj>;
  status: CrmIntegrationStatuses;
  winLoss?: Maybe<CrmIntegrationWinLossConfigObj>;
};

export type CrmIntegrationObjectObj = {
  __typename?: 'CrmIntegrationObjectObj';
  id: Scalars['String'];
  title: Scalars['String'];
  type?: Maybe<CrmObjectType>;
};

export type CrmIntegrationObjectPropertiesInput = {
  crm: CrmOptions;
  objectName: Scalars['String'];
  objectType: CrmObjectType;
};

export type CrmIntegrationObjectPropertyObj = {
  __typename?: 'CrmIntegrationObjectPropertyObj';
  id: Scalars['String'];
  title: Scalars['String'];
};

export type CrmIntegrationObjectsFilterInput = {
  crm: CrmOptions;
  search?: Maybe<Scalars['String']>;
  terms?: Maybe<Array<Scalars['String']>>;
};

export type CrmIntegrationProductGapsConfigObj = {
  __typename?: 'CrmIntegrationProductGapsConfigObj';
  createIdeasAutomatically?: Maybe<Scalars['Boolean']>;
  crmCustomObjectProperty?: Maybe<CrmIntegrationObjectPropertyObj>;
  crmObject?: Maybe<CrmIntegrationObjectObj>;
  crmObjectProperty?: Maybe<CrmIntegrationObjectPropertyObj>;
  endDate?: Maybe<Scalars['DateTime']>;
  filters?: Maybe<CrmIntegrationFilterObj>;
  lastCronRunOn?: Maybe<Scalars['DateTime']>;
  objectScope?: Maybe<CrmObjectType>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type CrmIntegrationWinLossConfigObj = {
  __typename?: 'CrmIntegrationWinLossConfigObj';
  competitorField?: Maybe<CrmIntegrationObjectPropertyObj>;
  competitorObject?: Maybe<CrmIntegrationObjectObj>;
  dealNotesFields?: Maybe<Array<CrmIntegrationObjectPropertyObj>>;
  dealNotesObject?: Maybe<CrmIntegrationObjectObj>;
  lostReasonFields?: Maybe<Array<CrmIntegrationObjectPropertyObj>>;
  lostReasonObject?: Maybe<CrmIntegrationObjectObj>;
};

export type CrmObjectInput = {
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<CrmObjectType>;
};

export type CrmObjectPropertyInput = {
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum CsvUploadType {
  FEEDBACK_POST = 'FEEDBACK_POST',
  INSIGHT = 'INSIGHT',
  ROADMAP_ITEM = 'ROADMAP_ITEM',
  TASK = 'TASK'
}

export type CursorPaginationInput = {
  cursor?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};

export type CustomFieldSortInput = {
  customFieldId: Scalars['String'];
  order: SortOrder;
};

export type CustomFieldSortObj = {
  __typename?: 'CustomFieldSortObj';
  customFieldId: Scalars['ID'];
  order: SortOrder;
};

export type CustomMessagingInput = {
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type CustomMessagingObj = {
  __typename?: 'CustomMessagingObj';
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type CustomProgressInput = {
  assetsApproval?: Maybe<Scalars['Float']>;
  productProgress?: Maybe<Scalars['Float']>;
  tasksProgress?: Maybe<Scalars['Float']>;
};

export type CustomProgressObj = {
  __typename?: 'CustomProgressObj';
  assetsApproval?: Maybe<Scalars['Float']>;
  productProgress?: Maybe<Scalars['Float']>;
  tasksProgress?: Maybe<Scalars['Float']>;
};

export type DateRangeInput = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};


export type DealCompanyFilterOptionObj = {
  __typename?: 'DealCompanyFilterOptionObj';
  label: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type DealCompanyObj = {
  __typename?: 'DealCompanyObj';
  id?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type DealFilterOptionObj = {
  __typename?: 'DealFilterOptionObj';
  amount?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  value: Scalars['String'];
};

export type DealFilterOptionsObj = {
  __typename?: 'DealFilterOptionsObj';
  companyOptions: Array<DealCompanyFilterOptionObj>;
  ownerOptions: Array<FilterOptionObj>;
  sources: Array<CrmOptions>;
  stages: Array<Scalars['String']>;
};

export type DealNotesObj = {
  __typename?: 'DealNotesObj';
  closeDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isClosed?: Maybe<Scalars['Boolean']>;
  isWon?: Maybe<Scalars['Boolean']>;
  lostNotes?: Maybe<Scalars['String']>;
  lostReason?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type DealNotesSecObj = {
  __typename?: 'DealNotesSecObj';
  deals: Array<DealObj>;
  lostReason?: Maybe<Scalars['String']>;
};

export type DealObj = {
  __typename?: 'DealObj';
  amount?: Maybe<Scalars['String']>;
  closeDate?: Maybe<Scalars['DateTime']>;
  color?: Maybe<Scalars['String']>;
  company?: Maybe<DealCompanyObj>;
  crm?: Maybe<CrmOptions>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<DealOwnerObj>;
  stage?: Maybe<Scalars['String']>;
};

export type DealOwnerInput = {
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type DealOwnerObj = {
  __typename?: 'DealOwnerObj';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum DealsSortBy {
  DATE = 'DATE',
  NAME = 'NAME',
  REVENUE = 'REVENUE'
}

export type DefaultApproversObj = {
  __typename?: 'DefaultApproversObj';
  required: Scalars['Boolean'];
  userDetails?: Maybe<UserObj>;
  userId: Scalars['String'];
};

export type DeleteChannelInput = {
  id: Scalars['String'];
  launchId: Scalars['String'];
};

export type DeleteChannelTimeframeInput = {
  channelId: Scalars['String'];
  id: Scalars['String'];
  launchId: Scalars['String'];
};

export type DeleteCrmIntegrationInput = {
  /** Currently, each organization can only have one type of each CRM, and that CRM type can be used as an index for integration. */
  crm: CrmOptions;
  isDeleteIntegrationData?: Maybe<Scalars['Boolean']>;
};

export type DeleteMilestoneInput = {
  id: Scalars['String'];
  launchId: Scalars['String'];
};

export type DeletePersonaDemographicsCategoryInput = {
  id: Scalars['String'];
  personaId: Scalars['String'];
};

export type DeletePersonaInput = {
  id: Scalars['String'];
};

export type DeletePersonaNoteInput = {
  id: Scalars['String'];
  personaId: Scalars['String'];
};

export type DeleteResponse = {
  __typename?: 'DeleteResponse';
  id: Scalars['String'];
};

export type DeleteSampleDataInput = {
  entities: Array<SampleDataEntities>;
};

export type DeleteTagFromTasksInput = {
  tagId: Scalars['String'];
  tasksIds: Array<Scalars['String']>;
};

export type DeleteTagInput = {
  id: Scalars['String'];
};

export type DeleteTagsFromEntitiesInput = {
  entitiesIds: Array<Scalars['String']>;
  tagsIds: Array<Scalars['String']>;
};

export type DeleteTaskInput = {
  id: Scalars['String'];
};

export type DeleteTasksInput = {
  ids: Array<Scalars['String']>;
};

export type DisplayMessageGroupUserObj = {
  __typename?: 'DisplayMessageGroupUserObj';
  id: Scalars['String'];
  label: Scalars['String'];
  avatarColor: Scalars['String'];
};

export enum DisplayedBanner {
  ASSETS = 'ASSETS',
  COMPETITORS = 'COMPETITORS',
  IDEAS = 'IDEAS',
  INSIGHTS = 'INSIGHTS',
  LAUNCHES = 'LAUNCHES',
  OKRS = 'OKRS',
  PERSONAS = 'PERSONAS',
  RELEASE_NOTES = 'RELEASE_NOTES',
  ROADMAP = 'ROADMAP',
  TASKS = 'TASKS'
}

export type DisplayedBannersObj = {
  __typename?: 'DisplayedBannersObj';
  assets: Scalars['Boolean'];
  competitors: Scalars['Boolean'];
  ideas: Scalars['Boolean'];
  insights: Scalars['Boolean'];
  launches: Scalars['Boolean'];
  okrs: Scalars['Boolean'];
  personas: Scalars['Boolean'];
  releaseNotes: Scalars['Boolean'];
  roadmap: Scalars['Boolean'];
  tasks: Scalars['Boolean'];
};

export type DragAssetInput = {
  after?: Maybe<Scalars['String']>;
  assetId: Scalars['String'];
  before?: Maybe<Scalars['String']>;
};

export type DragInput = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};

export type DuplicateLaunchInput = {
  launchDate: Scalars['DateTime'];
  launchId: Scalars['String'];
  name: Scalars['String'];
  shiftDates?: Maybe<Scalars['Boolean']>;
};

export type DuplicateObjectiveInput = {
  assignee?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  kpis?: Maybe<Array<CreateKpiInput>>;
  launchId?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  roadmapId?: Maybe<Scalars['String']>;
  tagsIds?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<OkrType>;
};

export enum EditorsTypes {
  ASSETS_EDITOR = 'ASSETS_EDITOR',
  BUDGET_EDITOR = 'BUDGET_EDITOR',
  COPY_ASSETS_EDITOR = 'COPY_ASSETS_EDITOR',
  FEATURES_EDITOR = 'FEATURES_EDITOR',
  KPI_EDITOR = 'KPI_EDITOR',
  LAUNCHTEAM_EDITOR = 'LAUNCHTEAM_EDITOR',
  POSITIONING_EDITOR = 'POSITIONING_EDITOR',
  POSITIONING_EDITOR_NEW = 'POSITIONING_EDITOR_NEW',
  TAGS_EDITOR = 'TAGS_EDITOR',
  TARGET_AUDIENCE_EDITOR = 'TARGET_AUDIENCE_EDITOR',
  TARGET_AUDIENCE_EDITOR_NEW = 'TARGET_AUDIENCE_EDITOR_NEW',
  WYSIWYG_EDITOR = 'WYSIWYG_EDITOR'
}

export enum ExportBattlecardsConfigurationStatus {
  CONFIGURATION_ERROR = 'CONFIGURATION_ERROR',
  CONFIGURED = 'CONFIGURED',
  NOT_CONFIGURED = 'NOT_CONFIGURED'
}

export type EmployeesCountHistory = {
  count: Scalars['String'];
  fetchedAt: Scalars['DateTime'];
};

export type ExportBattlecardsConfigurationObj = {
  __typename?: 'ExportBattlecardsConfigurationObj';
  crm: CrmOptions;
  status: ExportBattlecardsConfigurationStatus;
};

export type ExportBattlecardsInput = {
  battlecardIds: Array<Scalars['String']>;
  crm: CrmOptions;
};

export type ExportRoadmapTasksInput = {
  integrationProjectId: Scalars['String'];
  roadmapItemId: Scalars['String'];
  tasks: Array<ExportRoadmapTasksInputTask>;
};

export type ExportRoadmapTasksInputTask = {
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  status: TaskStatusTypes;
  tagIds?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<JiraIssueType>;
};

export type ExportTasksToIntegrationInput = {
  integrationName: TasksIntegrationProductName;
  integrationProjectId: Scalars['String'];
  subtaskIds: Array<Scalars['String']>;
  taskIds: Array<Scalars['String']>;
};

export type ExternalPageReleaseNotesSettings = {
  __typename?: 'ExternalPageReleaseNotesSettings';
  description: Scalars['String'];
  indexInSearchEngines: Scalars['Boolean'];
  live: Scalars['Boolean'];
  title: Scalars['String'];
};

export type ExternalPageSettings = {
  __typename?: 'ExternalPageSettings';
  accentColor: Scalars['String'];
  backgroundColor: Scalars['String'];
  backgroundImage?: Maybe<Scalars['String']>;
  dismissedWantToPublish: Scalars['Boolean'];
  domain?: Maybe<Scalars['String']>;
  font: Scalars['String'];
  isVerified?: Maybe<Scalars['Boolean']>;
  live: Scalars['Boolean'];
  releaseNotesSettings: ExternalPageReleaseNotesSettings;
  textColor: Scalars['String'];
  txtKey?: Maybe<Scalars['String']>;
};

export type ExternalProductIdeaBoardSettingsObj = {
  __typename?: 'ExternalProductIdeaBoardSettingsObj';
  boardId: Scalars['String'];
  emailDomain?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  internal?: Maybe<Scalars['Boolean']>;
  isAccountRestricted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  passwordRequired: Scalars['Boolean'];
};

export type ExternalPublicPageObj = {
  __typename?: 'ExternalPublicPageObj';
  coverImage?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  headerDescription?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isProductIdeasLive: Scalars['Boolean'];
  isReleaseNotesLive: Scalars['Boolean'];
  isVerified: Scalars['Boolean'];
  live: Scalars['Boolean'];
  name: Scalars['String'];
  productIdeaBoardSettings?: Maybe<Array<ExternalProductIdeaBoardSettingsObj>>;
  releaseNotesFilters?: Maybe<ExternalReleaseNotesFiltersObj>;
  styleSettings?: Maybe<StyleSettingsObj>;
};

export type ExternalReleaseNotesFiltersObj = {
  __typename?: 'ExternalReleaseNotesFiltersObj';
  internal?: Maybe<Scalars['Boolean']>;
  live?: Maybe<Scalars['Boolean']>;
};

export enum FeatureTableGenerationStatus {
  DONE = 'DONE',
  ERROR = 'ERROR',
  GENERATING = 'GENERATING',
  NOT_STARTED = 'NOT_STARTED'
}

export type FeatureTableCategoryInput = {
  competitorBattlecardId?: Maybe<Scalars['String']>;
};

export type FeatureTableCategoryObj = {
  __typename?: 'FeatureTableCategoryObj';
  competitorBattlecardId?: Maybe<Scalars['String']>;
  competitorBattlecardUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type FeatureTableInput = {
  competitorBattlecardId: Scalars['String'];
};

export type FeatureTableObj = {
  __typename?: 'FeatureTableObj';
  competitorBattlecardId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  status: FeatureTableGenerationStatus;
};

export type FeedbackBoardDto = {
  __typename?: 'FeedbackBoardDto';
  createdAt: Scalars['Timestamp'];
  customColumns: Array<FeedbackCustomColumnDto>;
  emailDomain?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  internal: Scalars['Boolean'];
  name: Scalars['String'];
  notifyingUserIds: Array<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  postsCount: Scalars['Int'];
  productLineTag?: Maybe<TagObj>;
  sendNotification: Scalars['Boolean'];
  subHeading?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Timestamp'];
};

export enum FeedbackBoardView {
  KANBAN = 'KANBAN',
  LIST = 'LIST'
}

export type FeedbackBoardsFilterInput = {
  productLineTagId?: Maybe<Scalars['String']>;
};

export type FeedbackBoardsSortInput = {
  createdAt?: Maybe<FieldSortInput>;
  name?: Maybe<FieldSortInput>;
};

export type FeedbackCommentDto = {
  __typename?: 'FeedbackCommentDto';
  author: FeedbackUserDto;
  createdAt: Scalars['Timestamp'];
  id: Scalars['String'];
  internal: Scalars['Boolean'];
  postId: Scalars['String'];
  replyTo?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  updatedAt: Scalars['Timestamp'];
};

export type FeedbackCustomColumnDto = {
  __typename?: 'FeedbackCustomColumnDto';
  board: FeedbackBoardDto;
  id: Scalars['String'];
  name: Scalars['String'];
  type: FeedbackCustomColumnType;
};

export enum FeedbackCustomColumnType {
  DATE = 'DATE',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT'
}

export type FeedbackPostCustomColumnDto = {
  __typename?: 'FeedbackPostCustomColumnDto';
  customColumnId: Scalars['String'];
  value: Scalars['String'];
};

export type FeedbackPostCustomColumnInput = {
  customColumnId: Scalars['String'];
  value: Scalars['String'];
};

export type FeedbackPostDto = {
  __typename?: 'FeedbackPostDto';
  accounts?: Maybe<Array<CdpAccountObj>>;
  assignee?: Maybe<UserObj>;
  author: FeedbackUserDto;
  boardId: Scalars['String'];
  comments: Array<FeedbackCommentDto>;
  commentsCount: Scalars['Int'];
  createdAt: Scalars['Timestamp'];
  customColumns: Array<FeedbackPostCustomColumnDto>;
  deals: Array<DealObj>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  importance?: Maybe<FeedbackPostImportance>;
  insights: Array<InsightObj>;
  internal: Scalars['Boolean'];
  isAIGenerated: Scalars['Boolean'];
  productBoardItems: Array<ProductBoardItemObj>;
  productLineTags: Array<TagObj>;
  revenueImpact: Scalars['Int'];
  source?: Maybe<FeedbackPostSource>;
  status: FeedbackPostStatus;
  tags: Array<TagObj>;
  title: Scalars['String'];
  updatedAt: Scalars['Timestamp'];
  upvotedByUser: Scalars['Boolean'];
  upvoters: Array<FeedbackUserDto>;
  upvotes: Scalars['Int'];
};

export type FeedbackPostFilterOptionObj = {
  __typename?: 'FeedbackPostFilterOptionObj';
  label: Scalars['String'];
  upvotersCount: Scalars['Float'];
  value: Scalars['String'];
};

export type FeedbackPostFilterOptionsObj = {
  __typename?: 'FeedbackPostFilterOptionsObj';
  CDPAccountOptions: Array<CdpAccountFilterOptionObj>;
  accountIndustries: Array<Scalars['String']>;
  accountTypes: Array<Scalars['String']>;
  assigneeOptions: Array<UserFilterOptionObj>;
  authorOptions: Array<FeedbackUserFilterOptionObj>;
  insightOptions: Array<FilterOptionObj>;
  productBoardItemOptions: Array<FilterOptionObj>;
  productLineTagOptions: Array<TagFilterOptionObj>;
  tagOptions: Array<TagFilterOptionObj>;
};

export enum FeedbackPostImportance {
  MUST_HAVE = 'MUST_HAVE',
  NICE_TO_HAVE = 'NICE_TO_HAVE',
  UNSET = 'UNSET'
}

export enum FeedbackPostSource {
  CLARI_COPILOT = 'CLARI_COPILOT',
  CSV = 'CSV',
  GONG = 'GONG',
  GRAIN = 'GRAIN',
  HUBSPOT = 'HUBSPOT',
  INTERCOM = 'INTERCOM',
  MICROSOFT_DYNAMICS = 'MICROSOFT_DYNAMICS',
  PIPEDRIVE = 'PIPEDRIVE',
  SALESFORCE = 'SALESFORCE',
  SLACK = 'SLACK',
  ZENDESK = 'ZENDESK',
  ZOOM = 'ZOOM'
}

export enum FeedbackPostStatus {
  DONE = 'DONE',
  IN_PROGRESS = 'IN_PROGRESS',
  IN_REVIEW = 'IN_REVIEW',
  PLANNED = 'PLANNED',
  REFUSED = 'REFUSED'
}

export type FeedbackPostsByDealDigestObj = {
  __typename?: 'FeedbackPostsByDealDigestObj';
  amount?: Maybe<Scalars['String']>;
  closeDate?: Maybe<Scalars['DateTime']>;
  company?: Maybe<DealCompanyObj>;
  crm?: Maybe<CrmOptions>;
  id: Scalars['String'];
  ideas?: Maybe<Array<FeedbackPostDto>>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<DealOwnerObj>;
  stage?: Maybe<Scalars['String']>;
};

export enum FeedbackPostsSortBy {
  ASSIGNEE = 'ASSIGNEE',
  CREATED_AT = 'CREATED_AT',
  REVENUE_IMPACT = 'REVENUE_IMPACT',
  STATUS = 'STATUS',
  TITLE = 'TITLE',
  VOTES = 'VOTES'
}

export type FeedbackPostsViewFilterObj = {
  __typename?: 'FeedbackPostsViewFilterObj';
  accountsFilter?: Maybe<CdpAccountItemsFilterObj>;
  assigneeIds?: Maybe<Array<Scalars['String']>>;
  boardId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isAIGenerated?: Maybe<Scalars['Boolean']>;
  isInternal?: Maybe<Scalars['Boolean']>;
  maxVotes?: Maybe<Scalars['Float']>;
  minVotes?: Maybe<Scalars['Float']>;
  productBoardItemIds?: Maybe<Array<Scalars['String']>>;
  query?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<FeedbackPostStatus>>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};

export type FeedbackPostsViewObj = {
  __typename?: 'FeedbackPostsViewObj';
  filter?: Maybe<FeedbackPostsViewFilterObj>;
  id: Scalars['String'];
  name: Scalars['String'];
  sort?: Maybe<FeedbackPostsViewSortObj>;
  view?: Maybe<FeedbackBoardView>;
  visibleProperties?: Maybe<Array<Scalars['String']>>;
};

export type FeedbackPostsViewSortObj = {
  __typename?: 'FeedbackPostsViewSortObj';
  id: Scalars['String'];
  sort: SortOrder;
  sortBy: FeedbackPostsSortBy;
};

export type FeedbackUserDto = {
  __typename?: 'FeedbackUserDto';
  admin: Scalars['Boolean'];
  avatarSrc?: Maybe<Scalars['String']>;
  createdAt: Scalars['Timestamp'];
  email: Scalars['String'];
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Timestamp'];
};

export type FeedbackUserFilterOptionObj = {
  __typename?: 'FeedbackUserFilterOptionObj';
  avatarSrc?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  value: Scalars['String'];
};

export type FeedbackUserLogInDto = {
  __typename?: 'FeedbackUserLogInDto';
  accessToken: Scalars['String'];
  user: FeedbackUserDto;
};

export type FetchIntegrationProjectsInput = {
  externalProjectURLs?: Maybe<Array<Scalars['String']>>;
  integrationId: Scalars['String'];
};

export type FieldSortInput = {
  order: SortOrder;
};

export type FieldSortObj = {
  __typename?: 'FieldSortObj';
  order: SortOrder;
};

export type FillOrganizationWithOnboardingDataInput = {
  brandGuidelines?: Maybe<Scalars['String']>;
  companyDescription?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  personas?: Maybe<Array<OrganizationOnboardingPersonasInput>>;
  productLineTags?: Maybe<Array<OrganizationOnboardingProductLineTagsInput>>;
};

export type FilterAnnouncementInput = {
  createdAtGte?: Maybe<Scalars['DateTime']>;
  includeNonRepeatingUpdates?: Maybe<Scalars['Boolean']>;
};

export type FilterAssetsInput = {
  approvalStatuses?: Maybe<Array<LaunchModuleApprovalStatus>>;
  approverIds?: Maybe<Array<Scalars['String']>>;
  createdAtGte?: Maybe<Scalars['DateTime']>;
  createdAtLte?: Maybe<Scalars['DateTime']>;
  isBrandAsset?: Maybe<Scalars['Boolean']>;
  isEmpty?: Maybe<Scalars['Boolean']>;
  launchIds?: Maybe<Array<Scalars['String']>>;
  ownerIds?: Maybe<Array<Scalars['String']>>;
  query?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  types?: Maybe<Array<AssetTypes>>;
};

export type FilterCommentInput = {
  parentId: Scalars['String'];
  parentType: CommentParentType;
};

export type FilterCompetingCompaniesNewsAticlesInput = {
  companiesDomains?: Maybe<Array<Scalars['String']>>;
  companiesNames?: Maybe<Array<Scalars['String']>>;
  endPublishedOn?: Maybe<Scalars['DateTime']>;
  query?: Maybe<Scalars['String']>;
  startPublishedOn?: Maybe<Scalars['DateTime']>;
};

export type FilterDealsCompaniesInput = {
  search?: Maybe<Scalars['String']>;
};

export type FilterDealsInput = {
  companiesIds?: Maybe<Array<Scalars['String']>>;
  endCloseDate?: Maybe<Scalars['DateTime']>;
  ids?: Maybe<Array<Scalars['String']>>;
  ownersIds?: Maybe<Array<Scalars['String']>>;
  query?: Maybe<Scalars['String']>;
  /** List of CRMs from which deals were imported */
  source?: Maybe<Array<CrmOptions>>;
  stages?: Maybe<Array<Scalars['String']>>;
  startCloseDate?: Maybe<Scalars['DateTime']>;
};

export type FilterDealsOwnersInput = {
  createdAtGte?: Maybe<Scalars['DateTime']>;
  search?: Maybe<Scalars['String']>;
};

export type FilterExistingFeedBackPostsDigestInput = {
  createdAtGte: Scalars['DateTime'];
};

export type FilterExternalFeedbackPostsInput = {
  accountIds?: Maybe<Array<Scalars['String']>>;
  accountsFilter?: Maybe<CdpAccountItemsFilterInput>;
  assigneeIds?: Maybe<Array<Scalars['String']>>;
  authorIds?: Maybe<Array<Scalars['String']>>;
  createdAtGte?: Maybe<Scalars['DateTime']>;
  createdAtLte?: Maybe<Scalars['DateTime']>;
  dealIds?: Maybe<Array<Scalars['String']>>;
  insightIds?: Maybe<Array<Scalars['String']>>;
  isAIGenerated?: Maybe<Scalars['Boolean']>;
  maxVotes?: Maybe<Scalars['Float']>;
  minVotes?: Maybe<Scalars['Float']>;
  productBoardItemIds?: Maybe<Array<Scalars['String']>>;
  productLineTagIds?: Maybe<Array<Scalars['String']>>;
  query?: Maybe<Scalars['String']>;
  sources?: Maybe<Array<FeedbackPostSource>>;
  statuses?: Maybe<Array<FeedbackPostStatus>>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};

export type FilterFeatureTableInput = {
  company?: Maybe<Scalars['Boolean']>;
  query?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type FilterFeedbackPostsInput = {
  accountIds?: Maybe<Array<Scalars['String']>>;
  accountsFilter?: Maybe<CdpAccountItemsFilterInput>;
  assigneeIds?: Maybe<Array<Scalars['String']>>;
  authorIds?: Maybe<Array<Scalars['String']>>;
  boardId?: Maybe<Scalars['String']>;
  createdAtGte?: Maybe<Scalars['DateTime']>;
  createdAtLte?: Maybe<Scalars['DateTime']>;
  dealIds?: Maybe<Array<Scalars['String']>>;
  insightIds?: Maybe<Array<Scalars['String']>>;
  isAIGenerated?: Maybe<Scalars['Boolean']>;
  isInternal?: Maybe<Scalars['Boolean']>;
  maxVotes?: Maybe<Scalars['Float']>;
  minVotes?: Maybe<Scalars['Float']>;
  productBoardItemIds?: Maybe<Array<Scalars['String']>>;
  productLineTagIds?: Maybe<Array<Scalars['String']>>;
  query?: Maybe<Scalars['String']>;
  sources?: Maybe<Array<FeedbackPostSource>>;
  statuses?: Maybe<Array<FeedbackPostStatus>>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};

export type FilterInsightGeneratedItemInput = {
  accountIds?: Maybe<Array<Scalars['String']>>;
  createdAtGte?: Maybe<Scalars['DateTime']>;
  createdAtLte?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  insightIds?: Maybe<Array<Scalars['String']>>;
  insightsFilter?: Maybe<FilterInsightsInput>;
  query?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  timeFrameSelected?: Maybe<MeasurementsTimeFrame>;
  type?: Maybe<Array<InsightGeneratedItemsType>>;
  updatedAtGte?: Maybe<Scalars['DateTime']>;
  updatedAtLte?: Maybe<Scalars['DateTime']>;
};

export type FilterInsightGeneratedItemTrendGraphInput = {
  accountIds?: Maybe<Array<Scalars['String']>>;
  createdAtGte?: Maybe<Scalars['DateTime']>;
  createdAtLte?: Maybe<Scalars['DateTime']>;
  endDate: Scalars['DateTime'];
  insightIds?: Maybe<Array<Scalars['String']>>;
  insightsFilter?: Maybe<FilterInsightsInput>;
  itemId?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  timeFrameSelected: MeasurementsTimeFrame;
  type?: Maybe<Array<InsightGeneratedItemsType>>;
  updatedAtGte?: Maybe<Scalars['DateTime']>;
  updatedAtLte?: Maybe<Scalars['DateTime']>;
};

export type FilterInsightTrendItemGraphInput = {
  accountIds?: Maybe<Array<Scalars['String']>>;
  createdAtGte?: Maybe<Scalars['DateTime']>;
  createdAtLte?: Maybe<Scalars['DateTime']>;
  endDate: Scalars['DateTime'];
  insightIds?: Maybe<Array<Scalars['String']>>;
  insightsFilter?: Maybe<FilterInsightsInput>;
  itemId?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  timeFrameSelected: MeasurementsTimeFrame;
  type?: Maybe<Array<InsightTrendItemsType>>;
  updatedAtGte?: Maybe<Scalars['DateTime']>;
  updatedAtLte?: Maybe<Scalars['DateTime']>;
};

export type FilterInsightTrendItemInput = {
  accountIds?: Maybe<Array<Scalars['String']>>;
  createdAtGte?: Maybe<Scalars['DateTime']>;
  createdAtLte?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  insightIds?: Maybe<Array<Scalars['String']>>;
  insightsFilter?: Maybe<FilterInsightsInput>;
  query?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  timeFrameSelected?: Maybe<MeasurementsTimeFrame>;
  type?: Maybe<Array<InsightTrendItemsType>>;
  updatedAtGte?: Maybe<Scalars['DateTime']>;
  updatedAtLte?: Maybe<Scalars['DateTime']>;
};

export type FilterInsightsInput = {
  accountIds?: Maybe<Array<Scalars['String']>>;
  accountsFilter?: Maybe<CdpAccountItemsFilterInput>;
  assigneeIds?: Maybe<Array<Scalars['String']>>;
  competitorIds?: Maybe<Array<Scalars['String']>>;
  contactIds?: Maybe<Array<Scalars['String']>>;
  conversationTypes?: Maybe<Array<Scalars['String']>>;
  createdAtGte?: Maybe<Scalars['DateTime']>;
  createdAtLte?: Maybe<Scalars['DateTime']>;
  creatorIds?: Maybe<Array<Scalars['String']>>;
  endRegisteredOn?: Maybe<Scalars['DateTime']>;
  feedbackPostIds?: Maybe<Array<Scalars['String']>>;
  launchIds?: Maybe<Array<Scalars['String']>>;
  personaIds?: Maybe<Array<Scalars['String']>>;
  productBoardItemIds?: Maybe<Array<Scalars['String']>>;
  productLineTagIds?: Maybe<Array<Scalars['String']>>;
  query?: Maybe<Scalars['String']>;
  source?: Maybe<Array<InsightSourceFilter>>;
  startRegisteredOn?: Maybe<Scalars['DateTime']>;
  summaryUpdatedAtGte?: Maybe<Scalars['DateTime']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  tagsUpdatedAtGte?: Maybe<Scalars['DateTime']>;
  taskIds?: Maybe<Array<Scalars['String']>>;
};

export type FilterIntegrationProjectsInput = {
  ids?: Maybe<Array<Scalars['String']>>;
  integrationIds?: Maybe<Array<Scalars['String']>>;
  integrationResourceId?: Maybe<Scalars['String']>;
  productName?: Maybe<Array<TasksIntegrationProductName>>;
  search?: Maybe<Scalars['String']>;
  selected?: Maybe<Scalars['Boolean']>;
};

export type FilterIntegrationTasksInput = {
  assignedTo?: Maybe<Array<Scalars['String']>>;
  dueDateGTE?: Maybe<Scalars['DateTime']>;
  dueDateLTE?: Maybe<Scalars['DateTime']>;
  inWatchList?: Maybe<Scalars['Boolean']>;
  integrationId?: Maybe<Scalars['String']>;
  integrationProjectIds?: Maybe<Array<Scalars['String']>>;
  launchId?: Maybe<Scalars['String']>;
  productName?: Maybe<Array<TasksIntegrationProductName>>;
  search?: Maybe<Scalars['String']>;
  startDateGTE?: Maybe<Scalars['DateTime']>;
  startDateLTE?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Array<TaskStatusTypes>>;
  types?: Maybe<Array<Scalars['String']>>;
};

export type FilterKeywordsInput = {
  search?: Maybe<Scalars['String']>;
};

export type FilterLaunchInput = {
  createdAtGte?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  launchId?: Maybe<Scalars['String']>;
  launchMonths?: Maybe<Array<Scalars['DateTime']>>;
  launchTags?: Maybe<Array<Scalars['String']>>;
  launchTier?: Maybe<Array<LaunchTiers>>;
  launchTypeId?: Maybe<Array<Scalars['String']>>;
  ownerId?: Maybe<Array<Scalars['String']>>;
  search?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<LaunchStatusByDuedate>;
  teamMembers?: Maybe<Array<Scalars['String']>>;
};

export type FilterLaunchModuleInput = {
  editor?: Maybe<EditorsTypes>;
  name?: Maybe<Scalars['String']>;
};

export type FilterLaunchSectionInput = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type FilterOptionObj = {
  __typename?: 'FilterOptionObj';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type FilterPhaseInput = {
  launchTiers?: Maybe<Array<LaunchTiers>>;
  launchTypeIds?: Maybe<Array<Scalars['String']>>;
};

export type FilterProductBoardReleasesInput = {
  launchIds?: Maybe<Array<Scalars['String']>>;
  productLineTagId?: Maybe<Scalars['String']>;
  releaseIds?: Maybe<Array<Scalars['String']>>;
};

export type FilterRetroInput = {
  id?: Maybe<Scalars['String']>;
  launchId?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
};

export type FilterTasksInput = {
  assigneeIds?: Maybe<Array<Scalars['String']>>;
  dueDateGte?: Maybe<Scalars['DateTime']>;
  dueDateLte?: Maybe<Scalars['DateTime']>;
  launchIds?: Maybe<Array<Scalars['String']>>;
  ownerIds?: Maybe<Array<Scalars['String']>>;
  priorities?: Maybe<Array<Scalars['Int']>>;
  query?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<TaskStatusTypes>>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  types?: Maybe<Array<TaskTypes>>;
};

export type FilterUserInput = {
  search?: Maybe<Scalars['String']>;
};

export type FilterWinlossGraphInput = {
  accounts?: Maybe<Array<Scalars['String']>>;
  competitorIds?: Maybe<Array<Scalars['String']>>;
  dealOwners?: Maybe<Array<Scalars['String']>>;
  endCloseDate?: Maybe<Scalars['DateTime']>;
  endDate: Scalars['DateTime'];
  opportunitySizeMax?: Maybe<Scalars['Float']>;
  opportunitySizeMin?: Maybe<Scalars['Float']>;
  stages?: Maybe<Array<WinlossStage>>;
  startCloseDate?: Maybe<Scalars['DateTime']>;
  startDate: Scalars['DateTime'];
  timeFrameSelected: MeasurementsTimeFrame;
};

export type FilterWinlossMetricsInput = {
  accounts?: Maybe<Array<Scalars['String']>>;
  competitorIds?: Maybe<Array<Scalars['String']>>;
  dealOwners?: Maybe<Array<Scalars['String']>>;
  endCloseDate?: Maybe<Scalars['DateTime']>;
  endDate: Scalars['DateTime'];
  opportunitySizeMax?: Maybe<Scalars['Float']>;
  opportunitySizeMin?: Maybe<Scalars['Float']>;
  stages?: Maybe<Array<WinlossStage>>;
  startCloseDate?: Maybe<Scalars['DateTime']>;
  startDate: Scalars['DateTime'];
};

export type FilterWinlossSalesrepDigestInput = {
  createdAtGte: Scalars['DateTime'];
};

export type FilterWinlossTableInput = {
  accounts?: Maybe<Array<Scalars['String']>>;
  competitorIds?: Maybe<Array<Scalars['String']>>;
  dealOwners?: Maybe<Array<Scalars['String']>>;
  endCloseDate?: Maybe<Scalars['DateTime']>;
  endDate: Scalars['DateTime'];
  opportunitySizeMax?: Maybe<Scalars['Float']>;
  opportunitySizeMin?: Maybe<Scalars['Float']>;
  stages?: Maybe<Array<WinlossStage>>;
  startCloseDate?: Maybe<Scalars['DateTime']>;
  startDate: Scalars['DateTime'];
};

export type FindIntegrationChannelsInput = {
  sendAs?: Maybe<NotificationSendAsTypes>;
  source?: Maybe<NotificationSources>;
};

export type FindNotificationChannelInput = {
  accessToken?: Maybe<Scalars['String']>;
  accessTokenOwnerId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  scope?: Maybe<NotificationTokenScope>;
  source?: Maybe<NotificationSources>;
};

export type FindTagInput = {
  id: Scalars['String'];
};

export type FindTagsInput = {
  ids?: Maybe<Array<Scalars['String']>>;
  launchId?: Maybe<Scalars['String']>;
  parentName?: Maybe<TagParentName>;
  types?: Maybe<Array<TagTypes>>;
};

export type G2UserReviewsOutput = {
  __typename?: 'G2UserReviewsOutput';
  answers?: Maybe<Array<Scalars['String']>>;
  companyName?: Maybe<Scalars['String']>;
  helpful?: Maybe<Scalars['Float']>;
  industry?: Maybe<Scalars['String']>;
  publishedDate?: Maybe<Scalars['DateTime']>;
  reviewSource?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
  segment?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  userName?: Maybe<Scalars['String']>;
};

export type GptGetObjectivesInput = {
  audience?: Maybe<Scalars['String']>;
  belief?: Maybe<Scalars['String']>;
  businessGoals?: Maybe<Scalars['String']>;
  launchFocus?: Maybe<Scalars['String']>;
  launchId: Scalars['String'];
  market?: Maybe<Scalars['String']>;
};

export type GptGetPositioningStrategyInput = {
  alternatives?: Maybe<Scalars['String']>;
  attributes?: Maybe<Scalars['String']>;
  customer?: Maybe<Scalars['String']>;
  launchId: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export enum GptPromptsType {
  FACEBOOK_AD = 'FACEBOOK_AD',
  GOOGLE_AD = 'GOOGLE_AD',
  SUMMARY = 'SUMMARY'
}

export type GenerateCopyUsingSummaryInput = {
  audience?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyUrl?: Maybe<Scalars['String']>;
  keywords?: Maybe<Array<Scalars['String']>>;
  keywordsToAvoid?: Maybe<Array<Scalars['String']>>;
  point1?: Maybe<Scalars['String']>;
  point2?: Maybe<Scalars['String']>;
  point3?: Maybe<Scalars['String']>;
  productKeywords?: Maybe<Array<Scalars['String']>>;
  productName?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  tone?: Maybe<CopysmithToneOptions>;
  topic?: Maybe<Scalars['String']>;
  type: CopysmithPromptsType;
};

export type GenerateFeatureTableInput = {
  competitorBattlecardId: Scalars['String'];
};

export type GenerateIntegrationCreateUrlInput = {
  productName: IntegrationProductNames;
  redirectUri: Scalars['String'];
};

export type GenerateIntegrationJoinUrlInput = {
  integrationId: Scalars['String'];
  redirectUri: Scalars['String'];
};

export type GeneratePersonaInfoInput = {
  companyName: Scalars['String'];
  details: Scalars['String'];
  id: Scalars['String'];
};

export type GetAiPositioningStrategyInputForMessaging = {
  alternatives?: Maybe<Scalars['String']>;
  attributes?: Maybe<Scalars['String']>;
  customer?: Maybe<Scalars['String']>;
  productLineTagId: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type GongInsightIntegrationItemsPaginationInput = {
  cursor?: Maybe<Scalars['String']>;
};

export type GtmTimelineObj = {
  __typename?: 'GtmTimelineObj';
  channels: Array<ChannelObj>;
  launchId: Scalars['String'];
  milestones: Array<MilestoneObj>;
};

export enum Homepage {
  DEFAULT = 'DEFAULT',
  MISSION_CONTROL_PM = 'MISSION_CONTROL_PM',
  PRODUCT_ROADMAP = 'PRODUCT_ROADMAP'
}

export type HubSpotCompaniesObj = {
  __typename?: 'HubSpotCompaniesObj';
  domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type HubSpotDealDetailsObj = {
  __typename?: 'HubSpotDealDetailsObj';
  amount?: Maybe<Scalars['Float']>;
  closeDate?: Maybe<Scalars['String']>;
  closedAmount?: Maybe<Scalars['Float']>;
  createdDate?: Maybe<Scalars['String']>;
  dealName?: Maybe<Scalars['String']>;
  dealOwnerId?: Maybe<Scalars['String']>;
  dealStage?: Maybe<Scalars['String']>;
  isClosed?: Maybe<Scalars['Boolean']>;
  isWon?: Maybe<Scalars['Boolean']>;
  pipeline?: Maybe<Scalars['String']>;
};

export type HubSpotOwnersObj = {
  __typename?: 'HubSpotOwnersObj';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Float']>;
};

export type HubspotIntegrationObj = {
  __typename?: 'HubspotIntegrationObj';
  accessToken: Scalars['String'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  organizationId: Scalars['String'];
  refreshToken: Scalars['String'];
  validTill?: Maybe<Scalars['DateTime']>;
};

export enum InsightsSummaryGenerationStatus {
  DONE = 'DONE',
  ERROR = 'ERROR',
  GENERATING = 'GENERATING',
  NOT_STARTED = 'NOT_STARTED'
}

export type ImportAllInsightIntegrationItemsOptionsInput = {
  generateFeedbackPosts?: Maybe<Scalars['Boolean']>;
};

export type ImportFeedbackPostsFromCsvInput = {
  boardId: Scalars['String'];
  posts: Array<ImportFeedbackPostsFromCsvInputPost>;
};

export type ImportFeedbackPostsFromCsvInputPost = {
  description?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

export type ImportInsightsFromCsvInput = {
  generateFeedbackPosts?: Maybe<Scalars['Boolean']>;
  insights: Array<ImportInsightsFromCsvInsight>;
};

export type ImportInsightsFromCsvInsight = {
  accountDomain?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  content: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  registeredOn?: Maybe<Scalars['DateTime']>;
  tags?: Maybe<Array<Scalars['String']>>;
};

export type ImportLaunchFromUploadedFilesInput = {
  assetFiles?: Maybe<Array<AssetsFile>>;
  launchBriefFiles?: Maybe<Array<AssetsFile>>;
  taskInput?: Maybe<Array<ImportTasksFromCsvTask>>;
};

export type ImportProductBoardItemsFromCsvInput = {
  items: Array<ImportProductBoardItemsFromCsvItem>;
  roadmapId: Scalars['String'];
};

export type ImportProductBoardItemsFromCsvItem = {
  description?: Maybe<Scalars['String']>;
  effort?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  tags?: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  value?: Maybe<Scalars['Float']>;
};

export type ImportProductBoardItemsFromIntegrationInput = {
  itemIds: Array<Scalars['String']>;
  roadmapId: Scalars['String'];
};

export type ImportTasksFromCsvInput = {
  launchId?: Maybe<Scalars['String']>;
  tasks: Array<ImportTasksFromCsvTask>;
};

export type ImportTasksFromCsvTask = {
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  tags?: Maybe<Array<Scalars['String']>>;
};

export type ImportTasksFromIntegrationInput = {
  deleteExisting: Scalars['Boolean'];
  integrationTaskIdsWithSubTaskIds: Array<TaskIdsWithSubTaskIdsInput>;
  launchId?: Maybe<Scalars['String']>;
  type?: Maybe<TaskTypes>;
};

export type InsightFilterOptionsObj = {
  __typename?: 'InsightFilterOptionsObj';
  CDPAccountOptions: Array<CdpAccountFilterOptionObj>;
  CDPContactOptions: Array<FilterOptionObj>;
  CDPOwnerOptions: Array<FilterOptionObj>;
  accountIndustries: Array<Scalars['String']>;
  accountTypes: Array<Scalars['String']>;
  competitorOptions: Array<CompetitorCompanyFilterOptionObj>;
  conversationTypes: Array<Scalars['String']>;
  creatorOptions: Array<UserFilterOptionObj>;
  feedbackPostOptions: Array<FeedbackPostFilterOptionObj>;
  launchOptions: Array<LaunchFilterOptionObj>;
  personaOptions: Array<PersonaFilterOptionObj>;
  productBoardItemOptions: Array<FilterOptionObj>;
  productLineTagOptions: Array<TagFilterOptionObj>;
  tagOptions: Array<TagFilterOptionObj>;
  taskOptions: Array<FilterOptionObj>;
};

export type InsightGeneratedItemFilterOptionsObj = {
  __typename?: 'InsightGeneratedItemFilterOptionsObj';
  CDPAccountOptions: Array<CdpAccountFilterOptionObj>;
  tagOptions: Array<TagFilterOptionObj>;
};

export enum InsightGeneratedItemsType {
  COMMON_TERMS = 'COMMON_TERMS',
  CONFUSION_POINTS = 'CONFUSION_POINTS',
  FEATURE_REQUESTS = 'FEATURE_REQUESTS',
  SOLVED_PROBLEMS = 'SOLVED_PROBLEMS',
  STRENGTHS = 'STRENGTHS',
  VALUE_DRIVERS = 'VALUE_DRIVERS',
  WEAKNESSES = 'WEAKNESSES'
}

export type InsightIntegrationFeedbackPostMappingObj = {
  __typename?: 'InsightIntegrationFeedbackPostMappingObj';
  channelId: Scalars['String'];
  feedbackBoardId: Scalars['String'];
};

export type InsightIntegrationImportAllItemsStateObj = {
  __typename?: 'InsightIntegrationImportAllItemsStateObj';
  fetchedItems?: Maybe<Scalars['Int']>;
  status: Scalars['String'];
  totalItems?: Maybe<Scalars['Int']>;
};

export type InsightIntegrationInsightMappingObj = {
  __typename?: 'InsightIntegrationInsightMappingObj';
  channelId: Scalars['String'];
  productLineTagId: Scalars['String'];
};

export type InsightIntegrationItemObj = {
  __typename?: 'InsightIntegrationItemObj';
  content: Scalars['String'];
  externalCreatedAt: Scalars['DateTime'];
  externalId: Scalars['String'];
  id: Scalars['String'];
};

export type InsightIntegrationItemsFilterInput = {
  endDate: Scalars['Timestamp'];
  integrationId: Scalars['String'];
  startDate: Scalars['Timestamp'];
};

export type InsightIntegrationOAuthUrlInput = {
  integrationSource: InsightsIntegrations;
  subdomain?: Maybe<Scalars['String']>;
};

export type InsightIntegrationObj = {
  __typename?: 'InsightIntegrationObj';
  appName?: Maybe<Scalars['String']>;
  createdAt: Scalars['Timestamp'];
  feedbackBoardId?: Maybe<Scalars['String']>;
  feedbackPostMappings: Array<InsightIntegrationFeedbackPostMappingObj>;
  generateFeedbackPosts: Scalars['Boolean'];
  id: Scalars['String'];
  importAllItemsState: InsightIntegrationImportAllItemsStateObj;
  insightMappings: Array<InsightIntegrationInsightMappingObj>;
  integrationSource: InsightsIntegrations;
  owner: UserObj;
  subdomain?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Timestamp'];
  webhookEnabled: Scalars['Boolean'];
};

export type InsightIntegrationsInput = {
  integrationSource?: Maybe<InsightsIntegrations>;
};

export type InsightMetadataObj = {
  __typename?: 'InsightMetadataObj';
  competitorsReferenced?: Maybe<Scalars['String']>;
  conversationType?: Maybe<Scalars['String']>;
  customerCompany?: Maybe<Scalars['String']>;
  customerJobTitle?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  customerType?: Maybe<Scalars['String']>;
  summaryName?: Maybe<Scalars['String']>;
};

export type InsightObj = {
  __typename?: 'InsightObj';
  account?: Maybe<CdpAccountObj>;
  assignee?: Maybe<CdpOwnerObj>;
  company?: Maybe<Scalars['String']>;
  competitors: Array<CompanyObj>;
  contact?: Maybe<CdpContactObj>;
  content?: Maybe<Scalars['String']>;
  conversationWithSpeakers?: Maybe<Scalars['String']>;
  createdAt: Scalars['Timestamp'];
  createdBy?: Maybe<Scalars['String']>;
  deal?: Maybe<CdpDealObj>;
  feedbackPosts: Array<FeedbackPostDto>;
  id: Scalars['String'];
  importedContent?: Maybe<Scalars['String']>;
  insightIntegrationItemId?: Maybe<Scalars['String']>;
  isEditable?: Maybe<Scalars['Boolean']>;
  isImportedFromIntegration?: Maybe<Scalars['Boolean']>;
  launches: Array<LaunchObj>;
  metadata?: Maybe<InsightMetadataObj>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  parts: Array<InsightPartObj>;
  personas: Array<PersonaDto>;
  productBoardItems: Array<ProductBoardItemObj>;
  productLineTags: Array<TagObj>;
  registeredOn: Scalars['DateTime'];
  source?: Maybe<InsightSource>;
  summary?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<TagObj>>;
  tasks: Array<TaskObj>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Timestamp'];
  user?: Maybe<Scalars['String']>;
};

export type InsightPartObj = {
  __typename?: 'InsightPartObj';
  authorName?: Maybe<Scalars['String']>;
  text: Scalars['String'];
};

export enum InsightSource {
  CLARI_COPILOT = 'CLARI_COPILOT',
  CSV = 'CSV',
  GONG = 'GONG',
  GRAIN = 'GRAIN',
  INTERCOM = 'INTERCOM',
  SLACK = 'SLACK',
  ZENDESK = 'ZENDESK',
  ZOOM = 'ZOOM'
}

export enum InsightSourceFilter {
  CLARI_COPILOT = 'CLARI_COPILOT',
  CSV = 'CSV',
  GONG = 'GONG',
  GRAIN = 'GRAIN',
  INTERCOM = 'INTERCOM',
  MANUAL = 'MANUAL',
  SLACK = 'SLACK',
  ZENDESK = 'ZENDESK',
  ZOOM = 'ZOOM'
}

export enum InsightTrendItemsType {
  COMMON_TERMS = 'COMMON_TERMS',
  CONFUSION_POINTS = 'CONFUSION_POINTS',
  FEATURE_REQUESTS = 'FEATURE_REQUESTS',
  SOLVED_PROBLEMS = 'SOLVED_PROBLEMS',
  STRENGTHS = 'STRENGTHS',
  VALUE_DRIVERS = 'VALUE_DRIVERS',
  WEAKNESSES = 'WEAKNESSES'
}

export type InsightsGeneratedItemObj = {
  __typename?: 'InsightsGeneratedItemObj';
  accounts: Array<CdpAccountObj>;
  createdAt: Scalars['Timestamp'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  insights: Array<InsightObj>;
  organizationId: Scalars['String'];
  tags: Array<TagObj>;
  text: Scalars['String'];
  trendGraph?: Maybe<InsightsGeneratedItemTrendGraphDataObj>;
  type: InsightGeneratedItemsType;
  updatedAt: Scalars['Timestamp'];
};

export type InsightsGeneratedItemTrendGraphDataObj = {
  __typename?: 'InsightsGeneratedItemTrendGraphDataObj';
  count?: Maybe<Array<Scalars['Float']>>;
  labels?: Maybe<Array<Scalars['String']>>;
};

export enum InsightsIntegrations {
  CLARI_COPILOT = 'CLARI_COPILOT',
  GONG = 'GONG',
  GRAIN = 'GRAIN',
  INTERCOM = 'INTERCOM',
  SLACK = 'SLACK',
  ZENDESK = 'ZENDESK',
  ZOOM = 'ZOOM'
}

export type InsightsMarketingSummaryObj = {
  __typename?: 'InsightsMarketingSummaryObj';
  commonTerms: Array<InsightsSummaryGeneratedItemObj>;
  confusionPoints: Array<InsightsSummaryGeneratedItemObj>;
  id: Scalars['String'];
  insightIds: Array<Scalars['String']>;
  insights: Array<InsightObj>;
  saved: Scalars['Boolean'];
  solvedProblems: Array<InsightsSummaryGeneratedItemObj>;
  status?: Maybe<InsightsSummaryGenerationStatus>;
  valueDrivers: Array<InsightsSummaryGeneratedItemObj>;
};

export type InsightsProductSummaryObj = {
  __typename?: 'InsightsProductSummaryObj';
  featureRequests: Array<InsightsSummaryGeneratedItemObj>;
  id: Scalars['String'];
  insightIds: Array<Scalars['String']>;
  insights: Array<InsightObj>;
  overallSentiment: Scalars['String'];
  saved: Scalars['Boolean'];
  status?: Maybe<InsightsSummaryGenerationStatus>;
  strengths: Array<InsightsSummaryGeneratedItemObj>;
  weaknesses: Array<InsightsSummaryGeneratedItemObj>;
};

export type InsightsSavedSummaryObj = {
  __typename?: 'InsightsSavedSummaryObj';
  createdAt: Scalars['Timestamp'];
  id: Scalars['String'];
  name: Scalars['String'];
  savedBy: UserObj;
  summary: SummaryUnion;
  tags: Array<TagObj>;
  updatedAt: Scalars['Timestamp'];
};

export enum InsightsSortBy {
  CREATED_AT = 'CREATED_AT',
  INSIGHT = 'INSIGHT',
  NAME = 'NAME',
  REGISTERED_ON = 'REGISTERED_ON',
  SUMMARY = 'SUMMARY'
}

export type InsightsSummaryGeneratedItemObj = {
  __typename?: 'InsightsSummaryGeneratedItemObj';
  createdAt: Scalars['Timestamp'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  insights: Array<InsightObj>;
  organizationId: Scalars['String'];
  score: Scalars['Float'];
  text: Scalars['String'];
  type: InsightGeneratedItemsType;
  updatedAt: Scalars['Timestamp'];
};

export enum InsightsSummaryType {
  MARKETING = 'MARKETING',
  PRODUCT = 'PRODUCT'
}

export type InsightsTrendItemGraphDataObj = {
  __typename?: 'InsightsTrendItemGraphDataObj';
  count?: Maybe<Array<Scalars['Float']>>;
  labels?: Maybe<Array<Scalars['String']>>;
};

export type InsightsTrendItemObj = {
  __typename?: 'InsightsTrendItemObj';
  accounts: Array<CdpAccountObj>;
  createdAt: Scalars['Timestamp'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  insightIds: Array<Scalars['String']>;
  insights: Array<InsightObj>;
  organizationId: Scalars['String'];
  tags: Array<TagObj>;
  text: Scalars['String'];
  trendGraph?: Maybe<InsightsGeneratedItemTrendGraphDataObj>;
  type: InsightGeneratedItemsType;
  updatedAt: Scalars['Timestamp'];
};

export type InsightsViewFilterObj = {
  __typename?: 'InsightsViewFilterObj';
  accountIds?: Maybe<Array<Scalars['String']>>;
  assigneeIds?: Maybe<Array<Scalars['String']>>;
  competitorIds?: Maybe<Array<Scalars['String']>>;
  contactIds?: Maybe<Array<Scalars['String']>>;
  conversationTypes?: Maybe<Array<Scalars['String']>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAtGte?: Maybe<Scalars['DateTime']>;
  endRegisteredOn?: Maybe<Scalars['DateTime']>;
  feedbackPostIds?: Maybe<Array<Scalars['String']>>;
  launchIds?: Maybe<Array<Scalars['String']>>;
  personaIds?: Maybe<Array<Scalars['String']>>;
  productBoardItemIds?: Maybe<Array<Scalars['String']>>;
  query?: Maybe<Scalars['String']>;
  source?: Maybe<Array<InsightSourceFilter>>;
  startRegisteredOn?: Maybe<Scalars['DateTime']>;
  summaryUpdatedAtGte?: Maybe<Scalars['DateTime']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  tagsUpdatedAtGte?: Maybe<Scalars['DateTime']>;
  taskIds?: Maybe<Array<Scalars['String']>>;
};

export type InsightsViewObj = {
  __typename?: 'InsightsViewObj';
  filter?: Maybe<InsightsViewFilterObj>;
  id: Scalars['String'];
  name: Scalars['String'];
  sort?: Maybe<InsightsViewSortObj>;
  visibleProperties?: Maybe<Array<Scalars['String']>>;
};

export type InsightsViewSortObj = {
  __typename?: 'InsightsViewSortObj';
  id: Scalars['String'];
  sort: SortOrder;
  sortBy: InsightsSortBy;
};

export type Integration = {
  __typename?: 'Integration';
  authorized: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  creator: UserObj;
  id: Scalars['String'];
  name: Scalars['String'];
  needsToReintegrate: Scalars['Boolean'];
  organization: OrganizationObj;
  productName: IntegrationProductNames;
};

export type IntegrationChannelOutput = {
  __typename?: 'IntegrationChannelOutput';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<SlackConversationType>;
};

export type IntegrationChannelsPaginatedOutput = {
  __typename?: 'IntegrationChannelsPaginatedOutput';
  docs: Array<IntegrationChannelOutput>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type IntegrationColumnMapObj = {
  __typename?: 'IntegrationColumnMapObj';
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['String']>;
};

export type IntegrationColumnObj = {
  __typename?: 'IntegrationColumnObj';
  id: Scalars['String'];
  title: Scalars['String'];
};

export type IntegrationColumnsInput = {
  integrationProjectId: Scalars['String'];
  subtaskBoard?: Maybe<Scalars['Boolean']>;
};

export type IntegrationObj = {
  __typename?: 'IntegrationObj';
  accessToken: Scalars['String'];
  accessTokenOwnerId?: Maybe<Scalars['String']>;
  fetchedAllResources: Scalars['Boolean'];
  id?: Maybe<Scalars['String']>;
  lastRefreshedOn?: Maybe<Scalars['DateTime']>;
  metadata?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  productName: TasksIntegrationProductName;
  refreshToken?: Maybe<Scalars['String']>;
  resources?: Maybe<Array<IntegrationResourceObj>>;
  selectedIntegrationProjects?: Maybe<Array<IntegrationProjectObj>>;
  validTill?: Maybe<Scalars['DateTime']>;
};

export enum IntegrationProductNames {
  SLACK = 'SLACK'
}

export type IntegrationProjectObj = {
  __typename?: 'IntegrationProjectObj';
  active: Scalars['Boolean'];
  columnMap: IntegrationColumnMapObj;
  externalProjectId: Scalars['String'];
  fetchedAllTasks: Scalars['Boolean'];
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  integrationResourceId: Scalars['String'];
  isManuallySelected?: Maybe<Scalars['Boolean']>;
  isValidExternalProjectURL?: Maybe<Scalars['Boolean']>;
  lastRefreshedOn?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  organizationId: Scalars['String'];
  productName: TasksIntegrationProductName;
  selected?: Maybe<Scalars['Boolean']>;
  subtaskColumnMap: IntegrationColumnMapObj;
  tasksCount: Scalars['Int'];
  tasksUpdatedOn?: Maybe<Scalars['DateTime']>;
};

export type IntegrationResourceObj = {
  __typename?: 'IntegrationResourceObj';
  externalResourceId: Scalars['String'];
  fetchedAllProjects: Scalars['Boolean'];
  fetchedSelectedProjects?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  metadata?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId: Scalars['String'];
  productName: TasksIntegrationProductName;
};

export type IntegrationTagObj = {
  __typename?: 'IntegrationTagObj';
  externalId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type IntegrationTaskObj = {
  __typename?: 'IntegrationTaskObj';
  actualStatus?: Maybe<Scalars['String']>;
  assignedTo?: Maybe<Scalars['String']>;
  calculatedStatus?: Maybe<TaskStatusTypes>;
  createdBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  externalTaskId: Scalars['String'];
  externalUrl?: Maybe<Scalars['String']>;
  fetchedAllSubTasks?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  inWatchList: Scalars['Boolean'];
  integrationId: Scalars['String'];
  integrationProjectId: Scalars['String'];
  integrationResourceId: Scalars['String'];
  integrationTaskStatusProgress?: Maybe<Array<IntegrationTaskStatusProgressObj>>;
  lastRefreshedOn?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  organizationId: Scalars['String'];
  parentIntegrationTaskId?: Maybe<Scalars['String']>;
  productName: TasksIntegrationProductName;
  readableExternalId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status: TaskStatusTypes;
  subTasks?: Maybe<Array<IntegrationTaskObj>>;
  subTasksStatuses?: Maybe<IntegrationTaskSubTasksStatusesObj>;
  subTasksUpdatedOn?: Maybe<Scalars['DateTime']>;
  tags?: Maybe<Array<IntegrationTagObj>>;
  type?: Maybe<Scalars['String']>;
};


export type IntegrationTaskObjSubTasksArgs = {
  filter?: Maybe<FilterIntegrationTasksInput>;
};

export type IntegrationTaskStatusProgressObj = {
  __typename?: 'IntegrationTaskStatusProgressObj';
  date: Scalars['DateTime'];
  status: TaskStatusTypes;
};

export type IntegrationTaskSubTasksStatusesObj = {
  __typename?: 'IntegrationTaskSubTasksStatusesObj';
  DONE: Scalars['Float'];
  IN_PROCESS: Scalars['Float'];
  NOT_STARTED: Scalars['Float'];
  TOTAL: Scalars['Float'];
};

export type IntegrationTasksStatusObj = {
  __typename?: 'IntegrationTasksStatusObj';
  progressPercentage: Scalars['Float'];
  status: ProductIntegrationTasksStatus;
  totalCompletedSubTasks: Scalars['Float'];
  totalSubTasks: Scalars['Float'];
};

export type IntercomInsightIntegrationItemsFilterInput = {
  endDate: Scalars['Timestamp'];
  integrationId: Scalars['String'];
  onlyClosed?: Maybe<Scalars['Boolean']>;
  startDate: Scalars['Timestamp'];
  tagIds?: Maybe<Array<Scalars['String']>>;
};

export type IntercomInsightIntegrationItemsPaginationInput = {
  cursor?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
};

export type IntercomTagObj = {
  __typename?: 'IntercomTagObj';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type InvitedApproversEmailInput = {
  email: Scalars['String'];
  required: Scalars['Boolean'];
};

export enum JiraIssueType {
  BUG = 'Bug',
  EPIC = 'Epic',
  STORY = 'Story',
  TASK = 'Task'
}

export enum KpiMetrics {
  DOLLAR = 'DOLLAR',
  HASH = 'HASH',
  PERCENT = 'PERCENT'
}

export type KeyPeople = {
  __typename?: 'KeyPeople';
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  linkedIn?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  subRole?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type KeywordResultsOutput = {
  __typename?: 'KeywordResultsOutput';
  cpc?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  search_term?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  visits?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
};

export enum KeywordsSortKeys {
  CPC = 'CPC',
  KEYWORD = 'KEYWORD',
  POSITION = 'POSITION',
  SEARCH_VOLUME = 'SEARCH_VOLUME',
  TOP_RANKING_PAGE = 'TOP_RANKING_PAGE',
  VISITS = 'VISITS'
}

export type KpiFilterInput = {
  launchId?: Maybe<Scalars['String']>;
  objectiveId?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
};

export type KpiObj = {
  __typename?: 'KpiObj';
  createdAt: Scalars['DateTime'];
  currentValue?: Maybe<Scalars['Float']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  format?: Maybe<KpiMetrics>;
  id: Scalars['String'];
  launchId?: Maybe<Scalars['String']>;
  objectiveId?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  owner?: Maybe<UserObj>;
  qualitativeStatus?: Maybe<OkrQualitativeStatus>;
  targetValue?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
};

export enum Language {
  AFRIKAANS = 'AFRIKAANS',
  ALBANIAN = 'ALBANIAN',
  AMHARIC = 'AMHARIC',
  ARABIC = 'ARABIC',
  ARMENIAN = 'ARMENIAN',
  ASSAMESE = 'ASSAMESE',
  AYMARA = 'AYMARA',
  AZERBAIJANI = 'AZERBAIJANI',
  BAMBARA = 'BAMBARA',
  BASQUE = 'BASQUE',
  BELARUSIAN = 'BELARUSIAN',
  BENGALI = 'BENGALI',
  BHOJPURI = 'BHOJPURI',
  BOSNIAN = 'BOSNIAN',
  BULGARIAN = 'BULGARIAN',
  CATALAN = 'CATALAN',
  CEBUANO = 'CEBUANO',
  CHECK = 'CHECK',
  CHICHEWA = 'CHICHEWA',
  CHINESE_SIMPLIFIED = 'CHINESE_SIMPLIFIED',
  CHINESE_TRADITIONAL = 'CHINESE_TRADITIONAL',
  CORSICAN = 'CORSICAN',
  CROATIAN = 'CROATIAN',
  CZECH = 'CZECH',
  DANISH = 'DANISH',
  DHIVEHI = 'DHIVEHI',
  DOGRI = 'DOGRI',
  DUTCH = 'DUTCH',
  ENGLISH = 'ENGLISH',
  ESPERANTO = 'ESPERANTO',
  ESTONIAN = 'ESTONIAN',
  EWE = 'EWE',
  FILIPINO = 'FILIPINO',
  FINNISH = 'FINNISH',
  FRENCH = 'FRENCH',
  FRISIAN = 'FRISIAN',
  GALICIAN = 'GALICIAN',
  GEORGIAN = 'GEORGIAN',
  GERMAN = 'GERMAN',
  GREEK = 'GREEK',
  GUARANI = 'GUARANI',
  GUJARATI = 'GUJARATI',
  HAITIAN_CREOLE = 'HAITIAN_CREOLE',
  HAUSA = 'HAUSA',
  HAWAIIAN = 'HAWAIIAN',
  HEBREW = 'HEBREW',
  HINDI = 'HINDI',
  HISTORY = 'HISTORY',
  HMONG = 'HMONG',
  HUNGARIAN = 'HUNGARIAN',
  ICELANDIC = 'ICELANDIC',
  IGBO = 'IGBO',
  ILOCANO = 'ILOCANO',
  INDONESIAN = 'INDONESIAN',
  IRISH = 'IRISH',
  ITALIAN = 'ITALIAN',
  JAPANESE = 'JAPANESE',
  JAVANESE = 'JAVANESE',
  KANNADA = 'KANNADA',
  KAZAKH = 'KAZAKH',
  KHMER = 'KHMER',
  KINYARWANDA = 'KINYARWANDA',
  KONKANI = 'KONKANI',
  KOREAN = 'KOREAN',
  KRIO = 'KRIO',
  KURDISH_KURMANJI = 'KURDISH_KURMANJI',
  KURDISH_SORANI = 'KURDISH_SORANI',
  KYRGYZ = 'KYRGYZ',
  LAO = 'LAO',
  LATIN = 'LATIN',
  LATVIAN = 'LATVIAN',
  LINGALA = 'LINGALA',
  LITHUANIAN = 'LITHUANIAN',
  LUGANDA = 'LUGANDA',
  LUXEMBOURGISH = 'LUXEMBOURGISH',
  MACEDONIAN = 'MACEDONIAN',
  MAITHILI = 'MAITHILI',
  MALAGASY = 'MALAGASY',
  MALAY = 'MALAY',
  MALAYALAM = 'MALAYALAM',
  MALTESE = 'MALTESE',
  MAORI = 'MAORI',
  MARATHI = 'MARATHI',
  MEITEILON_MANIPURI = 'MEITEILON_MANIPURI',
  MIZO = 'MIZO',
  MONGOLIAN = 'MONGOLIAN',
  MYANMAR_BURMESE = 'MYANMAR_BURMESE',
  NEPALI = 'NEPALI',
  NORWEGIAN = 'NORWEGIAN',
  ODIA_ORIYA = 'ODIA_ORIYA',
  OROMO = 'OROMO',
  PASHTO = 'PASHTO',
  PERSIAN = 'PERSIAN',
  POLISH = 'POLISH',
  PORTUGUESE = 'PORTUGUESE',
  PUNJABI = 'PUNJABI',
  QUECHUA = 'QUECHUA',
  ROMANIAN = 'ROMANIAN',
  RUSSIAN = 'RUSSIAN',
  SAMOAN = 'SAMOAN',
  SANSKRIT = 'SANSKRIT',
  SCOTS_GAELIC = 'SCOTS_GAELIC',
  SEPEDI = 'SEPEDI',
  SERBIAN = 'SERBIAN',
  SESOTHO = 'SESOTHO',
  SHONA = 'SHONA',
  SINDHI = 'SINDHI',
  SINHALA = 'SINHALA',
  SLOVAK = 'SLOVAK',
  SLOVENIAN = 'SLOVENIAN',
  SOMALI = 'SOMALI',
  SPANISH = 'SPANISH',
  SUNDANESE = 'SUNDANESE',
  SWAHILI = 'SWAHILI',
  SWEDISH = 'SWEDISH',
  TAJIK = 'TAJIK',
  TAMIL = 'TAMIL',
  TATAR = 'TATAR',
  TELUGU = 'TELUGU',
  THAI = 'THAI',
  TIGRINYA = 'TIGRINYA',
  TSONGA = 'TSONGA',
  TURKISH = 'TURKISH',
  TURKMEN = 'TURKMEN',
  TWI = 'TWI',
  UKRAINIAN = 'UKRAINIAN',
  URDU = 'URDU',
  UYGHUR = 'UYGHUR',
  UZBEK = 'UZBEK',
  VIETNAMESE = 'VIETNAMESE',
  WELSH = 'WELSH',
  XHOSA = 'XHOSA',
  YIDDISH = 'YIDDISH',
  YORUBA = 'YORUBA',
  ZULU = 'ZULU'
}

export enum LaunchModuleApprovalStatus {
  APPROVED = 'APPROVED',
  APPROVING = 'APPROVING',
  NOT_REQUESTED = 'NOT_REQUESTED',
  READY_TO_REQUEST = 'READY_TO_REQUEST'
}

export enum LaunchModuleStatus {
  DELAYED = 'DELAYED',
  DONE = 'DONE',
  IN_PROCESS = 'IN_PROCESS',
  NOT_STARTED = 'NOT_STARTED'
}

export enum LaunchPhaseStatus {
  AT_RISK = 'AT_RISK',
  DELAYED = 'DELAYED',
  ON_TRACK = 'ON_TRACK'
}

export enum LaunchStatusByDuedate {
  PAST = 'PAST',
  UPCOMING = 'UPCOMING'
}

export enum LaunchTeamModuleRoles {
  DESIGN = 'DESIGN',
  ENGINEERING = 'ENGINEERING',
  LAUNCH_LEAD = 'LAUNCH_LEAD',
  MARKETING = 'MARKETING',
  PRODUCT = 'PRODUCT',
  SALES = 'SALES'
}

export enum LaunchTiers {
  T1 = 'T1',
  T2 = 'T2',
  T3 = 'T3',
  T4 = 'T4',
  T5 = 'T5',
  T6 = 'T6'
}

export enum LaunchTypeCreator {
  IGNITION = 'IGNITION',
  ORGANIZATION = 'ORGANIZATION'
}

export type LastEditDetailsInput = {
  timestamp?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type LastEditDetailsObj = {
  __typename?: 'LastEditDetailsObj';
  timestamp?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type LaunchApproversObj = {
  __typename?: 'LaunchApproversObj';
  approvalRequestSent: Scalars['Boolean'];
  approvedAt?: Maybe<Scalars['DateTime']>;
  hasApproved: Scalars['Boolean'];
  required: Scalars['Boolean'];
  userDetails: UserObj;
  userId: Scalars['String'];
};

export type LaunchAssetContentObj = {
  __typename?: 'LaunchAssetContentObj';
  contentHTML: Scalars['String'];
  editor: EditorsTypes;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type LaunchContentObj = {
  __typename?: 'LaunchContentObj';
  assets: Array<LaunchAssetContentObj>;
  description: Scalars['String'];
  gtmTimelineContentHTML: Scalars['String'];
  id: Scalars['String'];
  launchDate: Scalars['DateTime'];
  launchProgressContentHTML: Scalars['String'];
  measurementsContentHTML: Scalars['String'];
  name: Scalars['String'];
  sections: Array<LaunchSectionContentObj>;
};

export type LaunchFilterOptionObj = {
  __typename?: 'LaunchFilterOptionObj';
  label: Scalars['String'];
  tier?: Maybe<LaunchTiers>;
  value: Scalars['String'];
};

export type LaunchFilterOptionsObj = {
  __typename?: 'LaunchFilterOptionsObj';
  members: Array<UserObj>;
  owners: Array<UserObj>;
  tags: Array<TagObj>;
};

export type LaunchModuleContentObj = {
  __typename?: 'LaunchModuleContentObj';
  contentHTML: Scalars['String'];
  editor: EditorsTypes;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type LaunchModuleHelpInput = {
  comment?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  launchModuleName: Scalars['String'];
  launchName: Scalars['String'];
  name: Scalars['String'];
};

export type LaunchModuleObj = {
  __typename?: 'LaunchModuleObj';
  approvalStatus?: Maybe<LaunchModuleApprovalStatus>;
  approversDetails?: Maybe<Array<ApproverDetailsObj>>;
  canGenerateWithAI?: Maybe<Scalars['Boolean']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  editor?: Maybe<EditorsTypes>;
  generateWithAIInput?: Maybe<Scalars['String']>;
  gptPrompt?: Maybe<GptPromptsType>;
  hint?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVisible: Scalars['Boolean'];
  lastEditBy?: Maybe<UserObj>;
  lastEditDetails?: Maybe<UserInputLastEditDetailsObj>;
  launchId: Scalars['String'];
  launchSectionId: Scalars['String'];
  lockingDetails?: Maybe<LockingDetailsObj>;
  name: Scalars['String'];
  orderIndex?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  status?: Maybe<LaunchModuleStatus>;
  tags?: Maybe<Array<TagObj>>;
  tagsIds?: Maybe<Array<Scalars['String']>>;
  templateModuleId?: Maybe<Scalars['String']>;
  userInput?: Maybe<UserInputObj>;
  userInputHistory?: Maybe<Array<UserInputObj>>;
};

export type LaunchMonthsObj = {
  __typename?: 'LaunchMonthsObj';
  monthIndex: Scalars['String'];
  numberOfLaunches: Scalars['Int'];
  year: Scalars['String'];
};

export type LaunchNameOption = {
  __typename?: 'LaunchNameOption';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type LaunchObj = {
  __typename?: 'LaunchObj';
  budget?: Maybe<Scalars['Float']>;
  competitors: Array<CompanyObj>;
  copilotPreferences?: Maybe<CopilotPreferencesObj>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customProgress?: Maybe<CustomProgressObj>;
  description?: Maybe<Scalars['String']>;
  feedbackPosts: Array<FeedbackPostDto>;
  gtmTimeline: GtmTimelineObj;
  id?: Maybe<Scalars['String']>;
  insights: Array<InsightObj>;
  isPrivate: Scalars['Boolean'];
  lastUpdateSentAt?: Maybe<Scalars['DateTime']>;
  launchDate?: Maybe<Scalars['DateTime']>;
  launchDateChangedOn?: Maybe<Scalars['DateTime']>;
  launchModules: Array<Maybe<LaunchModuleObj>>;
  launchReadiness?: Maybe<Scalars['Float']>;
  launchSections?: Maybe<Array<LaunchSectionObj>>;
  launchTier?: Maybe<LaunchTiers>;
  launchType?: Maybe<LaunchTypeObj>;
  modulesLaunchSections: Array<Maybe<LaunchSectionObj>>;
  name: Scalars['String'];
  organizationId: Scalars['String'];
  owner?: Maybe<UserObj>;
  ownerId?: Maybe<Scalars['String']>;
  personas: Array<PersonaDto>;
  phases: Array<LaunchPhaseObj>;
  productBoardItems: Array<ProductBoardItemObj>;
  productIntegrationSubTaskIds?: Maybe<Array<Scalars['String']>>;
  productIntegrationTaskIds?: Maybe<Array<Scalars['String']>>;
  publicPageConfig: LaunchPublicPageConfigObj;
  readinessNote?: Maybe<Scalars['String']>;
  sectionVisibilityPreferences: SectionVisibilityPreferencesObj;
  stageId?: Maybe<Scalars['String']>;
  strategicApproach?: Maybe<StrategicApproach>;
  supportsCopilot: Scalars['Boolean'];
  tags: Array<TagObj>;
  tasks: Array<TaskObj>;
  templateId: Scalars['String'];
  users?: Maybe<Array<UserWithModulesObj>>;
  viewers?: Maybe<Array<LaunchViewerObj>>;
};


export type LaunchObjLaunchSectionsArgs = {
  filter?: Maybe<FilterLaunchSectionInput>;
};

export type LaunchPhaseObj = {
  __typename?: 'LaunchPhaseObj';
  approvalRequestSent: Scalars['Boolean'];
  approvers?: Maybe<Array<LaunchApproversObj>>;
  endDate: Scalars['DateTime'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  status: LaunchPhaseStatus;
};

export type LaunchProgressObj = {
  __typename?: 'LaunchProgressObj';
  assetsProgress: ModulesApprovalStatusProgressObj;
  launchCountdown: Scalars['Float'];
  launchId: Scalars['String'];
  launchReadiness: Scalars['Float'];
  productProgress: IntegrationTasksStatusObj;
  tasksProgress: TasksProgressObj;
};

export type LaunchPublicCopyAndAssetsPageSettingsObj = {
  __typename?: 'LaunchPublicCopyAndAssetsPageSettingsObj';
  assetsModules: Array<Scalars['String']>;
  live: Scalars['Boolean'];
};

export type LaunchPublicLaunchPlanPageSettingsObj = {
  __typename?: 'LaunchPublicLaunchPlanPageSettingsObj';
  launchModules: Array<Scalars['String']>;
  live: Scalars['Boolean'];
};

export type LaunchPublicPageConfigObj = {
  __typename?: 'LaunchPublicPageConfigObj';
  live: Scalars['Boolean'];
  settings: LaunchPublicPagesSettingsObj;
};

export type LaunchPublicPageSettingsObj = {
  __typename?: 'LaunchPublicPageSettingsObj';
  live: Scalars['Boolean'];
};

export type LaunchPublicPagesSettingsObj = {
  __typename?: 'LaunchPublicPagesSettingsObj';
  competitiveIntelligence: LaunchPublicPageSettingsObj;
  copyAndAssets: LaunchPublicCopyAndAssetsPageSettingsObj;
  customersResearch: LaunchPublicPageSettingsObj;
  gtmTimeline: LaunchPublicPageSettingsObj;
  launchPlan: LaunchPublicLaunchPlanPageSettingsObj;
  measurements: LaunchPublicPageSettingsObj;
  missionControl: LaunchPublicPageSettingsObj;
  productStatus: LaunchPublicPageSettingsObj;
  tasks: LaunchPublicPageSettingsObj;
};

export type LaunchSectionContentObj = {
  __typename?: 'LaunchSectionContentObj';
  id: Scalars['String'];
  modules: Array<LaunchModuleContentObj>;
  name: Scalars['String'];
};

export type LaunchSectionObj = {
  __typename?: 'LaunchSectionObj';
  hideModules?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  launchId: Scalars['String'];
  launchModuleIds: Array<Scalars['String']>;
  launchModules?: Maybe<Array<LaunchModuleObj>>;
  name: Scalars['String'];
};


export type LaunchSectionObjLaunchModulesArgs = {
  filter?: Maybe<FilterLaunchModuleInput>;
};

export type LaunchTierDetailsObj = {
  __typename?: 'LaunchTierDetailsObj';
  channelPreferences?: Maybe<Array<ChannelPreferencesObj>>;
  launchTier?: Maybe<LaunchTiers>;
  templateGtmTimeline?: Maybe<TemplateGtmTimelineObj>;
  templateSections: Array<TemplateSectionObj>;
  templateTasks?: Maybe<Array<TemplateTaskObj>>;
};

export type LaunchTypeObj = {
  __typename?: 'LaunchTypeObj';
  createdBy: LaunchTypeCreator;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type LaunchTypesSubscriptionResponse = {
  __typename?: 'LaunchTypesSubscriptionResponse';
  doc: LaunchTypeObj;
  event: SubscriptionPayloadEventType;
};

export type LaunchViewerObj = {
  __typename?: 'LaunchViewerObj';
  viewDate?: Maybe<Scalars['DateTime']>;
  viewer?: Maybe<UserObj>;
};

export type LaunchesFilterOptionsObj = {
  __typename?: 'LaunchesFilterOptionsObj';
  launchNames: Array<LaunchNameOption>;
  launchTypes: Array<LaunchTypeObj>;
  members: Array<UserObj>;
  owners: Array<UserObj>;
  tags: Array<TagObj>;
};

export type LockingDetailsInput = {
  locked?: Maybe<Scalars['Boolean']>;
  lockedByUserId?: Maybe<Scalars['String']>;
};

export type LockingDetailsObj = {
  __typename?: 'LockingDetailsObj';
  locked: Scalars['Boolean'];
  lockedByUserId?: Maybe<Scalars['String']>;
};

export type LogInInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LoginResponseObj = {
  __typename?: 'LoginResponseObj';
  accessToken?: Maybe<Scalars['String']>;
  firstTimeLogin?: Maybe<Scalars['Boolean']>;
  organizations: Array<OrganizationObj>;
  user: UserObj;
};

export type LoginWithSsoInput = {
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
};

export enum MeasurementsIntegrationType {
  AMPLITUDE = 'AMPLITUDE',
  HUBSPOT = 'HUBSPOT',
  MIXPANEL = 'MIXPANEL',
  SALESFORCE = 'SALESFORCE'
}

export enum MeasurementsTimeFrame {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  WEEKLY = 'WEEKLY',
  YEARLY = 'YEARLY'
}

export enum MessageGroupsParticipantsTypes {
  NON_USER = 'NON_USER',
  USER = 'USER'
}

export enum MilestoneEventType {
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  UPDATED = 'UPDATED'
}

export enum MilestoneType {
  GTM_PHASE = 'GTM_PHASE',
  KEY_DATE = 'KEY_DATE'
}

export enum Months {
  APRIL = 'APRIL',
  AUGUST = 'AUGUST',
  DECEMBER = 'DECEMBER',
  FEBRUARY = 'FEBRUARY',
  JANUARY = 'JANUARY',
  JULY = 'JULY',
  JUNE = 'JUNE',
  MARCH = 'MARCH',
  MAY = 'MAY',
  NOVEMBER = 'NOVEMBER',
  OCTOBER = 'OCTOBER',
  SEPTEMBER = 'SEPTEMBER'
}

export enum MsgGrpUserUpdateTypes {
  ADD = 'ADD',
  REMOVE = 'REMOVE'
}

export type MapIntegrationProjectColumnsInput = {
  columnMap: MapIntegrationProjectColumnsInputColumnMap;
  integrationProjectId: Scalars['String'];
  subtaskColumnMap?: Maybe<MapIntegrationProjectColumnsInputColumnMap>;
};

export type MapIntegrationProjectColumnsInputColumnMap = {
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['String']>;
};

export type MapleBillingAccessObj = {
  __typename?: 'MapleBillingAccessObj';
  canCreateAICopy: Scalars['Boolean'];
  canCreateBattleCard: Scalars['Boolean'];
  canCreateInsightSummarization: Scalars['Boolean'];
  canCreateLaunch: Scalars['Boolean'];
  canCreateProductIdeaBoard: Scalars['Boolean'];
  canCreateRoadmap: Scalars['Boolean'];
  canCreateRoadmapItem: Scalars['Boolean'];
  canCreateSurvey: Scalars['Boolean'];
  numberOfInsightSummarizationsAllowed: Scalars['Float'];
  organizationId: Scalars['String'];
};

export type MapleBillingEntitlementObj = {
  __typename?: 'MapleBillingEntitlementObj';
  entitlement_id?: Maybe<Scalars['String']>;
  inherited_from_id?: Maybe<Scalars['String']>;
  inherited_from_type?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  name: Scalars['String'];
  overridden?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type MapleBillingInvoiceAmountObj = {
  __typename?: 'MapleBillingInvoiceAmountObj';
  currency: Scalars['String'];
  value_in_cents: Scalars['Float'];
};

export type MapleBillingInvoiceObj = {
  __typename?: 'MapleBillingInvoiceObj';
  due: MapleBillingInvoiceAmountObj;
  due_date: Scalars['DateTime'];
  invoice_date: Scalars['DateTime'];
  paid: MapleBillingInvoiceAmountObj;
  pdf_link?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  total: MapleBillingInvoiceAmountObj;
};

export type MapleBillingPaymentMethodObj = {
  __typename?: 'MapleBillingPaymentMethodObj';
  brand?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['Boolean']>;
  exp_month?: Maybe<Scalars['Float']>;
  exp_year?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  last_4?: Maybe<Scalars['String']>;
};

export type MapleBillingPriceObj = {
  __typename?: 'MapleBillingPriceObj';
  frequency: Scalars['String'];
  id: Scalars['String'];
  price_per_unit: Scalars['Float'];
};

export type MapleBillingProductObj = {
  __typename?: 'MapleBillingProductObj';
  additionalDescription?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  display_order?: Maybe<Scalars['Float']>;
  display_type?: Maybe<Scalars['String']>;
  downgradable?: Maybe<Scalars['Boolean']>;
  entitlements?: Maybe<Array<MapleBillingEntitlementObj>>;
  getInTouch?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  is_free?: Maybe<Scalars['Boolean']>;
  is_subscribed?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  prices?: Maybe<Array<MapleBillingPriceObj>>;
  upgradable?: Maybe<Scalars['Boolean']>;
};

export type MapleBillingSubscriptionObj = {
  __typename?: 'MapleBillingSubscriptionObj';
  computed_entitlements: Array<MapleBillingEntitlementObj>;
  end_date?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isFree?: Maybe<Scalars['Boolean']>;
  minimum_units?: Maybe<Scalars['Float']>;
  num_licenses?: Maybe<Scalars['Float']>;
  productDetails?: Maybe<Array<MapleBillingProductObj>>;
  start_date?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
};

export type MeasurementEventPropertyObj = {
  __typename?: 'MeasurementEventPropertyObj';
  parameter: Scalars['String'];
  parameterValues: Array<MeasurementEventPropertyValueObj>;
};

export type MeasurementEventPropertyValueObj = {
  __typename?: 'MeasurementEventPropertyValueObj';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type MeasurementIntegrationMetricFilterInput = {
  parameter: Scalars['String'];
  parameterValue: Scalars['String'];
};

export type MeasurementIntegrationMetricFilterObj = {
  __typename?: 'MeasurementIntegrationMetricFilterObj';
  parameter: Scalars['String'];
  parameterValue: Scalars['String'];
};

export type MeasurementIntegrationMetricObj = {
  __typename?: 'MeasurementIntegrationMetricObj';
  eventName: Scalars['String'];
  filters?: Maybe<Array<MeasurementIntegrationMetricFilterObj>>;
  id: Scalars['String'];
  integrationType: Scalars['String'];
  measurementsIntegrationId: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  ownerId: Scalars['String'];
};

export type MeasurementIntegrationsOutput = {
  __typename?: 'MeasurementIntegrationsOutput';
  id?: Maybe<Scalars['String']>;
  name: MeasurementsIntegrationType;
};

export type MeasurementIntegrationsQueryInput = {
  endDate: Scalars['DateTime'];
  launchId?: Maybe<Scalars['String']>;
  metrics: Array<MeasurementIntegrationsQueryMetricInput>;
  startDate: Scalars['DateTime'];
  timeFrameSelected: MeasurementsTimeFrame;
};

export type MeasurementIntegrationsQueryMetricInput = {
  integrationType: MeasurementsIntegrationType;
  metricId: Scalars['String'];
};

export type MeasurementIntegrationsQueryOutput = {
  __typename?: 'MeasurementIntegrationsQueryOutput';
  avgAfterLaunch?: Maybe<Array<Scalars['Float']>>;
  avgAfterLaunchNormalized?: Maybe<Array<Scalars['Float']>>;
  avgBeforeLaunch?: Maybe<Array<Scalars['Float']>>;
  avgBeforeLaunchNormalized?: Maybe<Array<Scalars['Float']>>;
  dates: Array<Scalars['String']>;
  values: Array<Array<Scalars['Float']>>;
  valuesNormalized: Array<Array<Scalars['Float']>>;
};

export type MessageGroupObj = {
  __typename?: 'MessageGroupObj';
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  nonUserIds?: Maybe<Array<Scalars['String']>>;
  ownerId: Scalars['String'];
  userIds?: Maybe<Array<Scalars['String']>>;
  users: MessageGroupRecipientsObj;
};

export type MessageGroupParticipantObj = {
  __typename?: 'MessageGroupParticipantObj';
  id: Scalars['String'];
  type: MessageGroupsParticipantsTypes;
  value: Scalars['String'];
};

export type MessageGroupRecipientsObj = {
  __typename?: 'MessageGroupRecipientsObj';
  displayUsers: Array<Maybe<DisplayMessageGroupUserObj>>;
  nonUsersData?: Maybe<Array<NonUserObj>>;
  usersData?: Maybe<Array<UserObj>>;
};

export type MessagingLibraryObj = {
  __typename?: 'MessagingLibraryObj';
  customMessaging?: Maybe<Array<CustomMessagingObj>>;
  id: Scalars['String'];
  isViewed: Scalars['Boolean'];
  messaging?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  positioningStrategy?: Maybe<Scalars['String']>;
  productlineTag: TagObj;
};

export type MilestoneObj = {
  __typename?: 'MilestoneObj';
  description?: Maybe<Scalars['String']>;
  endDate: Scalars['Timestamp'];
  id: Scalars['String'];
  name: Scalars['String'];
  startDate: Scalars['Timestamp'];
  type: MilestoneType;
};

export type MilestonesSubscriptionResponse = {
  __typename?: 'MilestonesSubscriptionResponse';
  event: MilestoneEventType;
  milestone: MilestoneObj;
};

export type MixpanelIntegrationObj = {
  __typename?: 'MixpanelIntegrationObj';
  events?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  organizationId: Scalars['String'];
  ownerId: Scalars['String'];
  password: Scalars['String'];
  projectId: Scalars['String'];
  username: Scalars['String'];
};

export type ModulesApprovalStatusProgressObj = {
  __typename?: 'ModulesApprovalStatusProgressObj';
  approvedCount: Scalars['Float'];
  approvingCount: Scalars['Float'];
  notRequestedCount: Scalars['Float'];
  progressPercentage: Scalars['Float'];
  readyToRequestCount: Scalars['Float'];
  totalCount: Scalars['Float'];
};

export type MoveProductBoardItemInput = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  orderIndex?: Maybe<Scalars['String']>;
  roadmapItemId: Scalars['ID'];
  viewId?: Maybe<Scalars['String']>;
};

export type MultipleTemplates = {
  __typename?: 'MultipleTemplates';
  files: Array<OrganizationUploadedTemplateObj>;
  organizationId: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  MBChangeProductInSubscription: MapleBillingSubscriptionObj;
  MBCheckoutURL: Scalars['String'];
  MBCreateSubscription: MapleBillingSubscriptionObj;
  MBManageUsingMapleForOrganization: Scalars['String'];
  MBMigrateAllFreeUsers: Scalars['Boolean'];
  MBarchiveCusomerInMaple: Scalars['Boolean'];
  aILaunchCreateNotification: Scalars['Boolean'];
  abortAccountSync: Scalars['Boolean'];
  abortCompetitorsExtraction: Scalars['Boolean'];
  abortContactSync: Scalars['Boolean'];
  abortDealSync: Scalars['Boolean'];
  abortIdeaExtraction: Scalars['Boolean'];
  abortOwnerSync: Scalars['Boolean'];
  acceptOrganizationInvite: OrganizationObj;
  addApproversToLaunchPhase: LaunchObj;
  addApproversToOrganizationPhase: PhaseObj;
  addLaunchConnections: LaunchObj;
  addLaunchPhase: LaunchObj;
  addNewUserToOrganization: UserInOrganizationObj;
  addOrganizationPhase: PhaseObj;
  addProductBoardItemDependency: AddProductBoardItemDependencyResultDto;
  addSectionInLaunch: LaunchObj;
  addTagToTask: Array<TaskObj>;
  addTagToTestimonial: Array<TestimonialObj>;
  adminCreateLaunchFromTemplates: LaunchObj;
  adminCreateOrganization: OrganizationObj;
  adminCreateTemplate: TemplateObj;
  adminUpdateOrganization: OrganizationObj;
  adminUpdateTemplate: TemplateObj;
  adminUpdateTemplateModule: TemplateModuleObj;
  adminUpdateUser: UserObj;
  adminVerifyEmail: Scalars['Boolean'];
  askForDemo: Scalars['Boolean'];
  assignTagToReleaseNote: ReleaseNoteObj;
  assignTagsToLaunches: Array<LaunchObj>;
  attachIntegrationTasksToProductBoardItem: ProductBoardItemObj;
  attachTagToFeedbackPost: FeedbackPostDto;
  attachTagsToFeedbackPostAsAdmin: FeedbackPostDto;
  attachTagsToFeedbackPostsAsAdmin: Array<FeedbackPostDto>;
  attachTagsToInsights: Array<InsightObj>;
  autoInsightsTaggingSetting: OrganizationObj;
  blockOrganization: Scalars['Boolean'];
  cancelSubscription: StripeSubscriptionObj;
  cancelV1FreeSubscriptionAndCreateV2FreeSubscription: Scalars['Boolean'];
  cancelV2FreeSubscriptionAndCreateV3FreeSubscription: Scalars['Boolean'];
  checkUserExists: Scalars['Boolean'];
  configureHubspotCRMIntegration: CrmIntegrationObj;
  configureMicrosoftDynamicsCRMIntegration: CrmIntegrationObj;
  configureSalesforceCRMIntegration: CrmIntegrationObj;
  configureWinlossHubspotCRMIntegration: CrmIntegrationObj;
  configureWinlossSalesforceCRMIntegration: CrmIntegrationObj;
  connectProductBoardItemsToLaunch: Array<ProductBoardItemObj>;
  contextualChat: Scalars['String'];
  copyPersona: PersonaDto;
  copywriteGeneration: Scalars['String'];
  createAiPrompt: AiPromptObj;
  createAmplitudeIntegration: AmplitudeIntegrationObj;
  createAnnouncement: AnnouncementObj;
  createAsset: AssetObj;
  createCDPAccount: CdpAccountObj;
  createCDPContact: CdpContactObj;
  createCDPDeal: CdpDealObj;
  createCDPOwner: CdpOwnerObj;
  createChannel: ChannelObj;
  createChannelTimeframe: ChannelTimeframeObj;
  createChecklist: ChecklistObj;
  createCheckoutLink: Scalars['String'];
  createCheckoutLinkV2: Scalars['String'];
  createCheckoutLinkV3: Scalars['String'];
  createComment: CommentObj;
  createCompany: CompanyObj;
  createCompetitiveIntelligenceFeature: CompetitiveIntelligenceFeatureObj;
  createCompletion: Scalars['String'];
  createConfiguration: CrmIntegrationObj;
  createConfluenceDoc: Scalars['String'];
  createCopywriteV2Favorites: CopywriteV2FavoriteObj;
  createDefaultAssets: Array<AssetObj>;
  createDefaultChannels: Array<ChannelObj>;
  createDefaultTasks: LaunchObj;
  createDemoInsights: Array<InsightObj>;
  createDemoLaunch: LaunchObj;
  createFeatureTableCategory: FeatureTableCategoryObj;
  createFeedbackBoard: FeedbackBoardDto;
  createFeedbackComment: FeedbackCommentDto;
  createFeedbackCommentAsAdmin: FeedbackCommentDto;
  createFeedbackCommentPublic: FeedbackCommentDto;
  createFeedbackCustomColumn: FeedbackCustomColumnDto;
  createFeedbackPost: FeedbackPostDto;
  createFeedbackPostAsAdmin: FeedbackPostDto;
  createFeedbackPostPublic: FeedbackPostDto;
  createFeedbackPostView: FeedbackPostsViewObj;
  createFeedbackPostsAsAdmin: Array<FeedbackPostDto>;
  createFeedbackUser: FeedbackUserLogInDto;
  createGoogleDoc: Scalars['String'];
  createGoogleSlide: Scalars['String'];
  createInsight: InsightObj;
  createInsightIntegration: InsightIntegrationObj;
  createInsightsView: InsightsViewObj;
  createIntegration: IntegrationObj;
  createLaunch: LaunchObj;
  createLaunchModule: LaunchModuleObj;
  createLaunchSection: LaunchObj;
  createLaunchType: LaunchTypeObj;
  createMeasurementIntegrationsMetric: MeasurementIntegrationMetricObj;
  createMessageGroup: MessageGroupObj;
  createMilestone: MilestoneObj;
  createMixpanelIntegration: MixpanelIntegrationObj;
  createNonUser: NonUserObj;
  createOrUpdateCopysmithAIFavorite: CopysmithAiFavoriteObj;
  createOrUpdateKpi: KpiObj;
  createOrUpdateObjectives: ObjectiveObj;
  createOrganization: OrganizationObj;
  createOrganizationStage: OrganizationObj;
  createPersona: PersonaDto;
  createPersonaDemographicsCategory: PersonaDemographicsCategoryDto;
  createPersonaNote: PersonaNoteDto;
  createPlanFromUploadedFiles: LaunchObj;
  createPlanFromUrl: LaunchObj;
  createProductBoardCustomColumn: ProductBoardCustomColumnDto;
  createProductBoardFactor: ProductBoardFactorDto;
  createProductBoardItem: ProductBoardItemObj;
  createProductBoardItemsView: ProductBoardItemsViewObj;
  createProductBoardRelease: ProductBoardReleaseObj;
  createProductBoardRoadmap: ProductBoardRoadmapObj;
  createProductBoardStatus: ProductBoardStatusObj;
  createPublicPage: PublicPageObj;
  createReleaseNote: ReleaseNoteObj;
  createReleaseNotesSubscriber: Scalars['Boolean'];
  createRetro: RetroObj;
  createSlackInsightIntegration: InsightIntegrationObj;
  createSubscription: StripeSubscriptionObj;
  createSurvey: SurveyObj;
  createTag: TagObj;
  createTask: TaskObj;
  createTemplate: TemplateObj;
  createTemplateFromLaunch: TemplateObj;
  createTemplateModule: TemplateModuleObj;
  createTestimonial: TestimonialObj;
  createTestimonialsFromInsights: Array<TestimonialObj>;
  createUser: UserObj;
  deleteAllCDPAccounts: Scalars['Float'];
  deleteAllCDPContacts: Scalars['Float'];
  deleteAllCDPDeals: Scalars['Float'];
  deleteAnnouncement: AnnouncementObj;
  deleteAsset: AssetObj;
  deleteCDPAccounts: Scalars['Float'];
  deleteCDPContacts: Scalars['Float'];
  deleteCDPDeals: Scalars['Float'];
  deleteChannel: ChannelObj;
  deleteChannelTimeframe: ChannelTimeframeObj;
  deleteChecklist: Scalars['Boolean'];
  deleteCompany: Scalars['String'];
  deleteCompetitiveIntelligenceFeatures: Scalars['Boolean'];
  deleteCrmIntegration: CrmIntegrationObj;
  deleteFeatureTableCategories: Scalars['Boolean'];
  deleteFeedbackBoard: FeedbackBoardDto;
  deleteFeedbackComment: FeedbackCommentDto;
  deleteFeedbackCommentAsAdmin: FeedbackCommentDto;
  deleteFeedbackCustomColumn: FeedbackCustomColumnDto;
  deleteFeedbackPost: FeedbackPostDto;
  deleteFeedbackPostAsAdmin: FeedbackPostDto;
  deleteFeedbackPostView: FeedbackPostsViewObj;
  deleteInsight: InsightObj;
  deleteInsightIntegration: InsightIntegrationObj;
  deleteInsights: Array<InsightObj>;
  deleteInsightsTrendItemsByType: Scalars['Boolean'];
  deleteInsightsView: InsightsViewObj;
  deleteIntegration: IntegrationObj;
  deleteMeasurementIntegrationsMetric: MeasurementIntegrationMetricObj;
  deleteMessageGroup: MessageGroupObj;
  deleteMilestone: MilestoneObj;
  deletePersona: PersonaDto;
  deletePersonaDemographicsCategory: PersonaDemographicsCategoryDto;
  deletePersonaNote: PersonaNoteDto;
  deleteProductBoardCustomColumn: ProductBoardCustomColumnDto;
  deleteProductBoardFactor: ProductBoardFactorDto;
  deleteProductBoardItems: Array<ProductBoardItemObj>;
  deleteProductBoardItemsView: ProductBoardItemsViewObj;
  deleteProductBoardRelease: ProductBoardReleaseObj;
  deleteProductBoardRoadmap: ProductBoardRoadmapObj;
  deleteProductBoardStatus: ProductBoardStatusObj;
  deleteProductGapsData: Scalars['Boolean'];
  deletePublicPage: PublicPageObj;
  deleteReleaseNote: ReleaseNoteObj;
  deleteSalesforceIntegration: Scalars['Boolean'];
  deleteSampleData: OrganizationObj;
  deleteSavedInsightsSummary: InsightsSavedSummaryObj;
  deleteSimilarwebData: Scalars['Boolean'];
  deleteTag: TagObj;
  deleteTagFromReleaseNote: ReleaseNoteObj;
  deleteTagsFromLaunches: Array<LaunchObj>;
  deleteTask: TaskObj;
  deleteTasks: Array<TaskObj>;
  deleteTestimonial: TestimonialObj;
  deleteUserData: Scalars['Boolean'];
  deleteUserRolesInLaunchModule: LaunchObj;
  deleteWinlossCompetitors: Scalars['Boolean'];
  deleteWinlossData: Scalars['Boolean'];
  detachTagFromFeedbackPost: FeedbackPostDto;
  detachTagsFromFeedbackPostAsAdmin: FeedbackPostDto;
  detachTagsFromFeedbackPostsAsAdmin: FeedbackPostDto;
  detachTagsFromInsights: Array<InsightObj>;
  disableIntegrationProject: IntegrationProjectObj;
  dismissBanner: OrganizationObj;
  dragAsset: LaunchModuleObj;
  dragOrgAsset: AssetObj;
  dragProductBoardItem: ProductBoardItemObj;
  duplicateLaunch: LaunchObj;
  duplicateMessageGroup: MessageGroupObj;
  duplicateObjective: ObjectiveObj;
  duplicateProductBoardItem: ProductBoardItemObj;
  editCustomScreenshot: CompanyObj;
  editRegisteredOn: Scalars['Boolean'];
  editRssFeeds: CompanyObj;
  emailForgotPassword: Scalars['Boolean'];
  emailResendVerificationToken: Scalars['Boolean'];
  enableIntegrationProject: IntegrationProjectObj;
  enrichAccounts: Scalars['Boolean'];
  exchangeCodeForTokensConfluence: Scalars['String'];
  exchangeCodeForTokensGoogle: Scalars['String'];
  exportBattlecards: Scalars['Boolean'];
  exportFeedbackPostsToCsv: Scalars['String'];
  exportInsightsToCsv: Scalars['String'];
  exportProductBoardItemsToCsv: Scalars['String'];
  exportRoadmapTasks: Array<IntegrationTaskObj>;
  exportTasksToCsv: Scalars['String'];
  exportTasksToIntegration: Scalars['Boolean'];
  extendFreeTrial: StripeSubscriptionObj;
  fetchIntegrationProjects: Array<IntegrationProjectObj>;
  fillOrganizationWithOnboardingData: OrganizationObj;
  fixInsightsProductLineTagsForAmplitude: Scalars['Boolean'];
  g2ReviewsForExistingBattlecards?: Maybe<Scalars['Boolean']>;
  generateCompanyTalkingPoints: CompanyObj;
  generateCompetitorCompanyMessagingSummary: Scalars['String'];
  generateCompetitorCompanyTalkingPoints: Array<AiGeneratedTalkingPointObj>;
  generateCopyUsingSummary: Scalars['String'];
  generateCopysmithAIContentV2: Array<CopysmithAiContentObj>;
  generateCopywriteV2CampaignContent: Array<CopywriteV2ContentObj>;
  generateCopywriteV2TemplateContent: CopywriteV2ContentObj;
  generateFeatureTable: Scalars['Boolean'];
  generateGrowthToolCompanyTalkingPoints: Array<AiGeneratedTalkingPointObj>;
  generateIdeasFromAllItems: Scalars['Boolean'];
  generateIdeasUplevel: Scalars['Boolean'];
  generateIntegrationCreateUrl: Scalars['String'];
  generateIntegrationJoinUrl: Scalars['String'];
  generateJIRATicketDetailsFromProductBoardItem: TaskTitleAndDescription;
  generateMarketingInsightsSummary: InsightsMarketingSummaryObj;
  generatePersonaInfo: PersonaDto;
  generateProductIdeasCron: Scalars['Boolean'];
  generateProductInsightsSummary: InsightsProductSummaryObj;
  generateReleaseNoteFromProductRoadmapItems: ReleaseNoteObj;
  generateSummariesForInsightsWithoutSummaries: Scalars['Boolean'];
  generateSummaryForUpdatedInsightsInLast30Min: Scalars['Boolean'];
  generateSummaryUsingAI?: Maybe<AiSummaryOutput>;
  generateTagsForAllInsightsInOrg: Scalars['Boolean'];
  generateTagsForFeedbackPosts: Scalars['Boolean'];
  generateTagsForInsight: Scalars['Boolean'];
  generateTestimonialsFromInsights: Array<TestimonialFromInsightObj>;
  generateWinlossSummary: WinlossTakeawaysSummaryObj;
  getEditAccess: Scalars['Boolean'];
  getExpertHelp: Scalars['Boolean'];
  importAllClariCopilotInsightIntegrationItems: Scalars['Boolean'];
  importAllGongInsightIntegrationItems: Scalars['Boolean'];
  importAllIntercomInsightIntegrationItems: Scalars['Boolean'];
  importAllSlackInsightIntegrationItems: Scalars['Boolean'];
  importAllZendeskInsightIntegrationItems: Scalars['Boolean'];
  importAllZoomInsightIntegrationItems: Scalars['Boolean'];
  importCSVInsightsForDocebo: Scalars['Boolean'];
  importFeedbackPostsFromCsv: Array<FeedbackPostDto>;
  importIdeasForAmplitude: Scalars['Boolean'];
  importInsightsFromCsv: Array<InsightObj>;
  importProductBoardItemsFromCsv: Array<ProductBoardItemObj>;
  importProductBoardItemsFromIntegration: Array<ProductBoardItemObj>;
  importTasksFromCsv: Array<TaskObj>;
  importTasksFromIntegration: Array<TaskObj>;
  joinOrganizationWithMatchingDomain: OrganizationObj;
  linkSalesforceObjectToOrganization: Scalars['String'];
  logInFeedbackUser: FeedbackUserLogInDto;
  logInFeedbackUserWithGoogle: FeedbackUserLogInDto;
  loginAsUserToken: Scalars['String'];
  loginWithGoogle: LoginResponseObj;
  loginWithPassword: LoginResponseObj;
  loginWithSSO: LoginResponseObj;
  mapIntegrationProjectColumns: IntegrationProjectObj;
  migrateDeleteOutdatedLinearWebhooks: Scalars['Boolean'];
  migrateEnableClariCopilotSync: Scalars['Boolean'];
  migrateFixBrokenIntegrationTasks: Scalars['Boolean'];
  migrateMoveIntegrationSubtasksToIntegrationTasksCollection: Scalars['Boolean'];
  migrateRemoveDuplicateIntegrations: Scalars['Boolean'];
  migrateRemoveIntegrationTags: Scalars['Boolean'];
  modifyRegisteredOn: Scalars['Boolean'];
  moveLaunchToCustomPhase: LaunchObj;
  moveLaunchToNextPhase: LaunchObj;
  moveLaunchToPrevPhase: LaunchObj;
  moveProductBoardItem: ProductBoardItemsViewObj;
  publicApproveAssets: AssetObj;
  publicApproveModules: LaunchObj;
  publicToggleLaunchPhaseApproval: LaunchObj;
  reSelectIntegrationProject: IntegrationProjectObj;
  reSelectIntegrationTask: IntegrationTaskObj;
  redisHealth: Scalars['Boolean'];
  refreshFeedbackUserTokens: Scalars['String'];
  refreshIntegrationProjects: Scalars['Boolean'];
  refreshTokens: Scalars['String'];
  regerateFailedFeatureTable: Scalars['Boolean'];
  registerNotificationChannel: NotificationChannelObj;
  removeApproversFromLaunchPhase: LaunchObj;
  removeApproversFromOrganizationPhase: PhaseObj;
  removeComment: Scalars['Boolean'];
  removeFeedbackPostPublic: FeedbackPostDto;
  removeFeedbackPostUpvote: FeedbackPostDto;
  removeFeedbackPostUpvoteAsAdmin: FeedbackPostDto;
  removeFeedbackPostUpvotePublic: FeedbackPostDto;
  removeIntegration: Integration;
  removeIntegrationTasksFromProductBoardItem: ProductBoardItemObj;
  removeKpi: KpiObj;
  removeLaunch: LaunchObj;
  removeLaunchConnections: LaunchObj;
  removeLaunchModule: DeleteResponse;
  removeLaunchPhase: LaunchObj;
  removeLaunchSection: LaunchObj;
  removeNotificationChannel: NotificationChannelObj;
  removeObjective: ObjectiveObj;
  removeOrganization: OrganizationObj;
  removeOrganizationPhase: Array<PhaseObj>;
  removeOrganizationStage: OrganizationObj;
  removeProductBoardItemDependency: RemoveProductBoardItemDependencyResultObj;
  removeSurvey: SurveyObj;
  removeTagFromTask: Array<TaskObj>;
  removeTagFromTestimonial: Array<TestimonialObj>;
  removeTemplate: TemplateObj;
  removeUserFromIntegration: Integration;
  removeUserFromOrganization: OrganizationObj;
  requestApproveAsset: Array<ApproveAssetResponseObj>;
  requestUserReviews?: Maybe<Scalars['Boolean']>;
  resendWelcomeMail: Scalars['Boolean'];
  roadmapToInsightsMappingSetting: OrganizationObj;
  saveFailedCsvUpload: Scalars['Boolean'];
  saveInsightsSummary: InsightsSavedSummaryObj;
  scrapeData: Scalars['String'];
  selectInsightIntegrationItems: Scalars['Boolean'];
  selectIntegrationProject: IntegrationProjectObj;
  sendDesktopLinkEmail: Scalars['Boolean'];
  sendSurvey: SurveyObj;
  sendTestMail: Scalars['Boolean'];
  setNewPassword: LoginResponseObj;
  signupDemoAccountWithPassword: Scalars['Boolean'];
  signupWithGoogle: LoginResponseObj;
  signupWithPassword: LoginResponseObj;
  similarWebCron?: Maybe<Scalars['Boolean']>;
  startFreeTrial: StripeSubscriptionObj;
  summarizeAllInsights: Scalars['Boolean'];
  summarizeAllInsightsOfOrganization: Scalars['Boolean'];
  summarizeInsight: InsightObj;
  swapModuleSection: LaunchObj;
  toggleLaunchPhaseApproval: LaunchObj;
  toggleLaunchPrivate: Scalars['Boolean'];
  toggleModuleLock: LockingDetailsObj;
  translate: Scalars['String'];
  turnFeedbackPostIntoProductBoardItem: ProductBoardItemObj;
  updateAiPrompt: AiPromptObj;
  updateAnnouncement: AnnouncementObj;
  updateAnnouncementsRecipients: AnnouncementObj;
  updateApprovalRequestStatus: LaunchObj;
  updateApprovalStatus: LaunchObj;
  updateApproverInAsset: AssetObj;
  updateAsset: AssetObj;
  updateBattleCardNewsCron: Scalars['Boolean'];
  updateBattleCardRSSFeedCron: Scalars['Boolean'];
  updateBattleCardScreenshotsCron: Scalars['Boolean'];
  updateCDPAccount: CdpAccountObj;
  updateCDPContact: CdpContactObj;
  updateCDPSyncStatus: Scalars['Boolean'];
  updateCalendarPublicPageSettings: OrganizationObj;
  updateChannel: ChannelObj;
  updateChannelTimeframe: ChannelTimeframeObj;
  updateChecklist: ChecklistObj;
  updateComment: CommentObj;
  updateCompany: CompanyObj;
  updateCompetitiveIntelligenceFeature: CompetitiveIntelligenceFeatureObj;
  updateCopilotOptions: LaunchObj;
  updateCopywriteV2Favorites: CopywriteV2FavoriteObj;
  updateCustomerEmail: Scalars['String'];
  updateFeatureTableCategory: FeatureTableCategoryObj;
  updateFeedbackBoard: FeedbackBoardDto;
  updateFeedbackComment: FeedbackCommentDto;
  updateFeedbackCommentAsAdmin: FeedbackCommentDto;
  updateFeedbackCustomColumn: FeedbackCustomColumnDto;
  updateFeedbackPost: FeedbackPostDto;
  updateFeedbackPostAsAdmin: FeedbackPostDto;
  updateFeedbackPostPublic: FeedbackPostDto;
  updateFeedbackUser: FeedbackUserDto;
  updateInsight: InsightObj;
  updateInsightIntegration: InsightIntegrationObj;
  updateInsightsGeneratedItem: InsightsGeneratedItemObj;
  updateInsightsTrendItem: InsightsTrendItemObj;
  updateLaunchDetails: LaunchObj;
  updateLaunchLaunchType: LaunchObj;
  updateLaunchModuleApprovalStatus: LaunchModuleObj;
  updateLaunchModuleDetails: Array<LaunchModuleObj>;
  updateLaunchModuleUserInput: LaunchModuleObj;
  updateLaunchPhase: LaunchObj;
  updateLaunchPublicPageConfig: LaunchObj;
  updateLaunchViewer: LaunchObj;
  updateMarketingInsightsSummary: InsightsMarketingSummaryObj;
  updateMeasurementIntegrationsMetric: MeasurementIntegrationMetricObj;
  updateMessageGroup: MessageGroupObj;
  updateMessageLibrary: MessagingLibraryObj;
  updateMilestone: MilestoneObj;
  updateOrganization: OrganizationObj;
  updateOrganizationExternalPageReleaseNotesSettings: OrganizationObj;
  updateOrganizationExternalPageSettings: OrganizationObj;
  updateOrganizationPhase: PhaseObj;
  updatePaymentMethod: Scalars['String'];
  updatePendingFeatureTable: Scalars['Boolean'];
  updatePersona: PersonaDto;
  updatePersonaDemographicsCategory: PersonaDemographicsCategoryDto;
  updatePersonaNote: PersonaNoteDto;
  updateProductBoardCustomColumn: ProductBoardCustomColumnDto;
  updateProductBoardFactor: ProductBoardFactorDto;
  updateProductBoardItem: ProductBoardItemObj;
  updateProductBoardItemsView: ProductBoardItemsViewObj;
  updateProductBoardRelease: ProductBoardReleaseObj;
  updateProductBoardRoadmap: ProductBoardRoadmapObj;
  updateProductBoardStatus: ProductBoardStatusObj;
  updateProductGapsAdditionalFilter: Scalars['Boolean'];
  updateProductGapsGenerationStatus: Scalars['Boolean'];
  updateProductInsightsSummary: InsightsProductSummaryObj;
  updatePublicPage: PublicPageObj;
  updateReleaseNote: ReleaseNoteObj;
  updateRetro: RetroObj;
  updateRoadmapsPublicPagesSettings: OrganizationObj;
  updateSavedInsightsSummary: InsightsSavedSummaryObj;
  updateSubscription: StripeSubscriptionObj;
  updateSubscriptionInBillingManager: Scalars['Boolean'];
  updateSurvey: SurveyObj;
  updateSurveyRecipients: SurveyObj;
  updateTag: TagObj;
  updateTask: TaskObj;
  updateTemplate: TemplateObj;
  updateTemplateModule: TemplateModuleObj;
  updateTestimonial: TestimonialObj;
  updateUser: UserObj;
  updateUserInOrganization: UserInOrganizationObj;
  updateUserRolesInLaunchModule: LaunchObj;
  updateUsersInMessageGroup: MessageGroupObj;
  updateViewerToEditorInOrg: OrganizationObj;
  updateWinlossAdditionalFilter: Scalars['Boolean'];
  updateWinlossGenerationStatus: Scalars['Boolean'];
  uploadOrganizationTemplates: MultipleTemplates;
  upsertAssociation: CrmIntegrationObj;
  upvoteFeedbackPost: FeedbackPostDto;
  upvoteFeedbackPostAsAdmin: FeedbackPostDto;
  upvoteFeedbackPostPublic: FeedbackPostDto;
  validateOrganizationExternalPageDomain: OrganizationObj;
  validatePublicPageDomain: PublicPageObj;
  verifyEmailSubscription: Scalars['Boolean'];
  verifyEmailToken: Scalars['Boolean'];
};


export type MutationMbChangeProductInSubscriptionArgs = {
  newPriceIds: Array<Scalars['String']>;
};


export type MutationMbCheckoutUrlArgs = {
  frequency: Scalars['String'];
  priceIds: Array<Scalars['String']>;
  quantity: Scalars['Float'];
};


export type MutationMbCreateSubscriptionArgs = {
  frequency: Scalars['String'];
  priceIds: Array<Scalars['String']>;
  quantity: Scalars['Float'];
};


export type MutationMbManageUsingMapleForOrganizationArgs = {
  organizationId: Scalars['String'];
};


export type MutationMBarchiveCusomerInMapleArgs = {
  mapleBillingCustomerId: Scalars['String'];
};


export type MutationAiLaunchCreateNotificationArgs = {
  launchId: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationAbortAccountSyncArgs = {
  abort: Scalars['Boolean'];
  crm: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationAbortCompetitorsExtractionArgs = {
  abort: Scalars['Boolean'];
  crm: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationAbortContactSyncArgs = {
  abort: Scalars['Boolean'];
  crm: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationAbortDealSyncArgs = {
  abort: Scalars['Boolean'];
  crm: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationAbortIdeaExtractionArgs = {
  abort: Scalars['Boolean'];
  crm: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationAbortOwnerSyncArgs = {
  abort: Scalars['Boolean'];
  crm: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationAddApproversToLaunchPhaseArgs = {
  input: AddLaunchPhaseApproversInput;
};


export type MutationAddApproversToOrganizationPhaseArgs = {
  input: AddPhaseApproversInput;
};


export type MutationAddLaunchConnectionsArgs = {
  input: AddLaunchConnectionsInput;
};


export type MutationAddLaunchPhaseArgs = {
  input: AddLaunchPhaseInput;
};


export type MutationAddNewUserToOrganizationArgs = {
  input: CreateNewUserInOrganizationInput;
};


export type MutationAddOrganizationPhaseArgs = {
  input: AddPhaseInput;
};


export type MutationAddProductBoardItemDependencyArgs = {
  input: AddProductBoardItemDependencyInput;
};


export type MutationAddSectionInLaunchArgs = {
  input: UpdateLaunchSectionsInput;
};


export type MutationAddTagToTaskArgs = {
  input: AssignTagToTasksInput;
};


export type MutationAddTagToTestimonialArgs = {
  input: UpdateTagToTestimonialsInput;
};


export type MutationAdminCreateLaunchFromTemplatesArgs = {
  organizationId: Scalars['String'];
};


export type MutationAdminCreateOrganizationArgs = {
  input: AdminCreateOrganizationInput;
};


export type MutationAdminCreateTemplateArgs = {
  input: CreateTemplateInput;
};


export type MutationAdminUpdateOrganizationArgs = {
  input: AdminUpdateOrganizationInput;
};


export type MutationAdminUpdateTemplateArgs = {
  input: UpdateTemplateInput;
};


export type MutationAdminUpdateTemplateModuleArgs = {
  input: UpdateTemplateModuleInput;
};


export type MutationAdminUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationAdminVerifyEmailArgs = {
  email: Scalars['String'];
};


export type MutationAskForDemoArgs = {
  input: AskForDemoInput;
};


export type MutationAssignTagToReleaseNoteArgs = {
  input: UpdateReleaseNoteTagInput;
};


export type MutationAssignTagsToLaunchesArgs = {
  input: AssignTagsToEntitiesInput;
};


export type MutationAttachIntegrationTasksToProductBoardItemArgs = {
  input: AttachIntegrationTasksToProductBoardItemInput;
};


export type MutationAttachTagToFeedbackPostArgs = {
  input: UpdateTagsOfFeedbackPostInput;
};


export type MutationAttachTagsToFeedbackPostAsAdminArgs = {
  input: UpdateTagsOfFeedbackPostInput;
};


export type MutationAttachTagsToFeedbackPostsAsAdminArgs = {
  input: UpdateTagsOfFeedbackPostsInput;
};


export type MutationAttachTagsToInsightsArgs = {
  input: UpdateInsightsTagsInput;
};


export type MutationAutoInsightsTaggingSettingArgs = {
  enable: Scalars['Boolean'];
};


export type MutationBlockOrganizationArgs = {
  block: Scalars['Boolean'];
  email: Scalars['String'];
};


export type MutationCancelSubscriptionArgs = {
  subscriptionId: Scalars['String'];
};


export type MutationCheckUserExistsArgs = {
  email: Scalars['String'];
};


export type MutationConfigureHubspotCrmIntegrationArgs = {
  input: ConfigureHubspotCrmIntegrationInput;
};


export type MutationConfigureMicrosoftDynamicsCrmIntegrationArgs = {
  input: ConfigureMicrosoftDynamicsCrmIntegrationInput;
};


export type MutationConfigureSalesforceCrmIntegrationArgs = {
  input: ConfigureSalesforceCrmIntegrationInput;
};


export type MutationConfigureWinlossHubspotCrmIntegrationArgs = {
  input: ConfigureWinlossHubspotCrmIntegrationInput;
};


export type MutationConfigureWinlossSalesforceCrmIntegrationArgs = {
  input: ConfigureWinLossSalesforceCrmIntegrationInput;
};


export type MutationConnectProductBoardItemsToLaunchArgs = {
  launchId: Scalars['String'];
  productBoardItemsIds: Array<Scalars['String']>;
};


export type MutationContextualChatArgs = {
  input: ContextualChatDto;
};


export type MutationCopyPersonaArgs = {
  input: CopyPersonaInput;
};


export type MutationCopywriteGenerationArgs = {
  assetType: Scalars['String'];
  deliverableFormat: Scalars['String'];
  exampleDeliverables: Scalars['String'];
  finalPrompt: Scalars['String'];
  llm: Scalars['String'];
  messaging: Scalars['String'];
  organizationName: Scalars['String'];
  productDescription: Scalars['String'];
  productName: Scalars['String'];
  tone: Scalars['String'];
};


export type MutationCreateAiPromptArgs = {
  prompt: AiPromptInput;
};


export type MutationCreateAmplitudeIntegrationArgs = {
  password: Scalars['String'];
  username: Scalars['String'];
};


export type MutationCreateAnnouncementArgs = {
  input: CreateAnnouncementInput;
};


export type MutationCreateAssetArgs = {
  input: CreateAssetInput;
};


export type MutationCreateCdpAccountArgs = {
  input: CdpAccountCreateInput;
};


export type MutationCreateCdpContactArgs = {
  input: CdpContactCreateInput;
};


export type MutationCreateCdpDealArgs = {
  input: CdpDealCreateInput;
};


export type MutationCreateCdpOwnerArgs = {
  input: CdpOwnerCreateInput;
};


export type MutationCreateChannelArgs = {
  input: CreateChannelInput;
};


export type MutationCreateChannelTimeframeArgs = {
  input: CreateChannelTimeframeInput;
};


export type MutationCreateChecklistArgs = {
  input?: Maybe<CreateChecklistInput>;
};


export type MutationCreateCheckoutLinkArgs = {
  priceId: Scalars['String'];
  quantity: Scalars['Float'];
};


export type MutationCreateCheckoutLinkV2Args = {
  input: StripeCheckoutLinkV2Input;
};


export type MutationCreateCheckoutLinkV3Args = {
  input: StripeCheckoutLinkV3Input;
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type MutationCreateCompanyArgs = {
  companyName?: Maybe<Scalars['String']>;
  companyUrl: Scalars['String'];
  launchId?: Maybe<Scalars['String']>;
};


export type MutationCreateCompetitiveIntelligenceFeatureArgs = {
  input: CreateCompetitiveIntelligenceFeaturesInput;
};


export type MutationCreateCompletionArgs = {
  input: CreateCompletionInput;
};


export type MutationCreateConfigurationArgs = {
  input: CreateExportBattlecardsConfigurationInput;
};


export type MutationCreateConfluenceDocArgs = {
  launchId?: Maybe<Scalars['String']>;
  launchModuleId?: Maybe<Scalars['String']>;
};


export type MutationCreateCopywriteV2FavoritesArgs = {
  input: CreateCopywriteV2FavoriteInput;
};


export type MutationCreateDefaultAssetsArgs = {
  input: CreateDefaultLaunchAssetsInput;
};


export type MutationCreateDefaultChannelsArgs = {
  input: CreateDefaultChannelsInput;
};


export type MutationCreateDefaultTasksArgs = {
  input: CreateDefaultLaunchTasksInput;
};


export type MutationCreateFeatureTableCategoryArgs = {
  input: CreateFeatureTableCategoryInput;
};


export type MutationCreateFeedbackBoardArgs = {
  input: CreateFeedbackBoardInput;
};


export type MutationCreateFeedbackCommentArgs = {
  input: CreateFeedbackCommentInput;
};


export type MutationCreateFeedbackCommentAsAdminArgs = {
  input: CreateFeedbackCommentInput;
};


export type MutationCreateFeedbackCommentPublicArgs = {
  input: CreateFeedbackCommentInput;
  publicPageId: Scalars['String'];
};


export type MutationCreateFeedbackCustomColumnArgs = {
  input: CreateFeedbackCustomColumnInput;
};


export type MutationCreateFeedbackPostArgs = {
  input: CreateFeedbackPostInput;
};


export type MutationCreateFeedbackPostAsAdminArgs = {
  input: CreateFeedbackPostAsAdminInput;
};


export type MutationCreateFeedbackPostPublicArgs = {
  input: CreateFeedbackPostInput;
  publicPageId: Scalars['String'];
};


export type MutationCreateFeedbackPostViewArgs = {
  input: CreateFeedbackPostsViewInput;
};


export type MutationCreateFeedbackPostsAsAdminArgs = {
  input: CreateFeedbackPostsAsAdminInput;
};


export type MutationCreateFeedbackUserArgs = {
  input: CreateFeedbackUserInput;
};


export type MutationCreateGoogleDocArgs = {
  launchId?: Maybe<Scalars['String']>;
  launchModuleId?: Maybe<Scalars['String']>;
};


export type MutationCreateGoogleSlideArgs = {
  launchId?: Maybe<Scalars['String']>;
  launchModuleId?: Maybe<Scalars['String']>;
};


export type MutationCreateInsightArgs = {
  input?: Maybe<CreateInsightInput>;
};


export type MutationCreateInsightIntegrationArgs = {
  input: CreateInsightIntegrationInput;
};


export type MutationCreateInsightsViewArgs = {
  input: CreateInsightsViewInput;
};


export type MutationCreateIntegrationArgs = {
  input: CreateIntegrationInput;
};


export type MutationCreateLaunchArgs = {
  input: CreateLaunchInput;
};


export type MutationCreateLaunchModuleArgs = {
  input: CreateLaunchModuleInput;
};


export type MutationCreateLaunchSectionArgs = {
  input: CreateOrRemoveLaunchSectionInput;
};


export type MutationCreateLaunchTypeArgs = {
  input: CreateLaunchTypeInput;
};


export type MutationCreateMeasurementIntegrationsMetricArgs = {
  input: CreateMeasurementIntegrationMetricInput;
};


export type MutationCreateMessageGroupArgs = {
  input: CreateMessageGroupInput;
};


export type MutationCreateMilestoneArgs = {
  input: CreateMilestoneInput;
};


export type MutationCreateMixpanelIntegrationArgs = {
  password: Scalars['String'];
  projectId: Scalars['String'];
  username: Scalars['String'];
};


export type MutationCreateNonUserArgs = {
  email: Scalars['String'];
};


export type MutationCreateOrUpdateCopysmithAiFavoriteArgs = {
  input: CopysmithAiFavoriteInput;
};


export type MutationCreateOrUpdateKpiArgs = {
  input: UpdateKpiInput;
};


export type MutationCreateOrUpdateObjectivesArgs = {
  input: UpdateObjectiveInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateOrganizationStageArgs = {
  name: Scalars['String'];
};


export type MutationCreatePersonaArgs = {
  input?: Maybe<CreatePersonaInput>;
};


export type MutationCreatePersonaDemographicsCategoryArgs = {
  input: CreatePersonaDemographicsCategoryInput;
};


export type MutationCreatePersonaNoteArgs = {
  input: CreatePersonaNoteInput;
};


export type MutationCreatePlanFromUploadedFilesArgs = {
  input: ImportLaunchFromUploadedFilesInput;
};


export type MutationCreatePlanFromUrlArgs = {
  url: Scalars['String'];
};


export type MutationCreateProductBoardCustomColumnArgs = {
  input: CreateProductBoardCustomColumnInput;
};


export type MutationCreateProductBoardFactorArgs = {
  input: CreateProductBoardFactorInput;
};


export type MutationCreateProductBoardItemArgs = {
  input: CreateProductBoardItemInput;
};


export type MutationCreateProductBoardItemsViewArgs = {
  input: CreateProductBoardItemsViewInput;
};


export type MutationCreateProductBoardReleaseArgs = {
  input: CreateProductBoardReleaseInput;
};


export type MutationCreateProductBoardRoadmapArgs = {
  input: CreateProductBoardRoadmapInput;
};


export type MutationCreateProductBoardStatusArgs = {
  input: CreateProductBoardStatusInput;
};


export type MutationCreatePublicPageArgs = {
  input: CreatePublicPageInput;
};


export type MutationCreateReleaseNoteArgs = {
  input: CreateReleaseNoteInput;
};


export type MutationCreateReleaseNotesSubscriberArgs = {
  input: CreateReleaseNotesSubscriberInput;
};


export type MutationCreateRetroArgs = {
  input: CreateRetroInput;
};


export type MutationCreateSubscriptionArgs = {
  priceId: Scalars['String'];
  quantity: Scalars['Float'];
};


export type MutationCreateSurveyArgs = {
  input: CreateSurveyInput;
};


export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


export type MutationCreateTaskArgs = {
  input: CreateTaskInput;
};


export type MutationCreateTemplateArgs = {
  input: CreateTemplateInput;
};


export type MutationCreateTemplateFromLaunchArgs = {
  input: CreateTemplateFromLaunchInput;
};


export type MutationCreateTemplateModuleArgs = {
  input: CreateTemplateModuleInput;
};


export type MutationCreateTestimonialArgs = {
  input?: Maybe<CreateTestimonialInput>;
};


export type MutationCreateTestimonialsFromInsightsArgs = {
  input: CreateTestimonialsFromInsightsInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationDeleteAnnouncementArgs = {
  id: Scalars['String'];
};


export type MutationDeleteAssetArgs = {
  id: Scalars['String'];
};


export type MutationDeleteCdpAccountsArgs = {
  accountIds: Array<Scalars['String']>;
};


export type MutationDeleteCdpContactsArgs = {
  contactIds: Array<Scalars['String']>;
};


export type MutationDeleteCdpDealsArgs = {
  dealIds: Array<Scalars['String']>;
};


export type MutationDeleteChannelArgs = {
  input: DeleteChannelInput;
};


export type MutationDeleteChannelTimeframeArgs = {
  input: DeleteChannelTimeframeInput;
};


export type MutationDeleteCompanyArgs = {
  id: Scalars['String'];
  launchId?: Maybe<Scalars['String']>;
};


export type MutationDeleteCompetitiveIntelligenceFeaturesArgs = {
  featureIds: Array<Scalars['String']>;
};


export type MutationDeleteCrmIntegrationArgs = {
  input: DeleteCrmIntegrationInput;
};


export type MutationDeleteFeatureTableCategoriesArgs = {
  categoryIds: Array<Scalars['String']>;
};


export type MutationDeleteFeedbackBoardArgs = {
  id: Scalars['String'];
};


export type MutationDeleteFeedbackCommentArgs = {
  id: Scalars['String'];
};


export type MutationDeleteFeedbackCommentAsAdminArgs = {
  id: Scalars['String'];
};


export type MutationDeleteFeedbackCustomColumnArgs = {
  id: Scalars['String'];
};


export type MutationDeleteFeedbackPostArgs = {
  id: Scalars['String'];
};


export type MutationDeleteFeedbackPostAsAdminArgs = {
  id: Scalars['String'];
};


export type MutationDeleteFeedbackPostViewArgs = {
  id: Scalars['String'];
};


export type MutationDeleteInsightArgs = {
  id: Scalars['String'];
};


export type MutationDeleteInsightIntegrationArgs = {
  id: Scalars['String'];
};


export type MutationDeleteInsightsArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationDeleteInsightsTrendItemsByTypeArgs = {
  type: Scalars['String'];
};


export type MutationDeleteInsightsViewArgs = {
  id: Scalars['String'];
};


export type MutationDeleteIntegrationArgs = {
  integrationId: Scalars['String'];
};


export type MutationDeleteMeasurementIntegrationsMetricArgs = {
  integrationMetricId: Scalars['String'];
};


export type MutationDeleteMessageGroupArgs = {
  id: Scalars['String'];
};


export type MutationDeleteMilestoneArgs = {
  input: DeleteMilestoneInput;
};


export type MutationDeletePersonaArgs = {
  input: DeletePersonaInput;
};


export type MutationDeletePersonaDemographicsCategoryArgs = {
  input: DeletePersonaDemographicsCategoryInput;
};


export type MutationDeletePersonaNoteArgs = {
  input: DeletePersonaNoteInput;
};


export type MutationDeleteProductBoardCustomColumnArgs = {
  id: Scalars['String'];
};


export type MutationDeleteProductBoardFactorArgs = {
  id: Scalars['String'];
};


export type MutationDeleteProductBoardItemsArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationDeleteProductBoardItemsViewArgs = {
  id: Scalars['String'];
};


export type MutationDeleteProductBoardReleaseArgs = {
  id: Scalars['String'];
};


export type MutationDeleteProductBoardRoadmapArgs = {
  id: Scalars['String'];
};


export type MutationDeleteProductBoardStatusArgs = {
  id: Scalars['String'];
};


export type MutationDeletePublicPageArgs = {
  id: Scalars['String'];
};


export type MutationDeleteReleaseNoteArgs = {
  id: Scalars['String'];
};


export type MutationDeleteSampleDataArgs = {
  input: DeleteSampleDataInput;
};


export type MutationDeleteSavedInsightsSummaryArgs = {
  id: Scalars['String'];
};


export type MutationDeleteTagArgs = {
  input: DeleteTagInput;
};


export type MutationDeleteTagFromReleaseNoteArgs = {
  input: UpdateReleaseNoteTagInput;
};


export type MutationDeleteTagsFromLaunchesArgs = {
  input: DeleteTagsFromEntitiesInput;
};


export type MutationDeleteTaskArgs = {
  id: DeleteTaskInput;
};


export type MutationDeleteTasksArgs = {
  input: DeleteTasksInput;
};


export type MutationDeleteTestimonialArgs = {
  id: Scalars['String'];
};


export type MutationDeleteUserRolesInLaunchModuleArgs = {
  input: RemoveUsersFromLaunchInput;
};


export type MutationDetachTagFromFeedbackPostArgs = {
  input: UpdateTagsOfFeedbackPostInput;
};


export type MutationDetachTagsFromFeedbackPostAsAdminArgs = {
  input: UpdateTagsOfFeedbackPostInput;
};


export type MutationDetachTagsFromFeedbackPostsAsAdminArgs = {
  input: UpdateTagsOfFeedbackPostsInput;
};


export type MutationDetachTagsFromInsightsArgs = {
  input: UpdateInsightsTagsInput;
};


export type MutationDisableIntegrationProjectArgs = {
  id: Scalars['String'];
};


export type MutationDismissBannerArgs = {
  banner: DisplayedBanner;
};


export type MutationDragAssetArgs = {
  input: DragAssetInput;
};


export type MutationDragOrgAssetArgs = {
  input: DragAssetInput;
};


export type MutationDragProductBoardItemArgs = {
  input: DragInput;
};


export type MutationDuplicateLaunchArgs = {
  input: DuplicateLaunchInput;
};


export type MutationDuplicateMessageGroupArgs = {
  id: Scalars['String'];
};


export type MutationDuplicateObjectiveArgs = {
  input: DuplicateObjectiveInput;
};


export type MutationDuplicateProductBoardItemArgs = {
  id: Scalars['String'];
};


export type MutationEditCustomScreenshotArgs = {
  domainsList: UpdateCompanyInput;
  id: Scalars['String'];
};


export type MutationEditRegisteredOnArgs = {
  organizationId: Scalars['String'];
};


export type MutationEditRssFeedsArgs = {
  input: UpdateCompanyInput;
};


export type MutationEmailForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationEmailResendVerificationTokenArgs = {
  input: VerifyEmailInput;
};


export type MutationEnableIntegrationProjectArgs = {
  id: Scalars['String'];
};


export type MutationEnrichAccountsArgs = {
  limit?: Maybe<Scalars['Float']>;
  organizationId: Scalars['String'];
};


export type MutationExchangeCodeForTokensConfluenceArgs = {
  code: Scalars['String'];
};


export type MutationExchangeCodeForTokensGoogleArgs = {
  code: Scalars['String'];
};


export type MutationExportBattlecardsArgs = {
  input: ExportBattlecardsInput;
};


export type MutationExportFeedbackPostsToCsvArgs = {
  filter?: Maybe<FilterFeedbackPostsInput>;
};


export type MutationExportInsightsToCsvArgs = {
  filter?: Maybe<FilterInsightsInput>;
};


export type MutationExportProductBoardItemsToCsvArgs = {
  filter?: Maybe<ProductBoardItemsFilterInput>;
};


export type MutationExportRoadmapTasksArgs = {
  input: ExportRoadmapTasksInput;
};


export type MutationExportTasksToCsvArgs = {
  filter?: Maybe<FilterTasksInput>;
};


export type MutationExportTasksToIntegrationArgs = {
  input: ExportTasksToIntegrationInput;
};


export type MutationFetchIntegrationProjectsArgs = {
  input: FetchIntegrationProjectsInput;
};


export type MutationFillOrganizationWithOnboardingDataArgs = {
  input: FillOrganizationWithOnboardingDataInput;
};


export type MutationFixInsightsProductLineTagsForAmplitudeArgs = {
  organizationId: Scalars['String'];
};


export type MutationGenerateCompanyTalkingPointsArgs = {
  additionalContext?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
};


export type MutationGenerateCompetitorCompanyMessagingSummaryArgs = {
  competitorName: Scalars['String'];
  competitorURL: Scalars['String'];
};


export type MutationGenerateCompetitorCompanyTalkingPointsArgs = {
  competitorName: Scalars['String'];
  competitorURL: Scalars['String'];
};


export type MutationGenerateCopyUsingSummaryArgs = {
  input: GenerateCopyUsingSummaryInput;
};


export type MutationGenerateCopysmithAiContentV2Args = {
  input: CopysmithAiPromptInput;
};


export type MutationGenerateCopywriteV2CampaignContentArgs = {
  input: CopywriteV2CampaignPromptInput;
};


export type MutationGenerateCopywriteV2TemplateContentArgs = {
  input: CopywriteV2TemplatePromptInput;
};


export type MutationGenerateFeatureTableArgs = {
  input: GenerateFeatureTableInput;
};


export type MutationGenerateGrowthToolCompanyTalkingPointsArgs = {
  companyName: Scalars['String'];
  companyURL?: Maybe<Scalars['String']>;
  competitorName: Scalars['String'];
  competitorURL: Scalars['String'];
};


export type MutationGenerateIdeasFromAllItemsArgs = {
  feedbackBoardId: Scalars['String'];
  limit?: Maybe<Scalars['Float']>;
  organizationId: Scalars['String'];
};


export type MutationGenerateIdeasUplevelArgs = {
  organizationId: Scalars['String'];
};


export type MutationGenerateIntegrationCreateUrlArgs = {
  input: GenerateIntegrationCreateUrlInput;
};


export type MutationGenerateIntegrationJoinUrlArgs = {
  input: GenerateIntegrationJoinUrlInput;
};


export type MutationGenerateJiraTicketDetailsFromProductBoardItemArgs = {
  productBoardItemId: Scalars['String'];
};


export type MutationGenerateMarketingInsightsSummaryArgs = {
  additionalContext?: Maybe<Scalars['String']>;
  insightsFilter?: Maybe<FilterInsightsInput>;
};


export type MutationGeneratePersonaInfoArgs = {
  input: GeneratePersonaInfoInput;
};


export type MutationGenerateProductInsightsSummaryArgs = {
  additionalContext?: Maybe<Scalars['String']>;
  insightsFilter?: Maybe<FilterInsightsInput>;
};


export type MutationGenerateReleaseNoteFromProductRoadmapItemsArgs = {
  productRoadmapItemIds: Array<Scalars['String']>;
};


export type MutationGenerateSummaryUsingAiArgs = {
  companyName: Scalars['String'];
};


export type MutationGenerateTagsForAllInsightsInOrgArgs = {
  limit?: Maybe<Scalars['Float']>;
  noFilter?: Maybe<Scalars['Boolean']>;
};


export type MutationGenerateTagsForFeedbackPostsArgs = {
  limit?: Maybe<Scalars['Float']>;
  organizationId: Scalars['String'];
};


export type MutationGenerateTagsForInsightArgs = {
  id: Scalars['String'];
};


export type MutationGenerateWinlossSummaryArgs = {
  filter?: Maybe<FilterWinlossTableInput>;
  sort?: Maybe<SortWinlossTableInput>;
};


export type MutationGetExpertHelpArgs = {
  input: LaunchModuleHelpInput;
};


export type MutationImportAllClariCopilotInsightIntegrationItemsArgs = {
  filter: InsightIntegrationItemsFilterInput;
  options: ImportAllInsightIntegrationItemsOptionsInput;
};


export type MutationImportAllGongInsightIntegrationItemsArgs = {
  filter: InsightIntegrationItemsFilterInput;
  options: ImportAllInsightIntegrationItemsOptionsInput;
};


export type MutationImportAllIntercomInsightIntegrationItemsArgs = {
  filter: IntercomInsightIntegrationItemsFilterInput;
  options: ImportAllInsightIntegrationItemsOptionsInput;
};


export type MutationImportAllSlackInsightIntegrationItemsArgs = {
  filter: SlackInsightIntegrationItemsFilterInput;
  options: ImportAllInsightIntegrationItemsOptionsInput;
};


export type MutationImportAllZendeskInsightIntegrationItemsArgs = {
  filter: ZendeskInsightIntegrationItemsFilterInput;
  options: ImportAllInsightIntegrationItemsOptionsInput;
};


export type MutationImportAllZoomInsightIntegrationItemsArgs = {
  filter: InsightIntegrationItemsFilterInput;
  options: ImportAllInsightIntegrationItemsOptionsInput;
};


export type MutationImportCsvInsightsForDoceboArgs = {
  createdBy: Scalars['String'];
  limit?: Maybe<Scalars['Float']>;
  organizationId: Scalars['String'];
};


export type MutationImportFeedbackPostsFromCsvArgs = {
  input: ImportFeedbackPostsFromCsvInput;
};


export type MutationImportIdeasForAmplitudeArgs = {
  feedbackBoardId: Scalars['String'];
  limit?: Maybe<Scalars['Float']>;
  organizationId: Scalars['String'];
};


export type MutationImportInsightsFromCsvArgs = {
  input: ImportInsightsFromCsvInput;
};


export type MutationImportProductBoardItemsFromCsvArgs = {
  input: ImportProductBoardItemsFromCsvInput;
};


export type MutationImportProductBoardItemsFromIntegrationArgs = {
  input: ImportProductBoardItemsFromIntegrationInput;
};


export type MutationImportTasksFromCsvArgs = {
  input: ImportTasksFromCsvInput;
};


export type MutationImportTasksFromIntegrationArgs = {
  input: ImportTasksFromIntegrationInput;
};


export type MutationLinkSalesforceObjectToOrganizationArgs = {
  competitorFieldType: Scalars['String'];
  competitorObjectName: Scalars['String'];
  dealNotesFieldName?: Maybe<Scalars['String']>;
  lostNotesFieldName?: Maybe<Scalars['String']>;
};


export type MutationLogInFeedbackUserArgs = {
  input: LogInInput;
};


export type MutationLogInFeedbackUserWithGoogleArgs = {
  code: Scalars['String'];
};


export type MutationLoginAsUserTokenArgs = {
  email: Scalars['String'];
};


export type MutationLoginWithGoogleArgs = {
  code: Scalars['String'];
};


export type MutationLoginWithPasswordArgs = {
  input: LogInInput;
};


export type MutationLoginWithSsoArgs = {
  input: LoginWithSsoInput;
};


export type MutationMapIntegrationProjectColumnsArgs = {
  input: MapIntegrationProjectColumnsInput;
};


export type MutationModifyRegisteredOnArgs = {
  limit?: Maybe<Scalars['Float']>;
  organizationId: Scalars['String'];
};


export type MutationMoveLaunchToCustomPhaseArgs = {
  launchId: Scalars['String'];
  phaseId: Scalars['String'];
};


export type MutationMoveLaunchToNextPhaseArgs = {
  force: Scalars['Boolean'];
  launchId: Scalars['String'];
};


export type MutationMoveLaunchToPrevPhaseArgs = {
  launchId: Scalars['String'];
};


export type MutationMoveProductBoardItemArgs = {
  input: MoveProductBoardItemInput;
};


export type MutationPublicApproveAssetsArgs = {
  input: ApproveAssetInput;
};


export type MutationPublicApproveModulesArgs = {
  input: PublicApproveModuleInput;
};


export type MutationPublicToggleLaunchPhaseApprovalArgs = {
  input: PublicLaunchPhaseApprovalInput;
};


export type MutationReSelectIntegrationProjectArgs = {
  integrationProjectId: Scalars['String'];
};


export type MutationReSelectIntegrationTaskArgs = {
  integrationTaskId: Scalars['String'];
};


export type MutationRefreshIntegrationProjectsArgs = {
  integrationResourceId: Scalars['String'];
};


export type MutationRegisterNotificationChannelArgs = {
  input: RegisterNotificationChannelInput;
};


export type MutationRemoveApproversFromLaunchPhaseArgs = {
  input: RemoveLaunchPhaseApproversInput;
};


export type MutationRemoveApproversFromOrganizationPhaseArgs = {
  input: RemovePhaseApproversInput;
};


export type MutationRemoveCommentArgs = {
  id: Scalars['String'];
};


export type MutationRemoveFeedbackPostPublicArgs = {
  postId: Scalars['String'];
  publicPageId: Scalars['String'];
};


export type MutationRemoveFeedbackPostUpvoteArgs = {
  postId: Scalars['String'];
};


export type MutationRemoveFeedbackPostUpvoteAsAdminArgs = {
  postId: Scalars['String'];
};


export type MutationRemoveFeedbackPostUpvotePublicArgs = {
  postId: Scalars['String'];
  publicPageId: Scalars['String'];
};


export type MutationRemoveIntegrationArgs = {
  id: Scalars['String'];
};


export type MutationRemoveIntegrationTasksFromProductBoardItemArgs = {
  input: AttachIntegrationTasksToProductBoardItemInput;
};


export type MutationRemoveKpiArgs = {
  id: Scalars['String'];
};


export type MutationRemoveLaunchArgs = {
  id: Scalars['String'];
};


export type MutationRemoveLaunchConnectionsArgs = {
  input: AddLaunchConnectionsInput;
};


export type MutationRemoveLaunchModuleArgs = {
  id: Scalars['String'];
};


export type MutationRemoveLaunchPhaseArgs = {
  launchId: Scalars['String'];
  phaseId: Scalars['String'];
};


export type MutationRemoveLaunchSectionArgs = {
  input: CreateOrRemoveLaunchSectionInput;
};


export type MutationRemoveNotificationChannelArgs = {
  id: Scalars['String'];
};


export type MutationRemoveObjectiveArgs = {
  id: Scalars['String'];
};


export type MutationRemoveOrganizationPhaseArgs = {
  ids: Array<Scalars['String']>;
};


export type MutationRemoveOrganizationStageArgs = {
  stageId: Scalars['String'];
};


export type MutationRemoveProductBoardItemDependencyArgs = {
  input: RemoveProductBoardItemDependencyInput;
};


export type MutationRemoveSurveyArgs = {
  id: Scalars['String'];
};


export type MutationRemoveTagFromTaskArgs = {
  input: DeleteTagFromTasksInput;
};


export type MutationRemoveTagFromTestimonialArgs = {
  input: UpdateTagToTestimonialsInput;
};


export type MutationRemoveTemplateArgs = {
  id: Scalars['String'];
};


export type MutationRemoveUserFromIntegrationArgs = {
  id: Scalars['String'];
};


export type MutationRemoveUserFromOrganizationArgs = {
  userId: Scalars['String'];
};


export type MutationRequestApproveAssetArgs = {
  input: RequestApproveAssetInput;
};


export type MutationRequestUserReviewsArgs = {
  companyName: Scalars['String'];
};


export type MutationResendWelcomeMailArgs = {
  userId: Scalars['String'];
};


export type MutationRoadmapToInsightsMappingSettingArgs = {
  enable: Scalars['Boolean'];
};


export type MutationSaveFailedCsvUploadArgs = {
  input: SaveFailedCsvUploadInput;
};


export type MutationSaveInsightsSummaryArgs = {
  input: SaveInsightsSummaryInput;
};


export type MutationScrapeDataArgs = {
  refresh?: Maybe<Scalars['Boolean']>;
  url: Scalars['String'];
};


export type MutationSelectInsightIntegrationItemsArgs = {
  input: SelectInsightIntegrationItemsInput;
};


export type MutationSelectIntegrationProjectArgs = {
  input: SelectIntegrationProjectInput;
};


export type MutationSendSurveyArgs = {
  input: SendSurveyInput;
};


export type MutationSendTestMailArgs = {
  email: Scalars['String'];
};


export type MutationSetNewPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationSignupDemoAccountWithPasswordArgs = {
  input: CreateDemoOrganizationInput;
};


export type MutationSignupWithGoogleArgs = {
  code: Scalars['String'];
};


export type MutationSignupWithPasswordArgs = {
  input: RegisterUserInput;
};


export type MutationSummarizeAllInsightsArgs = {
  organizationId: Scalars['String'];
};


export type MutationSummarizeAllInsightsOfOrganizationArgs = {
  organizationId: Scalars['String'];
};


export type MutationSummarizeInsightArgs = {
  id: Scalars['String'];
};


export type MutationSwapModuleSectionArgs = {
  input: SwapModuleSectionInput;
};


export type MutationToggleLaunchPhaseApprovalArgs = {
  input: ToggleLaunchPhaseApprovalInput;
};


export type MutationToggleLaunchPrivateArgs = {
  input: ToggleLaunchPrivateInput;
};


export type MutationToggleModuleLockArgs = {
  input: ToggleModuleLockInput;
};


export type MutationTranslateArgs = {
  input: TranslateInput;
};


export type MutationTurnFeedbackPostIntoProductBoardItemArgs = {
  input: TurnFeedbackPostIntoProductBoardItemInput;
};


export type MutationUpdateAiPromptArgs = {
  prompt: AiPromptInput;
};


export type MutationUpdateAnnouncementArgs = {
  input: UpdateAnnouncementInput;
};


export type MutationUpdateAnnouncementsRecipientsArgs = {
  input: UpdateAnnouncementUsersInput;
};


export type MutationUpdateApprovalRequestStatusArgs = {
  input: UpdateApprovalRequestStatusInput;
};


export type MutationUpdateApprovalStatusArgs = {
  input: UpdateLaunchApprovalStatusInput;
};


export type MutationUpdateApproverInAssetArgs = {
  input: UpdateAssetApproverInput;
};


export type MutationUpdateAssetArgs = {
  input: UpdateAssetInput;
};


export type MutationUpdateCdpAccountArgs = {
  input: CdpAccountUpdateInput;
};


export type MutationUpdateCdpContactArgs = {
  input: CdpContactUpdateInput;
};


export type MutationUpdateCdpSyncStatusArgs = {
  crm: Scalars['String'];
};


export type MutationUpdateCalendarPublicPageSettingsArgs = {
  input: UpdateCalendarPublicPageSettingsInput;
};


export type MutationUpdateChannelArgs = {
  input: UpdateChannelInput;
};


export type MutationUpdateChannelTimeframeArgs = {
  input: UpdateChannelTimeframeInput;
};


export type MutationUpdateChecklistArgs = {
  input: UpdateChecklistInput;
};


export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};


export type MutationUpdateCompetitiveIntelligenceFeatureArgs = {
  input: UpdateCompetitiveIntelligenceFeaturesInput;
};


export type MutationUpdateCopilotOptionsArgs = {
  input: UpdateLaunchCopilotOptionsInput;
};


export type MutationUpdateCopywriteV2FavoritesArgs = {
  input: UpdateCopywriteV2FavoriteInput;
};


export type MutationUpdateCustomerEmailArgs = {
  email: Scalars['String'];
};


export type MutationUpdateFeatureTableCategoryArgs = {
  input: UpdateFeatureTableCategoryInput;
};


export type MutationUpdateFeedbackBoardArgs = {
  input: UpdateFeedbackBoardInput;
};


export type MutationUpdateFeedbackCommentArgs = {
  input: UpdateFeedbackCommentInput;
};


export type MutationUpdateFeedbackCommentAsAdminArgs = {
  input: UpdateFeedbackCommentInput;
};


export type MutationUpdateFeedbackCustomColumnArgs = {
  input: UpdateFeedbackCustomColumnInput;
};


export type MutationUpdateFeedbackPostArgs = {
  input: UpdateFeedbackPostInput;
};


export type MutationUpdateFeedbackPostAsAdminArgs = {
  input: UpdateFeedbackPostAsAdminInput;
};


export type MutationUpdateFeedbackPostPublicArgs = {
  input: UpdateFeedbackPostInput;
  publicPageId: Scalars['String'];
};


export type MutationUpdateFeedbackUserArgs = {
  input: UpdateFeedbackUserInput;
};


export type MutationUpdateInsightArgs = {
  input: UpdateInsightInput;
};


export type MutationUpdateInsightIntegrationArgs = {
  input: UpdateInsightIntegrationInput;
};


export type MutationUpdateInsightsGeneratedItemArgs = {
  input: UpdateInsightGeneratedItemInput;
};


export type MutationUpdateInsightsTrendItemArgs = {
  input: UpdateInsightTrendItemInput;
};


export type MutationUpdateLaunchDetailsArgs = {
  input: UpdateLaunchDetailsInput;
};


export type MutationUpdateLaunchLaunchTypeArgs = {
  input: UpdateLaunchLaunchTypeInput;
};


export type MutationUpdateLaunchModuleApprovalStatusArgs = {
  input: UpdateLaunchModuleApprovalStatusInput;
};


export type MutationUpdateLaunchModuleDetailsArgs = {
  input: UpdateLaunchModuleDetailsInput;
};


export type MutationUpdateLaunchModuleUserInputArgs = {
  input: UpdateLaunchModuleUserInputInput;
};


export type MutationUpdateLaunchPhaseArgs = {
  input: UpdateLaunchPhaseInput;
};


export type MutationUpdateLaunchPublicPageConfigArgs = {
  input: UpdateLaunchPublicPageConfigInput;
};


export type MutationUpdateLaunchViewerArgs = {
  launchId: Scalars['String'];
};


export type MutationUpdateMarketingInsightsSummaryArgs = {
  input: UpdateInsightsMarketingSummaryInput;
};


export type MutationUpdateMeasurementIntegrationsMetricArgs = {
  input: UpdateMeasurementIntegrationMetricInput;
};


export type MutationUpdateMessageGroupArgs = {
  input: UpdateMessageGroupInput;
};


export type MutationUpdateMessageLibraryArgs = {
  input: UpdateMessagingLibraryInput;
};


export type MutationUpdateMilestoneArgs = {
  input: UpdateMilestoneInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationExternalPageReleaseNotesSettingsArgs = {
  input: UpdateOrganizationExternalPageReleaseNotesInput;
};


export type MutationUpdateOrganizationExternalPageSettingsArgs = {
  input: UpdateOrganizationExternalPageInput;
};


export type MutationUpdateOrganizationPhaseArgs = {
  input: UpdatePhaseInput;
};


export type MutationUpdatePersonaArgs = {
  input: UpdatePersonaInput;
};


export type MutationUpdatePersonaDemographicsCategoryArgs = {
  input: UpdatePersonaDemographicsCategoryInput;
};


export type MutationUpdatePersonaNoteArgs = {
  input: UpdatePersonaNoteInput;
};


export type MutationUpdateProductBoardCustomColumnArgs = {
  input: UpdateProductBoardCustomColumnInput;
};


export type MutationUpdateProductBoardFactorArgs = {
  input: UpdateProductBoardFactorInput;
};


export type MutationUpdateProductBoardItemArgs = {
  input: UpdateProductBoardItemInput;
};


export type MutationUpdateProductBoardItemsViewArgs = {
  input: UpdateProductBoardItemsViewInput;
};


export type MutationUpdateProductBoardReleaseArgs = {
  input: UpdateProductBoardReleaseInput;
};


export type MutationUpdateProductBoardRoadmapArgs = {
  input: UpdateProductBoardRoadmapInput;
};


export type MutationUpdateProductBoardStatusArgs = {
  input: UpdateProductBoardStatusInput;
};


export type MutationUpdateProductGapsAdditionalFilterArgs = {
  crm: Scalars['String'];
  filter: Scalars['String'];
};


export type MutationUpdateProductGapsGenerationStatusArgs = {
  crm: Scalars['String'];
};


export type MutationUpdateProductInsightsSummaryArgs = {
  input: UpdateInsightsProductSummaryInput;
};


export type MutationUpdatePublicPageArgs = {
  input: UpdatePublicPageInput;
};


export type MutationUpdateReleaseNoteArgs = {
  input: UpdateReleaseNoteInput;
};


export type MutationUpdateRetroArgs = {
  input: UpdateRetroInput;
};


export type MutationUpdateRoadmapsPublicPagesSettingsArgs = {
  input: UpdateRoadmapsPublicPagesSettingsInput;
};


export type MutationUpdateSavedInsightsSummaryArgs = {
  input: UpdateSavedInsightsSummaryInput;
};


export type MutationUpdateSubscriptionArgs = {
  itemId: Scalars['String'];
  priceId: Scalars['String'];
  quantity: Scalars['Float'];
};


export type MutationUpdateSubscriptionInBillingManagerArgs = {
  organizationId: Scalars['String'];
};


export type MutationUpdateSurveyArgs = {
  input: UpdateSurveyInput;
};


export type MutationUpdateSurveyRecipientsArgs = {
  input: CreateSurveyRecipientsInput;
};


export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
};


export type MutationUpdateTaskArgs = {
  input: UpdateTaskInput;
};


export type MutationUpdateTemplateArgs = {
  input: UpdateTemplateInput;
};


export type MutationUpdateTemplateModuleArgs = {
  input: UpdateTemplateModuleInput;
};


export type MutationUpdateTestimonialArgs = {
  input: UpdateTestimonialInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserInOrganizationArgs = {
  input: UpdateUserInOrganizationInput;
};


export type MutationUpdateUserRolesInLaunchModuleArgs = {
  input: UpdateUsersInLaunchInput;
};


export type MutationUpdateUsersInMessageGroupArgs = {
  input: UpdateMessageGroupUsersInput;
};


export type MutationUpdateWinlossAdditionalFilterArgs = {
  crm: Scalars['String'];
  filter: Scalars['String'];
};


export type MutationUpdateWinlossGenerationStatusArgs = {
  crm: Scalars['String'];
};


export type MutationUploadOrganizationTemplatesArgs = {
  input: CreateOrganizationMultipleTemplateInput;
};


export type MutationUpsertAssociationArgs = {
  input: CreateExportBattlecardsConfigurationInput;
};


export type MutationUpvoteFeedbackPostArgs = {
  postId: Scalars['String'];
};


export type MutationUpvoteFeedbackPostAsAdminArgs = {
  postId: Scalars['String'];
};


export type MutationUpvoteFeedbackPostPublicArgs = {
  postId: Scalars['String'];
  publicPageId: Scalars['String'];
};


export type MutationValidatePublicPageDomainArgs = {
  id: Scalars['String'];
};


export type MutationVerifyEmailSubscriptionArgs = {
  emailToken: Scalars['String'];
};


export type MutationVerifyEmailTokenArgs = {
  emailToken: Scalars['String'];
};

export enum NotificationDestinations {
  EMAIL = 'EMAIL',
  MS_TEAMS = 'MS_TEAMS',
  SLACK = 'SLACK'
}

export enum NotificationSendAsTypes {
  IGNITION = 'IGNITION',
  SELF = 'SELF'
}

export enum NotificationSources {
  APP = 'APP',
  EMAIL = 'EMAIL',
  MS_TEAMS = 'MS_TEAMS',
  SLACK = 'SLACK'
}

export enum NotificationStatus {
  ON_HOLD = 'ON_HOLD',
  RUNNING = 'RUNNING'
}

export enum NotificationTokenScope {
  ORGANIZATION = 'ORGANIZATION',
  PERSONAL = 'PERSONAL'
}

export type NonUserObj = {
  __typename?: 'NonUserObj';
  avatarColor: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['String'];
};

export type NotificationChannelObj = {
  __typename?: 'NotificationChannelObj';
  accessToken: Scalars['String'];
  accessTokenOwnerId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  lastRefresedOn?: Maybe<Scalars['DateTime']>;
  organizationId: Scalars['String'];
  refreshToken?: Maybe<Scalars['String']>;
  scope: NotificationTokenScope;
  source: NotificationSources;
  validTill?: Maybe<Scalars['DateTime']>;
};

export type NotificationPreferences = {
  __typename?: 'NotificationPreferences';
  sources?: Maybe<NotificationSourcesObj>;
  types?: Maybe<NotificationTypes>;
};

export type NotificationPreferencesInput = {
  sources: NotificationSourcesInput;
  types: NotificationTypesInput;
};

export type NotificationSourcesInput = {
  APP: Scalars['Boolean'];
  EMAIL: Scalars['Boolean'];
  SLACK: Scalars['Boolean'];
};

export type NotificationSourcesObj = {
  __typename?: 'NotificationSourcesObj';
  APP?: Maybe<Scalars['Boolean']>;
  EMAIL?: Maybe<Scalars['Boolean']>;
  SLACK?: Maybe<Scalars['Boolean']>;
};

export type NotificationTypes = {
  __typename?: 'NotificationTypes';
  AI_ALERTS?: Maybe<Scalars['Boolean']>;
  EMAIL_DIGEST?: Maybe<Scalars['Boolean']>;
  STATUS_UPDATES_AND_COMMENTS?: Maybe<Scalars['Boolean']>;
  TASKS_AND_REMINDERS_NOTIFICATIONS?: Maybe<Scalars['Boolean']>;
};

export type NotificationTypesInput = {
  AI_ALERTS?: Maybe<Scalars['Boolean']>;
  EMAIL_DIGEST: Scalars['Boolean'];
  STATUS_UPDATES_AND_COMMENTS: Scalars['Boolean'];
  TASKS_AND_REMINDERS_NOTIFICATIONS: Scalars['Boolean'];
};

export enum OkrQualitativeStatus {
  COMPLETE = 'COMPLETE',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED'
}

export enum OkrType {
  LAUNCH = 'LAUNCH',
  ORGANIZATION = 'ORGANIZATION',
  PRODUCT = 'PRODUCT'
}

export enum OrganizationOrigins {
  RELEASE_NOTES = 'RELEASE_NOTES',
  ROADMAP = 'ROADMAP',
  STANDARD = 'STANDARD'
}

export enum OrganizationTypeOfCompany {
  AGENCY = 'AGENCY',
  ENTERTAINMENT = 'ENTERTAINMENT',
  LOCAL_MARKETPLACE = 'LOCAL_MARKETPLACE',
  PHYSICAL_PRODUCTS = 'PHYSICAL_PRODUCTS',
  SERVICE = 'SERVICE',
  SOFTWARE = 'SOFTWARE'
}

export type ObjectiveFilterInput = {
  assigneeIds?: Maybe<Array<Scalars['String']>>;
  endDate?: Maybe<Scalars['DateTime']>;
  launchId?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  releaseIds?: Maybe<Array<Scalars['String']>>;
  roadmapIds?: Maybe<Array<Scalars['String']>>;
  search?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  type?: Maybe<OkrType>;
};

export type ObjectiveObj = {
  __typename?: 'ObjectiveObj';
  assignee?: Maybe<UserObj>;
  createdAt: Scalars['DateTime'];
  dueDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  kpis?: Maybe<Array<KpiObj>>;
  launchId?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  releaseId?: Maybe<Scalars['String']>;
  roadmapId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<OkrType>;
};

export enum OnboardingGoal {
  COMPANIES = 'COMPANIES',
  LAUNCHES = 'LAUNCHES',
  PERSONAS = 'PERSONAS',
  ROADMAP = 'ROADMAP'
}

export type OrganizationIntegrationProjectObj = {
  __typename?: 'OrganizationIntegrationProjectObj';
  active: Scalars['Boolean'];
  integrationProjectId: Scalars['String'];
};

export type OrganizationIntegrationsQueryFilterInput = {
  productName: IntegrationProductNames;
};

export type OrganizationObj = {
  __typename?: 'OrganizationObj';
  admin: Scalars['String'];
  aiSettings?: Maybe<AiSettingsObj>;
  allowUsersFromSameDomain?: Maybe<Scalars['Boolean']>;
  appsumoInvoiceUuid?: Maybe<Scalars['String']>;
  appsumoPlanId?: Maybe<Scalars['String']>;
  appsumoUuid?: Maybe<Scalars['String']>;
  autoInsightsTaggingEnabled?: Maybe<Scalars['Boolean']>;
  billingEmailId?: Maybe<Scalars['String']>;
  billingForLaunches?: Maybe<Scalars['Float']>;
  billingVersion: Scalars['String'];
  chatGTMEnabled?: Maybe<Scalars['Boolean']>;
  companyType?: Maybe<OrganizationTypeOfCompany>;
  createdAt: Scalars['DateTime'];
  currentSubscriptionPlanName?: Maybe<Scalars['String']>;
  currentSubscriptionPlanStripePriceId?: Maybe<Scalars['String']>;
  currentUser?: Maybe<UserInOrganizationObj>;
  customerTemplateUrls?: Maybe<Array<Scalars['String']>>;
  externalPageSettings: ExternalPageSettings;
  hasCreatedFirstLaunch?: Maybe<Scalars['Boolean']>;
  hasExpiredFreeTrial?: Maybe<Scalars['Boolean']>;
  hasPaidSubscription?: Maybe<Scalars['Boolean']>;
  hasPaidSubscriptionMB?: Maybe<Scalars['Boolean']>;
  haveGtm?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  integrationProjects: Array<OrganizationIntegrationProjectObj>;
  isActive: Scalars['Boolean'];
  isDemo: Scalars['Boolean'];
  isFree: Scalars['Boolean'];
  isUnderFreeTrial?: Maybe<Scalars['Boolean']>;
  isWorkspaceConfigGenerated: Scalars['Boolean'];
  launchesPerYear?: Maybe<Scalars['String']>;
  llmToBeUsed?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  mapleBillingCustomerId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationEmailDomain?: Maybe<Scalars['String']>;
  origin?: Maybe<OrganizationOrigins>;
  peopleRange?: Maybe<Scalars['String']>;
  phases: Array<PhaseObj>;
  publicPagesSettings: PublicPagesSettingsObj;
  roadmapToInsightsMappingEnabled?: Maybe<Scalars['Boolean']>;
  sampleDataFlag: SampleDataDeleteDetailsObj;
  slug: Scalars['String'];
  stages: Array<StageObj>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  subscriptionRestrictions?: Maybe<SubscriptionRestrictionsObj>;
  users: Array<UserInOrganizationObj>;
  winlossIntegrationType?: Maybe<Scalars['String']>;
};

export type OrganizationOnboardingPersonasInput = {
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type OrganizationOnboardingProductLineTagsInput = {
  description?: Maybe<Scalars['String']>;
  label: Scalars['String'];
};

export type OrganizationUploadedTemplateObj = {
  __typename?: 'OrganizationUploadedTemplateObj';
  fileType: Scalars['String'];
  name: Scalars['String'];
  organizationId: Scalars['String'];
  path: Scalars['String'];
  userId: Scalars['String'];
};

export enum ProductBoardFactorScales {
  FLOAT = 'FLOAT',
  NUMBER = 'NUMBER',
  STAR = 'STAR'
}

export enum ProductIntegrationTasksStatus {
  AT_RISK = 'AT_RISK',
  ON_TRACK = 'ON_TRACK'
}

export type PaginatedAnnouncementObj = {
  __typename?: 'PaginatedAnnouncementObj';
  docs: Array<AnnouncementObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedAssetGroupObj = {
  __typename?: 'PaginatedAssetGroupObj';
  color?: Maybe<Scalars['String']>;
  docs: Array<AssetObj>;
  key: Scalars['String'];
  title: Scalars['String'];
};

export type PaginatedAssetGroupsObj = {
  __typename?: 'PaginatedAssetGroupsObj';
  docs: Array<PaginatedAssetGroupObj>;
  limit: Scalars['Float'];
  page: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type PaginatedAssetsObj = {
  __typename?: 'PaginatedAssetsObj';
  docs: Array<AssetObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedCdpAccountObj = {
  __typename?: 'PaginatedCDPAccountObj';
  docs: Array<CdpAccountObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedCdpContactObj = {
  __typename?: 'PaginatedCDPContactObj';
  docs: Array<CdpContactObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedCdpDealObj = {
  __typename?: 'PaginatedCDPDealObj';
  docs: Array<CdpDealObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedCdpOwnerObj = {
  __typename?: 'PaginatedCDPOwnerObj';
  docs: Array<CdpOwnerObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedCommentsObj = {
  __typename?: 'PaginatedCommentsObj';
  docs: Array<CommentObj>;
  page: Scalars['Float'];
  parentId: Scalars['String'];
  totalPages: Scalars['Float'];
};

export type PaginatedCompaniesFilterInput = {
  launchId?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  tagType?: Maybe<TagTypes>;
};

export type PaginatedCompanyGroupsFilterInput = {
  productLineTagIds?: Maybe<Array<Scalars['String']>>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};

export type PaginatedCompanyObj = {
  __typename?: 'PaginatedCompanyObj';
  docs: Array<CompanyObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedCompanyTagGroupObj = {
  __typename?: 'PaginatedCompanyTagGroupObj';
  docs: Array<CompanyTagGroup>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedCompetingCompaniesNewsArticlesObj = {
  __typename?: 'PaginatedCompetingCompaniesNewsArticlesObj';
  docs: Array<CompetitorCompanyNewsArticleObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedCrmIntegrationObjectsObj = {
  __typename?: 'PaginatedCrmIntegrationObjectsObj';
  docs: Array<CrmIntegrationObjectObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedDealsCompaniesObj = {
  __typename?: 'PaginatedDealsCompaniesObj';
  docs: Array<DealCompanyObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedDealsObj = {
  __typename?: 'PaginatedDealsObj';
  docs: Array<DealObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedDealsOwnersObj = {
  __typename?: 'PaginatedDealsOwnersObj';
  docs: Array<DealOwnerObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedFeedbackPostsByDealDigestObj = {
  __typename?: 'PaginatedFeedbackPostsByDealDigestObj';
  docs: Array<FeedbackPostsByDealDigestObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedFeedbackPostsDto = {
  __typename?: 'PaginatedFeedbackPostsDto';
  docs: Array<FeedbackPostDto>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedG2UserReviewsOutputObj = {
  __typename?: 'PaginatedG2UserReviewsOutputObj';
  docs: Array<G2UserReviewsOutput>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedGroup = {
  __typename?: 'PaginatedGroup';
  count: Scalars['Float'];
  key: Scalars['String'];
};

export type PaginatedInsightIntegrationItemsObj = {
  __typename?: 'PaginatedInsightIntegrationItemsObj';
  cursor?: Maybe<Scalars['String']>;
  docs: Array<InsightIntegrationItemObj>;
  hasNextPage: Scalars['Boolean'];
  totalDocs?: Maybe<Scalars['Int']>;
};

export type PaginatedInsightsGeneratedItemObj = {
  __typename?: 'PaginatedInsightsGeneratedItemObj';
  docs: Array<InsightsGeneratedItemObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedInsightsObj = {
  __typename?: 'PaginatedInsightsObj';
  docs: Array<InsightObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedInsightsTrendItemObj = {
  __typename?: 'PaginatedInsightsTrendItemObj';
  docs: Array<InsightsTrendItemObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedIntegrationTasks = {
  __typename?: 'PaginatedIntegrationTasks';
  docs: Array<IntegrationTaskObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedIntegrations = {
  __typename?: 'PaginatedIntegrations';
  currentPage: Scalars['Float'];
  items: Array<Integration>;
  lastPage: Scalars['Float'];
  perPage: Scalars['Float'];
  total: Scalars['Float'];
};

export type PaginatedKeywordsObj = {
  __typename?: 'PaginatedKeywordsObj';
  docs: Array<KeywordResultsOutput>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedKpiObj = {
  __typename?: 'PaginatedKpiObj';
  docs: Array<KpiObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedLaunchObj = {
  __typename?: 'PaginatedLaunchObj';
  docs: Array<LaunchObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedMessageGroupObj = {
  __typename?: 'PaginatedMessageGroupObj';
  docs: Array<MessageGroupObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedObjectiveObj = {
  __typename?: 'PaginatedObjectiveObj';
  docs: Array<ObjectiveObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedPersonasDto = {
  __typename?: 'PaginatedPersonasDto';
  docs: Array<PersonaDto>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedPersonasInput = {
  launchesIds?: Maybe<Array<Scalars['String']>>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  query?: Maybe<Scalars['String']>;
};

export type PaginatedProductBoardItemsObj = {
  __typename?: 'PaginatedProductBoardItemsObj';
  docs: Array<ProductBoardItemObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedPublicPageObj = {
  __typename?: 'PaginatedPublicPageObj';
  docs: Array<PublicPageObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedPublicPagesFilterInput = {
  isVerified?: Maybe<Scalars['Boolean']>;
  live?: Maybe<Scalars['Boolean']>;
};

export type PaginatedReleaseNoteObj = {
  __typename?: 'PaginatedReleaseNoteObj';
  docs: Array<ReleaseNoteObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedRoadmapItemsGroupsObj = {
  __typename?: 'PaginatedRoadmapItemsGroupsObj';
  docs: Array<ProductBoardItemsGroupObj>;
  limit: Scalars['Float'];
  page: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type PaginatedSurveyObj = {
  __typename?: 'PaginatedSurveyObj';
  docs: Array<SurveyObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedTagObj = {
  __typename?: 'PaginatedTagObj';
  docs: Array<TagObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedTagsFilterInput = {
  query?: Maybe<Scalars['String']>;
  types?: Maybe<Array<TagTypes>>;
};

export type PaginatedTaskObj = {
  __typename?: 'PaginatedTaskObj';
  docs: Array<TaskObj>;
  groups: Array<PaginatedGroup>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  launchId?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedTestimonialObj = {
  __typename?: 'PaginatedTestimonialObj';
  docs: Array<TestimonialObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedUsersInOrganizationObj = {
  __typename?: 'PaginatedUsersInOrganizationObj';
  docs: Array<UserInOrganizationObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedWinLossCompetitorObj = {
  __typename?: 'PaginatedWinLossCompetitorObj';
  docs: Array<WinLossCompetitorObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginatedWinLossTableObj = {
  __typename?: 'PaginatedWinLossTableObj';
  docs: Array<WinLossTableObj>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
  nextPage?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  pagingCounter?: Maybe<Scalars['Float']>;
  prevPage?: Maybe<Scalars['Float']>;
  totalDocs?: Maybe<Scalars['Float']>;
  totalPages?: Maybe<Scalars['Float']>;
};

export type PaginationInput = {
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

export type PerformanceDataFilterInput = {
  launchDateFrom?: Maybe<Scalars['DateTime']>;
  launchDateTo?: Maybe<Scalars['DateTime']>;
};

export type PersonaDemographicsCategoryDto = {
  __typename?: 'PersonaDemographicsCategoryDto';
  createdAt: Scalars['Timestamp'];
  id: Scalars['String'];
  name: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Timestamp'];
  value: Scalars['String'];
};

export type PersonaDto = {
  __typename?: 'PersonaDto';
  age: Array<Scalars['Float']>;
  avatar?: Maybe<Scalars['String']>;
  createdAt: Scalars['Timestamp'];
  createdBy: UserObj;
  demographics: Array<PersonaDemographicsCategoryDto>;
  id: Scalars['String'];
  launchesIds: Array<Scalars['String']>;
  messagingLibraryIds: Array<Scalars['String']>;
  name: Scalars['String'];
  notes: Array<PersonaNoteDto>;
  occupation: Scalars['String'];
  organizationId: Scalars['String'];
  primary: Scalars['Boolean'];
  tags: Array<TagObj>;
  updatedAt: Scalars['Timestamp'];
};

export type PersonaFilterOptionObj = {
  __typename?: 'PersonaFilterOptionObj';
  avatar?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  value: Scalars['String'];
};

export type PersonaInput = {
  id: Scalars['String'];
};

export type PersonaNoteDto = {
  __typename?: 'PersonaNoteDto';
  createdAt: Scalars['Timestamp'];
  id: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['Timestamp'];
};

export type PersonasInput = {
  launchesIds?: Maybe<Array<Scalars['String']>>;
  messagingLibraryIds?: Maybe<Array<Scalars['String']>>;
  query?: Maybe<Scalars['String']>;
};

export type PhaseObj = {
  __typename?: 'PhaseObj';
  daysAfterLaunch: Scalars['Float'];
  defaultApprovers?: Maybe<Array<DefaultApproversObj>>;
  durationInDays: Scalars['Float'];
  id: Scalars['String'];
  launchTier: LaunchTiers;
  launchTypeId: Scalars['String'];
  name: Scalars['String'];
};

export type PreferenceObj = {
  __typename?: 'PreferenceObj';
  budget?: Maybe<Scalars['Float']>;
  exclusionRules?: Maybe<ChannelRecommendationRuleObj>;
  fromDate?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  inclusionRules?: Maybe<ChannelRecommendationRuleObj>;
  inclusionType?: Maybe<MilestoneType>;
  note: Scalars['String'];
  toDate?: Maybe<Scalars['Float']>;
};

export type PreviewDefaultAssetObj = {
  __typename?: 'PreviewDefaultAssetObj';
  name?: Maybe<Scalars['String']>;
  type: AssetTypes;
};

export type PreviewDefaultChannelObj = {
  __typename?: 'PreviewDefaultChannelObj';
  channelTemplateId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  logoSrc?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  timeframes: Array<ChannelTimeframeObj>;
  type: ChannelType;
};

export type PreviewDefaultTaskObj = {
  __typename?: 'PreviewDefaultTaskObj';
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  plainDescription?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status: TaskStatusTypes;
  subtasks?: Maybe<Array<PreviewDefaultTaskObj>>;
  type?: Maybe<TaskTypes>;
};

export type PreviousConversationsDto = {
  content: Scalars['String'];
  role: Scalars['String'];
};

export type ProductBoardCustomColumnDto = {
  __typename?: 'ProductBoardCustomColumnDto';
  id: Scalars['String'];
  name: Scalars['String'];
  type: ProductBoardCustomColumnType;
};

export enum ProductBoardCustomColumnType {
  DATE = 'DATE',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT'
}

export type ProductBoardFactorDto = {
  __typename?: 'ProductBoardFactorDto';
  id: Scalars['String'];
  immutable: Scalars['Boolean'];
  name: Scalars['String'];
  organizationId: Scalars['String'];
  scale: ProductBoardFactorScales;
  updatedAt: Scalars['Timestamp'];
  weight: Scalars['Int'];
};

export type ProductBoardItemCustomColumnInput = {
  customColumnId: Scalars['String'];
  value: Scalars['String'];
};

export type ProductBoardItemCustomColumnObj = {
  __typename?: 'ProductBoardItemCustomColumnObj';
  customColumnId: Scalars['ID'];
  value: Scalars['String'];
};

export type ProductBoardItemFactorInput = {
  factorId: Scalars['String'];
  value: Scalars['Int'];
};

export type ProductBoardItemFactorObj = {
  __typename?: 'ProductBoardItemFactorObj';
  factorId: Scalars['ID'];
  immutable: Scalars['Boolean'];
  value: Scalars['Float'];
};

export type ProductBoardItemFilterOptionsObj = {
  __typename?: 'ProductBoardItemFilterOptionsObj';
  CDPAccountOptions: Array<CdpAccountFilterOptionObj>;
  accountIndustries: Array<Scalars['String']>;
  accountTypes: Array<Scalars['String']>;
  assigneeOptions: Array<UserFilterOptionObj>;
  competitorOptions: Array<CompetitorCompanyFilterOptionObj>;
  dealOptions: Array<DealFilterOptionObj>;
  feedbackPostOptions: Array<FeedbackPostFilterOptionObj>;
  insightOptions: Array<FilterOptionObj>;
  launchOptions: Array<LaunchFilterOptionObj>;
  personaOptions: Array<PersonaFilterOptionObj>;
  productLineTagOptions: Array<TagFilterOptionObj>;
  releaseOptions: Array<ProductBoardReleaseFilterOptionObj>;
  roadmapOptions: Array<FilterOptionObj>;
  statusOptions: Array<ProductBoardStatusFilterOptionObj>;
  tagOptions: Array<TagFilterOptionObj>;
};

export type ProductBoardItemObj = {
  __typename?: 'ProductBoardItemObj';
  accounts: Array<CdpAccountObj>;
  assignee?: Maybe<UserObj>;
  blockedByItems: Array<ProductBoardItemObj>;
  blockingItems: Array<ProductBoardItemObj>;
  competitors: Array<CompanyObj>;
  competitorsIds: Array<Maybe<Scalars['String']>>;
  createdAt: Scalars['DateTime'];
  customColumns: Array<ProductBoardItemCustomColumnObj>;
  customFileUrls: Array<Scalars['String']>;
  dealIds: Array<Maybe<Scalars['String']>>;
  deals: Array<DealObj>;
  description?: Maybe<Scalars['String']>;
  designFileUrls: Array<Scalars['String']>;
  effort?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['DateTime']>;
  factors: Array<ProductBoardItemFactorObj>;
  feedbackPostIds: Array<Maybe<Scalars['String']>>;
  feedbackPosts: Array<FeedbackPostDto>;
  id: Scalars['ID'];
  insights: Array<InsightObj>;
  insightsIds: Array<Maybe<Scalars['String']>>;
  integrationSubTasks: Array<IntegrationTaskObj>;
  integrationTasks: Array<IntegrationTaskObj>;
  integrationTasksStatus: IntegrationTasksStatusObj;
  launchId?: Maybe<Scalars['ID']>;
  launches: Array<LaunchObj>;
  launchesIds: Array<Maybe<Scalars['String']>>;
  /** Default order index */
  orderIndex: Scalars['String'];
  organizationId: Scalars['String'];
  parentItemId?: Maybe<Scalars['ID']>;
  personas: Array<PersonaDto>;
  personasIds: Array<Maybe<Scalars['String']>>;
  priority?: Maybe<RoadmapItemPriority>;
  productDocUrls: Array<Scalars['String']>;
  productLineTags: Array<TagObj>;
  release?: Maybe<ProductBoardReleaseObj>;
  /** @deprecated Use revenueImpactDetails.totalRevenueImpact instead */
  revenueImpact: Scalars['Int'];
  revenueImpactDetails: ProductBoardRevenueImpactDetailsObj;
  roadmap: ProductBoardRoadmapObj;
  roadmapId: Scalars['String'];
  score?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<ProductBoardStatusObj>;
  subItems: Array<ProductBoardItemObj>;
  subItemsIds: Array<Maybe<Scalars['String']>>;
  tags: Array<TagObj>;
  title: Scalars['String'];
  updatedAt: Scalars['Timestamp'];
};

export type ProductBoardItemOrderIndexObj = {
  __typename?: 'ProductBoardItemOrderIndexObj';
  orderIndex: Scalars['Float'];
  roadmapItemId: Scalars['ID'];
};

export type ProductBoardItemsFilterInput = {
  accountIds?: Maybe<Array<Scalars['String']>>;
  accountsFilter?: Maybe<CdpAccountItemsFilterInput>;
  assigneeIds?: Maybe<Array<Scalars['String']>>;
  competitorIds?: Maybe<Array<Scalars['String']>>;
  dealIds?: Maybe<Array<Scalars['String']>>;
  endDateGte?: Maybe<Scalars['DateTime']>;
  endDateLte?: Maybe<Scalars['DateTime']>;
  feedbackPostIds?: Maybe<Array<Scalars['String']>>;
  insightIds?: Maybe<Array<Scalars['String']>>;
  launchIds?: Maybe<Array<Scalars['String']>>;
  opportunitySizeMax?: Maybe<Scalars['Float']>;
  opportunitySizeMin?: Maybe<Scalars['Float']>;
  parentItemId?: Maybe<Scalars['String']>;
  personaIds?: Maybe<Array<Scalars['String']>>;
  priority?: Maybe<Array<RoadmapItemPriority>>;
  productLineTagIds?: Maybe<Array<Scalars['String']>>;
  query?: Maybe<Scalars['String']>;
  releaseIds?: Maybe<Array<Scalars['String']>>;
  roadmapIds?: Maybe<Array<Scalars['String']>>;
  statusIds?: Maybe<Array<Scalars['String']>>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};

export enum ProductBoardItemsGroupBy {
  ASSIGNEE = 'ASSIGNEE',
  COMPETITOR = 'COMPETITOR',
  DEAL = 'DEAL',
  INSIGHT = 'INSIGHT',
  LAUNCH = 'LAUNCH',
  PERSONA = 'PERSONA',
  PRODUCT_IDEA = 'PRODUCT_IDEA',
  RELEASE = 'RELEASE',
  ROADMAP = 'ROADMAP',
  STATUS = 'STATUS',
  TAG = 'TAG'
}

export type ProductBoardItemsGroupObj = {
  __typename?: 'ProductBoardItemsGroupObj';
  iconColor?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  imageSrc?: Maybe<Scalars['String']>;
  items: Array<ProductBoardItemObj>;
  key: ProductBoardItemsGroupBy;
  name: Scalars['String'];
};

export type ProductBoardItemsSortInput = {
  assignee?: Maybe<FieldSortInput>;
  createdAt?: Maybe<FieldSortInput>;
  customColumn?: Maybe<CustomFieldSortInput>;
  effort?: Maybe<FieldSortInput>;
  endDate?: Maybe<FieldSortInput>;
  factor?: Maybe<CustomFieldSortInput>;
  orderIndex?: Maybe<FieldSortInput>;
  priority?: Maybe<FieldSortInput>;
  release?: Maybe<FieldSortInput>;
  revenueImpact?: Maybe<FieldSortInput>;
  roadmap?: Maybe<FieldSortInput>;
  score?: Maybe<FieldSortInput>;
  startDate?: Maybe<FieldSortInput>;
  status?: Maybe<FieldSortInput>;
  title?: Maybe<FieldSortInput>;
  value?: Maybe<FieldSortInput>;
};

export type ProductBoardItemsStatsObj = {
  __typename?: 'ProductBoardItemsStatsObj';
  closedDealsRevenueImpact: Scalars['Float'];
  lostDealsRevenueImpact: Scalars['Float'];
  percentComplete: Scalars['Float'];
  /** @deprecated Use totalRevenueImpact instead of revenueImpact */
  revenueImpact: Scalars['Float'];
  todaysDealsRevenueImpact: Scalars['Float'];
  totalRevenueImpact: Scalars['Float'];
  wonDealsRevenueImpact: Scalars['Float'];
};

export type ProductBoardItemsViewFilterObj = {
  __typename?: 'ProductBoardItemsViewFilterObj';
  assigneeIds?: Maybe<Array<Scalars['ID']>>;
  competitorIds?: Maybe<Array<Scalars['ID']>>;
  dealIds?: Maybe<Array<Scalars['ID']>>;
  endDateGte?: Maybe<Scalars['DateTime']>;
  endDateLte?: Maybe<Scalars['DateTime']>;
  feedbackPostIds?: Maybe<Array<Scalars['ID']>>;
  id: Scalars['ID'];
  insightIds?: Maybe<Array<Scalars['ID']>>;
  launchIds?: Maybe<Array<Scalars['ID']>>;
  parentItemId?: Maybe<Scalars['ID']>;
  personaIds?: Maybe<Array<Scalars['ID']>>;
  priority?: Maybe<Array<RoadmapItemPriority>>;
  productLineTagIds?: Maybe<Array<Scalars['ID']>>;
  query?: Maybe<Scalars['String']>;
  releaseIds?: Maybe<Array<Scalars['ID']>>;
  roadmapIds?: Maybe<Array<Scalars['ID']>>;
  statusIds?: Maybe<Array<Scalars['ID']>>;
  tagIds?: Maybe<Array<Scalars['ID']>>;
};

export type ProductBoardItemsViewItemOrderIndexInput = {
  orderIndex: Scalars['Float'];
  roadmapItemId: Scalars['ID'];
};

export type ProductBoardItemsViewObj = {
  __typename?: 'ProductBoardItemsViewObj';
  filter?: Maybe<ProductBoardItemsViewFilterObj>;
  groupBy?: Maybe<ProductBoardItemsGroupBy>;
  id: Scalars['String'];
  name: Scalars['String'];
  orderIndexes: Array<ProductBoardItemOrderIndexObj>;
  sort?: Maybe<ProductBoardItemsViewSortObj>;
  view?: Maybe<ProductBoardView>;
  visibleProperties?: Maybe<Array<Scalars['String']>>;
};

export type ProductBoardItemsViewSortObj = {
  __typename?: 'ProductBoardItemsViewSortObj';
  assignee?: Maybe<FieldSortObj>;
  createdAt?: Maybe<FieldSortObj>;
  customColumn?: Maybe<CustomFieldSortObj>;
  effort?: Maybe<FieldSortObj>;
  endDate?: Maybe<FieldSortObj>;
  factor?: Maybe<CustomFieldSortObj>;
  orderIndex?: Maybe<FieldSortObj>;
  priority?: Maybe<FieldSortObj>;
  release?: Maybe<FieldSortObj>;
  revenueImpact?: Maybe<FieldSortObj>;
  roadmap?: Maybe<FieldSortObj>;
  score?: Maybe<FieldSortObj>;
  startDate?: Maybe<FieldSortObj>;
  status?: Maybe<FieldSortObj>;
  title?: Maybe<FieldSortObj>;
  value?: Maybe<FieldSortObj>;
};

export type ProductBoardKanbanCellAxisObj = {
  __typename?: 'ProductBoardKanbanCellAxisObj';
  id: Scalars['String'];
  key: RoadmapGroupKeys;
  name: Scalars['String'];
};

export type ProductBoardKanbanCellObj = {
  __typename?: 'ProductBoardKanbanCellObj';
  axisX?: Maybe<ProductBoardKanbanCellAxisObj>;
  axisY?: Maybe<ProductBoardKanbanCellAxisObj>;
  items: Array<ProductBoardItemObj>;
};

export type ProductBoardKanbanMatrixAxesInput = {
  axisX?: Maybe<RoadmapGroupKeys>;
  axisY?: Maybe<RoadmapGroupKeys>;
};

export type ProductBoardKanbanMatrixInput = {
  axes: ProductBoardKanbanMatrixAxesInput;
  launchId?: Maybe<Scalars['String']>;
  roadmapIds?: Maybe<Array<Scalars['String']>>;
};

export type ProductBoardObjectiveObj = {
  __typename?: 'ProductBoardObjectiveObj';
  id: Scalars['String'];
  progress: Scalars['Float'];
  title?: Maybe<Scalars['String']>;
};

export type ProductBoardOkrProgressObj = {
  __typename?: 'ProductBoardOkrProgressObj';
  objectives?: Maybe<Array<ProductBoardObjectiveObj>>;
  progress: Scalars['Float'];
};

export type ProductBoardReleaseFilterOptionObj = {
  __typename?: 'ProductBoardReleaseFilterOptionObj';
  color: Scalars['String'];
  label: Scalars['String'];
  value: Scalars['String'];
};

export type ProductBoardReleaseObj = {
  __typename?: 'ProductBoardReleaseObj';
  description?: Maybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  iconColor: Scalars['String'];
  id: Scalars['String'];
  items: PaginatedProductBoardItemsObj;
  milestones: Array<MilestoneObj>;
  name: Scalars['String'];
  okrProgress?: Maybe<Scalars['Float']>;
  organizationId: Scalars['String'];
  owner?: Maybe<UserObj>;
  percentComplete?: Maybe<Scalars['Int']>;
  productLineTag?: Maybe<TagObj>;
  /** @deprecated Use revenueImpactDetails.totalRevenueImpact instead */
  revenueImpact: Scalars['Int'];
  revenueImpactDetails: ProductBoardRevenueImpactDetailsObj;
  startDate?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['Timestamp'];
};


export type ProductBoardReleaseObjItemsArgs = {
  filter?: Maybe<ProductBoardItemsFilterInput>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<ProductBoardItemsSortInput>;
  viewId?: Maybe<Scalars['String']>;
};

export type ProductBoardReleasesInput = {
  isPublic?: Maybe<Array<Scalars['Boolean']>>;
  launchIds?: Maybe<Array<Scalars['String']>>;
  productLineTagId?: Maybe<Scalars['String']>;
  releaseIds?: Maybe<Array<Scalars['String']>>;
};

export type ProductBoardRevenueImpactDetailsObj = {
  __typename?: 'ProductBoardRevenueImpactDetailsObj';
  lostDealsRevenueImpact: Scalars['Float'];
  todaysDealsRevenueImpact: Scalars['Float'];
  totalRevenueImpact: Scalars['Float'];
  wonDealsRevenueImpact: Scalars['Float'];
};

export type ProductBoardRoadmapObj = {
  __typename?: 'ProductBoardRoadmapObj';
  customColumns: Array<ProductBoardCustomColumnDto>;
  id: Scalars['String'];
  items: PaginatedProductBoardItemsObj;
  name: Scalars['String'];
  organizationId: Scalars['String'];
  percentComplete: Scalars['Int'];
  productLineTag?: Maybe<TagObj>;
  /** @deprecated Use revenueImpactDetails.totalRevenueImpact instead */
  revenueImpact: Scalars['Int'];
  revenueImpactDetails: ProductBoardRevenueImpactDetailsObj;
  updatedAt: Scalars['Timestamp'];
};


export type ProductBoardRoadmapObjItemsArgs = {
  filter?: Maybe<ProductBoardItemsFilterInput>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<ProductBoardItemsSortInput>;
  viewId?: Maybe<Scalars['String']>;
};

export type ProductBoardRoadmapsInput = {
  ids?: Maybe<Array<Scalars['String']>>;
  launchId?: Maybe<Scalars['String']>;
  productLineTagId?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
};

export type ProductBoardStatusFilterOptionObj = {
  __typename?: 'ProductBoardStatusFilterOptionObj';
  color: Scalars['String'];
  label: Scalars['String'];
  value: Scalars['String'];
};

export type ProductBoardStatusObj = {
  __typename?: 'ProductBoardStatusObj';
  description: Scalars['String'];
  iconColor: Scalars['String'];
  id: Scalars['String'];
  immutable: Scalars['Boolean'];
  name: Scalars['String'];
  organizationId: Scalars['String'];
  updatedAt: Scalars['Timestamp'];
};

export type ProductBoardSummaryInput = {
  roadmapIds?: Maybe<Array<Scalars['String']>>;
};

export type ProductBoardSummaryObj = {
  __typename?: 'ProductBoardSummaryObj';
  attachedLaunches: Array<LaunchObj>;
  nextRelease?: Maybe<ProductBoardReleaseObj>;
  releasesThisMonth: Array<ProductBoardReleaseObj>;
};

export enum ProductBoardView {
  KANBAN = 'KANBAN',
  LIST = 'LIST',
  TIMELINE = 'TIMELINE'
}

export type ProductGapsDto = {
  __typename?: 'ProductGapsDto';
  dealId?: Maybe<Array<Scalars['String']>>;
  dealNotes?: Maybe<Scalars['String']>;
};

export type ProductIdeaBoardFiltersInput = {
  assigneeIds: Array<Scalars['String']>;
  statuses: Array<FeedbackPostStatus>;
  tagIds: Array<Scalars['String']>;
};

export type ProductIdeaBoardFiltersObj = {
  __typename?: 'ProductIdeaBoardFiltersObj';
  assigneeIds: Array<Scalars['String']>;
  statuses?: Maybe<Array<FeedbackPostStatus>>;
  tagIds: Array<Scalars['String']>;
};

export type ProductIdeaBoardSettingsInput = {
  boardId: Scalars['String'];
  emailDomain?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  internal: Scalars['Boolean'];
  isAccountRestricted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  productIdeaBoardFilters?: Maybe<ProductIdeaBoardFiltersInput>;
};

export type ProductIdeaBoardSettingsObj = {
  __typename?: 'ProductIdeaBoardSettingsObj';
  boardId: Scalars['String'];
  emailDomain?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  internal?: Maybe<Scalars['Boolean']>;
  isAccountRestricted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  productIdeaBoardFilters?: Maybe<ProductIdeaBoardFiltersObj>;
};

export type ProposedChannelsObj = {
  __typename?: 'ProposedChannelsObj';
  items: Array<ChannelTemplateObj>;
  launchId: Scalars['String'];
};

export type PublicApproveModuleInput = {
  approvalStatus: Scalars['Boolean'];
  launchId: Scalars['String'];
  launchModuleId: Scalars['String'];
  organizationId: Scalars['String'];
  userId: Scalars['String'];
};

export type PublicLaunchPhaseApprovalInput = {
  launchId: Scalars['String'];
  organizationId: Scalars['String'];
  phaseId: Scalars['String'];
  userId: Scalars['String'];
};

export type PublicOrganizationObj = {
  __typename?: 'PublicOrganizationObj';
  externalPageSettings: ExternalPageSettings;
  hasPaidSubscription?: Maybe<Scalars['Boolean']>;
  haveGtm?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isUnderFreeTrial?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  stages: Array<StageObj>;
  url?: Maybe<Scalars['String']>;
  users: Array<PublicUserObj>;
};

export type PublicPageObj = {
  __typename?: 'PublicPageObj';
  coverImage?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  headerDescription?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isProductIdeasLive: Scalars['Boolean'];
  isReleaseNotesLive: Scalars['Boolean'];
  isVerified: Scalars['Boolean'];
  live: Scalars['Boolean'];
  name: Scalars['String'];
  productIdeaBoardSettings?: Maybe<Array<ProductIdeaBoardSettingsObj>>;
  releaseNotesFilters?: Maybe<ReleaseNotesFiltersObj>;
  releaseNotesPassword?: Maybe<Scalars['String']>;
  styleSettings?: Maybe<StyleSettingsObj>;
  txtKey?: Maybe<Scalars['String']>;
};

export type PublicPagesSettingsObj = {
  __typename?: 'PublicPagesSettingsObj';
  calendar: CalendarPageSettingsObj;
  roadmap: RoadmapsPagesSettingsObj;
};

export type PublicReleaseNotesFilterInput = {
  months?: Maybe<Array<Months>>;
  search?: Maybe<Scalars['String']>;
  tagsIds?: Maybe<Array<Scalars['String']>>;
  year?: Maybe<Scalars['Float']>;
};

export type PublicUserObj = {
  __typename?: 'PublicUserObj';
  avatarColor: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['String'];
  isEmailVerified?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  primaryOnboardingGoal: OnboardingGoal;
  profileImage?: Maybe<Scalars['String']>;
  theme: Theme;
};

export type Query = {
  __typename?: 'Query';
  GPTGetLaunchSummary: Scalars['String'];
  GPTGetMessagingStrategy: Scalars['String'];
  GPTGetObjectives: Scalars['String'];
  GPTGetPositioningStrategy: Scalars['String'];
  MBAccess: MapleBillingAccessObj;
  MBActiveSubscriptions: Array<MapleBillingSubscriptionObj>;
  MBAvailableProducts: Array<MapleBillingProductObj>;
  MBHasPaymentMethod: Scalars['Boolean'];
  MBInvoices: Array<MapleBillingInvoiceObj>;
  MBPaymentMethodIntent: Scalars['String'];
  MBPaymentMethodURL: Scalars['String'];
  MBShowUpgradeButton: Scalars['Boolean'];
  MBUpdateObjectsForAllOrganizations: Scalars['Boolean'];
  MBgetPaymentMethods: Array<MapleBillingPaymentMethodObj>;
  aIConvertTOJSON: Scalars['String'];
  activeSubscriptions: Array<StripeSubscriptionObj>;
  adminGenerateLaunchContent: AiLaunchContentObj;
  adminGenerateLaunchSummary: Scalars['String'];
  adminOrgTemplates: Array<TemplateObj>;
  adminOrgUploadedTemplateFiles: Array<OrganizationUploadedTemplateObj>;
  adminOrganization: OrganizationObj;
  adminTemplate: TemplateObj;
  adminTemplateModule: TemplateModuleObj;
  adminTemplateModules: Array<TemplateModuleObj>;
  adminTemplates: Array<TemplateObj>;
  adminUser: UserObj;
  adminUsers: Array<UserObj>;
  announcement: AnnouncementObj;
  asset: AssetObj;
  assetFilterOptions: AssetFilterOptionsObj;
  assets: Array<AssetObj>;
  availableCDPAccountIndustries: Array<Scalars['String']>;
  availableCDPAccountTypes: Array<Scalars['String']>;
  availableCDPContactRoles: Array<Scalars['String']>;
  availableCDPContactStages: Array<Scalars['String']>;
  availableCDPDealStages: Array<Scalars['String']>;
  availableCDPDealTypes: Array<Scalars['String']>;
  availableInsightConversationTypes: Array<Scalars['String']>;
  availableProducts: Array<StripeProductObj>;
  availableProductsV2: Array<StripeProductObj>;
  availableProductsV3: Array<StripeProductObj>;
  cdpAccount: CdpAccountObj;
  cdpContact: CdpContactObj;
  cdpDeal: CdpDealObj;
  cdpOwner: CdpOwnerObj;
  channels: Array<ChannelObj>;
  channelsBetweenDates: Array<ChannelObj>;
  chatGTM: Scalars['String'];
  chatGTMData: Scalars['String'];
  checkConfigurations: Array<ExportBattlecardsConfigurationObj>;
  checkInitialTrendGenerationState: Scalars['Boolean'];
  checkWinlossIntegration: Scalars['String'];
  checklist: ChecklistObj;
  clearbitCompany: ClearbitCompanyObj;
  clearbitForOnboarding: CompanyInfoFromWebsiteObj;
  comments: Array<CommentObj>;
  companies: Array<CompanyObj>;
  company: CompanyObj;
  companyInfoFromWebsite: CompanyInfoFromWebsiteObj;
  companyRating?: Maybe<CompanyRatingsOutput>;
  competitiveIntelligenceFeatures: Array<CompetitiveIntelligenceFeatureObj>;
  cookie: Cookie;
  copyAndAssetsProgress: ModulesApprovalStatusProgressObj;
  copysmithAIFavorites?: Maybe<CopysmithAiFavoriteObj>;
  copysmithAITemplates: Array<CopysmithAiTemplateObj>;
  copywriteV2Favorites: CopywriteV2FavoriteObj;
  copywriteV2Templates: Array<CopywriteV2TemplateObj>;
  countAssets: Scalars['Float'];
  countFeedbackBoards: Scalars['Float'];
  countFeedbackPosts: Scalars['Float'];
  countLaunches: Scalars['Float'];
  countObjectives: Scalars['Float'];
  countPersonas: Scalars['Float'];
  countProductBoardItems: Scalars['Float'];
  countProductBoardReleases: Scalars['Float'];
  countReleaseNotes: Scalars['Float'];
  countTasks: Scalars['Float'];
  countTestimonials: Scalars['Float'];
  createIntegrationWebhook: Scalars['Boolean'];
  crmIntegration?: Maybe<CrmIntegrationObj>;
  crmIntegrationOAuthUrl: Scalars['String'];
  crmIntegrationObjectProperties: Array<CrmIntegrationObjectPropertyObj>;
  crmIntegrationStatus: CrmIntegrationStatuses;
  crmIntegrations: Array<CrmIntegrationObj>;
  currentFeedbackUser: FeedbackUserDto;
  customOrganizationTemplates: Array<TemplateObj>;
  deal: DealObj;
  dealFilterOptions: DealFilterOptionsObj;
  deals: Array<DealObj>;
  dealsCompanies: Array<DealCompanyObj>;
  dealsCompany: DealCompanyObj;
  dealsOwner: DealOwnerObj;
  dealsOwners: Array<DealOwnerObj>;
  dealsStages: Array<Scalars['String']>;
  defaultExternalPublicPage: ExternalPublicPageObj;
  existingProductIdeasDigest: PaginatedFeedbackPostsByDealDigestObj;
  externalFeedbackBoard: FeedbackBoardDto;
  externalFeedbackBoards: Array<FeedbackBoardDto>;
  externalFeedbackPost: FeedbackPostDto;
  externalFeedbackPosts: Array<FeedbackPostDto>;
  externalPublicPage: ExternalPublicPageObj;
  externalPublicPageByDomain: ExternalPublicPageObj;
  featureTable: FeatureTableObj;
  featureTableCategories: Array<FeatureTableCategoryObj>;
  feedbackBoard: FeedbackBoardDto;
  feedbackBoards: Array<FeedbackBoardDto>;
  feedbackPost: FeedbackPostDto;
  feedbackPostFilterOptions: FeedbackPostFilterOptionsObj;
  feedbackPosts: Array<FeedbackPostDto>;
  feedbackPostsView: FeedbackPostsViewObj;
  feedbackPostsViews: Array<FeedbackPostsViewObj>;
  findIntegrationChannels: IntegrationChannelsPaginatedOutput;
  findReleaseNote: ReleaseNoteObj;
  geDesktopReferrals?: Maybe<Array<ReferrelsOutput>>;
  getAISummary: AiSummaryOutput;
  getAiPrompt: AiPromptObj;
  getAiPrompts: Array<AiPromptObj>;
  getCDPAccounts: Array<CdpAccountObj>;
  getCDPContacts: Array<CdpContactObj>;
  getCDPContactsOfAccount: Array<CdpContactObj>;
  getCDPDeals: Array<CdpDealObj>;
  getCDPOwners: Array<CdpOwnerObj>;
  getClearbitCompany: ClearbitModuleCompanyObj;
  getCompanyScrapedData: Scalars['String'];
  getConfluenceAuthUrl: Scalars['String'];
  getGoogleAuthUrl: Scalars['String'];
  getHubspotAuthorizationUrl: Scalars['String'];
  getHubspotCompanies: Array<HubSpotCompaniesObj>;
  getHubspotCompany: HubSpotCompaniesObj;
  getHubspotCustomObjects: Array<Scalars['String']>;
  getHubspotDeals: Array<HubSpotDealDetailsObj>;
  getHubspotDealsAssociatedWithCompetitor: Array<HubSpotCompaniesObj>;
  getHubspotOwners: Array<HubSpotOwnersObj>;
  getKPIPerformance?: Maybe<Scalars['Float']>;
  getKeywords?: Maybe<PaginatedKeywordsObj>;
  getMeasurementIntegrationEventProperties: Array<MeasurementEventPropertyObj>;
  getMeasurementIntegrationEvents: Array<Scalars['String']>;
  getMeasurementIntegrationMetrics: Array<MeasurementIntegrationMetricObj>;
  getMeasurementIntegrationTypes: Array<Scalars['String']>;
  getMeasurementIntegrations: Array<MeasurementIntegrationsOutput>;
  getMessagingForMessagingLibrary: Scalars['String'];
  getObjectivesCompletion?: Maybe<Scalars['Float']>;
  getOrganizationPaymentMethods: Array<StripePaymentMethod>;
  getOverdueTasks: PaginatedTaskObj;
  getPaidCustomersPaginatedMB: Array<OrganizationObj>;
  getPositioningStrategyForMessagingLibrary: Scalars['String'];
  getProductBoardItemsMappingToInsights: Scalars['Boolean'];
  getProductIntegrationTasksForLaunch: Array<IntegrationTaskObj>;
  getRetroResponses: RetroAnswersObj;
  getRetroScore?: Maybe<Scalars['Float']>;
  getRssFeeds: Array<RssFeedDataObj>;
  getSalesforceAuthorizationUrl: Scalars['String'];
  getSalesforceOpportunity: Array<Scalars['String']>;
  getSalesforceOpportunityCustomFields: Array<SalesforceCompetitorsDataObj>;
  getScreenshots: ScreenshotsData;
  getSelectedSalesforceIntegrationFields: SalesforceIntegrationFields;
  getTemplatesForCopysmith: Array<Scalars['String']>;
  getTotalTraffic?: Maybe<Scalars['String']>;
  getTotalTrafficChart?: Maybe<SimilarWebChartQueryOutput>;
  getVisits?: Maybe<SimilarWebOutput>;
  getWinlossAccounts: Array<SalesforceCompetitorsDataObj>;
  getWinlossAuthUrl: Scalars['String'];
  getWinlossCustomObjects: Array<SalesforceCompetitorsDataObj>;
  googleLoginUrl: Scalars['String'];
  grainInsightIntegrationItems: Array<InsightIntegrationItemObj>;
  growthToolCompany: ClearbitCompanyObj;
  growthToolCompanyNews: PaginatedCompetingCompaniesNewsArticlesObj;
  gtmTimeline: GtmTimelineObj;
  insight: InsightObj;
  insightFilterOptions: InsightFilterOptionsObj;
  insightGeneratedItemFilterOptions: InsightGeneratedItemFilterOptionsObj;
  insightIntegration: InsightIntegrationObj;
  insightIntegrationOAuthUrl: Scalars['String'];
  insightIntegrations: Array<InsightIntegrationObj>;
  insights: Array<InsightObj>;
  insightsGeneratedItem: InsightsGeneratedItemObj;
  insightsGeneratedTrendGraph: InsightsGeneratedItemTrendGraphDataObj;
  insightsTrendItem: InsightsTrendItemObj;
  insightsTrendItemGraph: InsightsTrendItemGraphDataObj;
  insightsView: InsightsViewObj;
  insightsViews: Array<InsightsViewObj>;
  integration: IntegrationObj;
  integrationColumns: Array<IntegrationColumnObj>;
  integrationOAuthUrl: Scalars['String'];
  integrationProject: IntegrationProjectObj;
  integrationProjects: Array<IntegrationProjectObj>;
  integrationProjectsFetchStatus: Scalars['Boolean'];
  integrationResources: Array<IntegrationResourceObj>;
  integrationResourcesFetchStatus: Scalars['Boolean'];
  integrationSubTasks: Array<IntegrationTaskObj>;
  integrationTasks: Array<IntegrationTaskObj>;
  integrationTasksFetchStatus: Scalars['Boolean'];
  integrationTasksRefreshToken: IntegrationObj;
  integrations: Array<IntegrationObj>;
  integrationsTasksAssignees: Array<Scalars['String']>;
  intercomTags: Array<IntercomTagObj>;
  invoices: Array<StripeInvoiceObj>;
  kpis: PaginatedKpiObj;
  launch: LaunchObj;
  launchContent: LaunchContentObj;
  launchModule: LaunchModuleObj;
  launchMonths: Array<LaunchMonthsObj>;
  launchProgress: LaunchProgressObj;
  launchTypePreferences: Array<CopilotLaunchTypePreferenceObj>;
  launchTypes: Array<LaunchTypeObj>;
  launches: Array<LaunchObj>;
  /** @deprecated Use launchesFilterOptionsV2 instead */
  launchesFilterOptions: LaunchFilterOptionsObj;
  launchesFilterOptionsV2: LaunchesFilterOptionsObj;
  marketingInsightsSummary: InsightsMarketingSummaryObj;
  measurementQuery: MeasurementIntegrationsQueryOutput;
  messageGroup: MessageGroupObj;
  messageGroups: PaginatedMessageGroupObj;
  messageLibraries: Array<MessagingLibraryObj>;
  milestones: Array<MilestoneObj>;
  milestonesBetweenDates: Array<MilestoneObj>;
  notificationChannel?: Maybe<NotificationChannelObj>;
  notificationChannelsAll: Array<NotificationChannelObj>;
  numberOfActiveLaunches: Scalars['Float'];
  numberOfLaunchesCurrentlyBilled: Scalars['Float'];
  organization: OrganizationObj;
  organizationIntegration: Integration;
  organizationIntegrations: PaginatedIntegrations;
  organizationInvites: Array<OrganizationObj>;
  organizationPhases: Array<PhaseObj>;
  organizationTemplates: Array<TemplateObj>;
  organizationUploadedTemplates: Array<OrganizationUploadedTemplateObj>;
  organizations: Array<OrganizationObj>;
  organizationsForAdmin: Array<OrganizationObj>;
  paginatedAnnouncements: PaginatedAnnouncementObj;
  paginatedAssetGroups: PaginatedAssetGroupsObj;
  paginatedAssets: PaginatedAssetsObj;
  paginatedCDPAccounts: PaginatedCdpAccountObj;
  paginatedCDPContacts: PaginatedCdpContactObj;
  paginatedCDPDeals: PaginatedCdpDealObj;
  paginatedCDPOwners: PaginatedCdpOwnerObj;
  paginatedClariCopilotInsightIntegrationItems: PaginatedInsightIntegrationItemsObj;
  paginatedComments: PaginatedCommentsObj;
  paginatedCompanies: PaginatedCompanyObj;
  paginatedCompaniesByGroup: PaginatedCompanyObj;
  paginatedCompanyGroups: PaginatedCompanyTagGroupObj;
  paginatedCompetingCompaniesNewsArticles: PaginatedCompetingCompaniesNewsArticlesObj;
  paginatedCompetitors: PaginatedWinLossCompetitorObj;
  paginatedCrmIntegrationObjects: PaginatedCrmIntegrationObjectsObj;
  paginatedDeals: PaginatedDealsObj;
  paginatedDealsCompanies: PaginatedDealsCompaniesObj;
  paginatedDealsOwners: PaginatedDealsOwnersObj;
  paginatedExternalFeedbackPosts: PaginatedFeedbackPostsDto;
  paginatedFeedbackPosts: PaginatedFeedbackPostsDto;
  paginatedG2UserReviews?: Maybe<PaginatedG2UserReviewsOutputObj>;
  paginatedGongInsightIntegrationItems: PaginatedInsightIntegrationItemsObj;
  paginatedInsightGeneratedItems: PaginatedInsightsGeneratedItemObj;
  paginatedInsightTrendItems: PaginatedInsightsTrendItemObj;
  paginatedInsights: PaginatedInsightsObj;
  paginatedIntegrationTasks: PaginatedIntegrationTasks;
  paginatedIntercomInsightIntegrationItems: PaginatedInsightIntegrationItemsObj;
  paginatedLaunches: PaginatedLaunchObj;
  paginatedNewsDigest: PaginatedCompetingCompaniesNewsArticlesObj;
  paginatedObjectives: PaginatedObjectiveObj;
  paginatedPersonas: PaginatedPersonasDto;
  paginatedProductBoardItems: PaginatedProductBoardItemsObj;
  paginatedReleaseNotes: PaginatedReleaseNoteObj;
  paginatedReviewsDigest: PaginatedG2UserReviewsOutputObj;
  paginatedSalesrepDigest: PaginatedDealsOwnersObj;
  paginatedSlackInsightIntegrationItems: PaginatedInsightIntegrationItemsObj;
  paginatedTags: PaginatedTagObj;
  paginatedTasks: PaginatedTaskObj;
  paginatedTestimonials: PaginatedTestimonialObj;
  paginatedWinlossInsightsDigest: PaginatedWinLossTableObj;
  paginatedWinlossTable: PaginatedWinLossTableObj;
  paginatedZendeskInsightIntegrationItems: PaginatedInsightIntegrationItemsObj;
  paginatedZoomInsightIntegrationItems: PaginatedInsightIntegrationItemsObj;
  pendingApprovalAssets: Array<AssetObj>;
  persona: PersonaDto;
  personas: Array<PersonaDto>;
  previewDefaultAssets: Array<PreviewDefaultAssetObj>;
  previewDefaultChannels: Array<PreviewDefaultChannelObj>;
  previewDefaultTasks: Array<PreviewDefaultTaskObj>;
  productBoardCustomColumns: Array<ProductBoardCustomColumnDto>;
  productBoardFactors: Array<ProductBoardFactorDto>;
  productBoardItem: ProductBoardItemObj;
  productBoardItemFilterOptions: ProductBoardItemFilterOptionsObj;
  productBoardItemViews: Array<ProductBoardItemsViewObj>;
  productBoardItems: Array<ProductBoardItemObj>;
  productBoardItemsAssignees: Array<UserObj>;
  productBoardItemsGroups: PaginatedRoadmapItemsGroupsObj;
  productBoardItemsStats: ProductBoardItemsStatsObj;
  productBoardItemsView: ProductBoardItemsViewObj;
  productBoardKanbanMatrix: Array<Array<ProductBoardKanbanCellObj>>;
  productBoardReleases: Array<ProductBoardReleaseObj>;
  productBoardRoadmap: ProductBoardRoadmapObj;
  productBoardRoadmaps: Array<ProductBoardRoadmapObj>;
  productBoardStatuses: Array<ProductBoardStatusObj>;
  productBoardSummary: ProductBoardSummaryObj;
  productGaps: Array<ProductGapsDto>;
  productGapsIntegrationStatus: CrmIntegrationStatuses;
  productInsightsSummary: InsightsProductSummaryObj;
  productIntegrationTaskTypeValues: Array<Scalars['String']>;
  productIntegrationTaskTypes: Array<Scalars['String']>;
  productIntegrationTasksStatus: IntegrationTasksStatusObj;
  productRoadmapSummary: ProductBoardSummaryObj;
  proposedChannels: ProposedChannelsObj;
  publicCompany: CompanyObj;
  publicCompanyNews: PaginatedCompetingCompaniesNewsArticlesObj;
  publicCompanyOrganization: OrganizationObj;
  publicCompanyScreenshots: ScreenshotsData;
  publicLaunchPageGtmTimeline: GtmTimelineObj;
  publicLaunchPageIntegrations: Array<IntegrationObj>;
  publicLaunchPageKpis: PaginatedKpiObj;
  publicLaunchPageLaunch: LaunchObj;
  publicLaunchPageLaunchProgress: LaunchProgressObj;
  publicLaunchPageObjectives: PaginatedObjectiveObj;
  publicLaunchPageOrganization: OrganizationObj;
  publicLaunchPagePaginatedAssets: PaginatedAssetsObj;
  publicLaunchPagePaginatedTasks: PaginatedTaskObj;
  publicLaunchPagePersonas: Array<PersonaDto>;
  publicLaunchPageTags: Array<TagObj>;
  publicLaunchPageTasksProgress: TasksProgressObj;
  publicOrganization: PublicOrganizationObj;
  publicPage: PublicPageObj;
  publicPageFeedbackPost: FeedbackPostDto;
  publicPageFeedbackPosts: PaginatedFeedbackPostsDto;
  publicPagePaginatedReleaseNotes: PaginatedReleaseNoteObj;
  publicPageReleaseNote: ReleaseNoteObj;
  publicPages: PaginatedPublicPageObj;
  publicPaginatedProductRoadmapItems: PaginatedProductBoardItemsObj;
  publicProductRoadmap: ProductBoardRoadmapObj;
  publicProductRoadmapFactors: Array<ProductBoardFactorDto>;
  publicProductRoadmapItem: ProductBoardItemObj;
  publicProductRoadmapItems: Array<ProductBoardItemObj>;
  publicProductRoadmapItemsAssignees: Array<UserObj>;
  publicProductRoadmapKanbanMatrix: Array<Array<ProductBoardKanbanCellObj>>;
  publicProductRoadmapReleases: Array<ProductBoardReleaseObj>;
  publicProductRoadmapStatuses: Array<ProductBoardStatusObj>;
  publicProductRoadmapTags: Array<TagObj>;
  publicProductRoadmaps: Array<ProductBoardRoadmapObj>;
  publicReleaseNote: ReleaseNoteObj;
  publicReleaseNotes: PaginatedReleaseNoteObj;
  publicReleaseNotesTags: Array<TagObj>;
  publicTaskAssignees: Array<UserObj>;
  ratingSummary?: Maybe<Array<RatingSummaryOutput>>;
  refreshToken: HubspotIntegrationObj;
  releaseNotesSubscribers: Array<ReleaseNotesSubscriberObj>;
  requestUserReviewsAppsmith?: Maybe<Array<G2UserReviewsOutput>>;
  retro: RetroObj;
  revenueDigest: Scalars['Float'];
  roadmapOkrProgress: ProductBoardOkrProgressObj;
  salesforceOpportunityProductGaps: Array<ProductGapsDto>;
  salesforceProductGaps: Array<ProductGapsDto>;
  sameDomainOrganization: OrganizationObj;
  savedInsightsSummaries: Array<InsightsSavedSummaryObj>;
  scrapeCompanyPages: Scalars['String'];
  searchAnnouncementRecipients: Array<AnnouncementRecipientObj>;
  searchMessagesGroupsParticipants: Array<MessageGroupParticipantObj>;
  sendReleaseNoteNotification: Scalars['Boolean'];
  showUpgradeButton: Scalars['Boolean'];
  stripeAccess: StripeAccessObj;
  supportedIntegrations: Array<SupportedIntegration>;
  survey: SurveyObj;
  surveyTypes: Array<SurveyTypeObj>;
  surveys: PaginatedSurveyObj;
  tag: TagObj;
  tags: Array<TagObj>;
  tagsForTasksGroupBy: Array<TagObj>;
  task: TaskObj;
  taskFilterOptions: TaskFilterOptionsObj;
  tasksAssignees: Array<UserObj>;
  tasksBetweenDates: Array<TaskObj>;
  tasksProgress: TasksProgressObj;
  tasksTags: Array<TagObj>;
  template: TemplateObj;
  templateModule: TemplateModuleObj;
  templateModules: Array<TemplateModuleObj>;
  testAIResponse: Scalars['String'];
  testAi: Scalars['Boolean'];
  testimonial: TestimonialObj;
  updateAiSettingsUsingScrappedWebsiteOrganization: Scalars['Boolean'];
  updateDemoWorkspaceDates: Scalars['String'];
  user: UserObj;
  users: Array<UserObj>;
  usersInOrganization: PaginatedUsersInOrganizationObj;
  validateExternalProjectURLs: Array<IntegrationProjectObj>;
  winLossGraph: WinLossGraphDataObj;
  winLossIntegrationStatus: CrmIntegrationStatuses;
  winlossLostRevenueDigest: WinLossRevenueDigestObj;
  winlossMetrics: WinLossMetricsObj;
  winlossTakeawaysSummary: WinlossTakeawaysSummaryObj;
};


export type QueryGptGetLaunchSummaryArgs = {
  launchId: Scalars['String'];
};


export type QueryGptGetMessagingStrategyArgs = {
  description: Scalars['String'];
  launchId: Scalars['String'];
};


export type QueryGptGetObjectivesArgs = {
  input: GptGetObjectivesInput;
};


export type QueryGptGetPositioningStrategyArgs = {
  input: GptGetPositioningStrategyInput;
};


export type QueryAiConvertTojsonArgs = {
  json: Scalars['String'];
  text: Scalars['String'];
};


export type QueryAdminGenerateLaunchContentArgs = {
  launchId: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};


export type QueryAdminGenerateLaunchSummaryArgs = {
  launchId: Scalars['String'];
};


export type QueryAdminOrgTemplatesArgs = {
  org_id: Scalars['String'];
};


export type QueryAdminOrgUploadedTemplateFilesArgs = {
  org_id: Scalars['String'];
};


export type QueryAdminOrganizationArgs = {
  id?: Maybe<Scalars['String']>;
};


export type QueryAdminTemplateArgs = {
  id: Scalars['String'];
};


export type QueryAdminTemplateModuleArgs = {
  id: Scalars['String'];
};


export type QueryAdminUserArgs = {
  id: Scalars['String'];
};


export type QueryAdminUsersArgs = {
  filter?: Maybe<FilterUserInput>;
};


export type QueryAnnouncementArgs = {
  id: Scalars['String'];
};


export type QueryAssetArgs = {
  id: Scalars['String'];
};


export type QueryAssetFilterOptionsArgs = {
  filter?: Maybe<FilterAssetsInput>;
};


export type QueryAssetsArgs = {
  filter?: Maybe<FilterAssetsInput>;
  sort?: Maybe<SortAssetsInput>;
};


export type QueryCdpAccountArgs = {
  id: Scalars['String'];
};


export type QueryCdpContactArgs = {
  id: Scalars['String'];
};


export type QueryCdpDealArgs = {
  id: Scalars['String'];
};


export type QueryCdpOwnerArgs = {
  id: Scalars['String'];
};


export type QueryChannelsArgs = {
  launchId: Scalars['String'];
};


export type QueryChannelsBetweenDatesArgs = {
  input: DateRangeInput;
};


export type QueryChatGtmArgs = {
  query: Scalars['String'];
  sessionId: Scalars['String'];
};


export type QueryClearbitCompanyArgs = {
  companyUrl: Scalars['String'];
};


export type QueryClearbitForOnboardingArgs = {
  companyDomain?: Maybe<Scalars['String']>;
};


export type QueryCommentsArgs = {
  filter?: Maybe<FilterCommentInput>;
};


export type QueryCompaniesArgs = {
  launchId?: Maybe<Scalars['String']>;
};


export type QueryCompanyArgs = {
  id: Scalars['String'];
};


export type QueryCompanyInfoFromWebsiteArgs = {
  companyDomain?: Maybe<Scalars['String']>;
  refresh?: Maybe<Scalars['Boolean']>;
};


export type QueryCompanyRatingArgs = {
  companyName: Scalars['String'];
};


export type QueryCompetitiveIntelligenceFeaturesArgs = {
  filter?: Maybe<FilterFeatureTableInput>;
  input: FeatureTableInput;
};


export type QueryCopyAndAssetsProgressArgs = {
  launchId: Scalars['String'];
};


export type QueryCountAssetsArgs = {
  filter?: Maybe<FilterAssetsInput>;
};


export type QueryCountFeedbackBoardsArgs = {
  filter?: Maybe<FeedbackBoardsFilterInput>;
};


export type QueryCountFeedbackPostsArgs = {
  filter?: Maybe<FilterFeedbackPostsInput>;
};


export type QueryCountLaunchesArgs = {
  filter?: Maybe<FilterLaunchInput>;
};


export type QueryCountObjectivesArgs = {
  filter?: Maybe<ObjectiveFilterInput>;
};


export type QueryCountPersonasArgs = {
  input?: Maybe<PersonasInput>;
};


export type QueryCountProductBoardItemsArgs = {
  filter?: Maybe<ProductBoardItemsFilterInput>;
};


export type QueryCountProductBoardReleasesArgs = {
  filter?: Maybe<FilterProductBoardReleasesInput>;
};


export type QueryCountReleaseNotesArgs = {
  filter?: Maybe<ReleaseNotesFilterInput>;
};


export type QueryCountTasksArgs = {
  filter?: Maybe<FilterTasksInput>;
};


export type QueryCountTestimonialsArgs = {
  filter?: Maybe<TestimonialsFilterInput>;
};


export type QueryCreateIntegrationWebhookArgs = {
  integrationProjectId: Scalars['String'];
};


export type QueryCrmIntegrationArgs = {
  input: CrmIntegrationInput;
};


export type QueryCrmIntegrationOAuthUrlArgs = {
  input: CrmIntegrationOAuthUrlInput;
};


export type QueryCrmIntegrationObjectPropertiesArgs = {
  input: CrmIntegrationObjectPropertiesInput;
};


export type QueryDealArgs = {
  id: Scalars['String'];
};


export type QueryDealsArgs = {
  filter?: Maybe<FilterDealsInput>;
  sort?: Maybe<SortDealsInput>;
};


export type QueryDealsCompanyArgs = {
  id: Scalars['String'];
};


export type QueryDealsOwnerArgs = {
  id: Scalars['String'];
};


export type QueryExistingProductIdeasDigestArgs = {
  filter: FilterExistingFeedBackPostsDigestInput;
  pagination?: Maybe<PaginationInput>;
};


export type QueryExternalFeedbackBoardArgs = {
  id: Scalars['String'];
};


export type QueryExternalFeedbackBoardsArgs = {
  slug: Scalars['String'];
};


export type QueryExternalFeedbackPostArgs = {
  id: Scalars['String'];
};


export type QueryExternalFeedbackPostsArgs = {
  filter?: Maybe<FilterExternalFeedbackPostsInput>;
  sort?: Maybe<SortFeedbackPostsInput>;
};


export type QueryExternalPublicPageArgs = {
  id: Scalars['String'];
};


export type QueryExternalPublicPageByDomainArgs = {
  domain: Scalars['String'];
};


export type QueryFeatureTableArgs = {
  input: FeatureTableInput;
};


export type QueryFeatureTableCategoriesArgs = {
  input: FeatureTableCategoryInput;
};


export type QueryFeedbackBoardArgs = {
  id: Scalars['String'];
};


export type QueryFeedbackBoardsArgs = {
  filter?: Maybe<FeedbackBoardsFilterInput>;
  sort?: Maybe<FeedbackBoardsSortInput>;
};


export type QueryFeedbackPostArgs = {
  id: Scalars['String'];
};


export type QueryFeedbackPostsArgs = {
  filter?: Maybe<FilterFeedbackPostsInput>;
  sort?: Maybe<SortFeedbackPostsInput>;
};


export type QueryFeedbackPostsViewArgs = {
  id: Scalars['String'];
};


export type QueryFindIntegrationChannelsArgs = {
  filter?: Maybe<FindIntegrationChannelsInput>;
  pagination?: Maybe<CursorPaginationInput>;
};


export type QueryFindReleaseNoteArgs = {
  id: Scalars['String'];
};


export type QueryGeDesktopReferralsArgs = {
  websiteName: Scalars['String'];
};


export type QueryGetAiSummaryArgs = {
  companyName: Scalars['String'];
};


export type QueryGetAiPromptArgs = {
  name: Scalars['String'];
};


export type QueryGetCdpContactsArgs = {
  filter?: Maybe<CdpContactItemsFilterInput>;
};


export type QueryGetCdpContactsOfAccountArgs = {
  filter?: Maybe<CdpDealItemsFilterInput>;
};


export type QueryGetCdpDealsArgs = {
  filter?: Maybe<CdpDealItemsFilterInput>;
};


export type QueryGetCdpOwnersArgs = {
  filter?: Maybe<CdpOwnerItemsFilterInput>;
};


export type QueryGetClearbitCompanyArgs = {
  domain: Scalars['String'];
};


export type QueryGetCompanyScrapedDataArgs = {
  url: Scalars['String'];
};


export type QueryGetHubspotCompanyArgs = {
  companyId: Scalars['String'];
};


export type QueryGetHubspotDealsAssociatedWithCompetitorArgs = {
  dealId: Scalars['String'];
};


export type QueryGetKpiPerformanceArgs = {
  input: PerformanceDataFilterInput;
};


export type QueryGetKeywordsArgs = {
  filter?: Maybe<FilterKeywordsInput>;
  input: SimilarWebKeywordsQueryInput;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<SortKeywordsInput>;
};


export type QueryGetMeasurementIntegrationEventPropertiesArgs = {
  eventName?: Maybe<Scalars['String']>;
  integrationType: Scalars['String'];
};


export type QueryGetMeasurementIntegrationEventsArgs = {
  integrationType: Scalars['String'];
};


export type QueryGetMessagingForMessagingLibraryArgs = {
  description: Scalars['String'];
  productLineTagId: Scalars['String'];
};


export type QueryGetObjectivesCompletionArgs = {
  input: PerformanceDataFilterInput;
};


export type QueryGetOverdueTasksArgs = {
  pagination?: Maybe<PaginationInput>;
  sort: SortTasksInput;
};


export type QueryGetPositioningStrategyForMessagingLibraryArgs = {
  input: GetAiPositioningStrategyInputForMessaging;
};


export type QueryGetProductIntegrationTasksForLaunchArgs = {
  launchId: Scalars['String'];
};


export type QueryGetRetroResponsesArgs = {
  input: RetroResultsInput;
};


export type QueryGetRetroScoreArgs = {
  input: PerformanceDataFilterInput;
};


export type QueryGetRssFeedsArgs = {
  id: Scalars['String'];
};


export type QueryGetScreenshotsArgs = {
  id: Scalars['String'];
};


export type QueryGetTotalTrafficArgs = {
  websiteName: Scalars['String'];
};


export type QueryGetTotalTrafficChartArgs = {
  input: SimilarWebChartQueryInput;
};


export type QueryGetVisitsArgs = {
  websiteName: Scalars['String'];
};


export type QueryGetWinlossAuthUrlArgs = {
  integrationType: Scalars['String'];
};


export type QueryGrainInsightIntegrationItemsArgs = {
  filter: InsightIntegrationItemsFilterInput;
};


export type QueryGrowthToolCompanyArgs = {
  companyUrl: Scalars['String'];
};


export type QueryGrowthToolCompanyNewsArgs = {
  companyUrl: Scalars['String'];
};


export type QueryGtmTimelineArgs = {
  launchId: Scalars['String'];
};


export type QueryInsightArgs = {
  id: Scalars['String'];
};


export type QueryInsightIntegrationArgs = {
  integrationId: Scalars['String'];
};


export type QueryInsightIntegrationOAuthUrlArgs = {
  input: InsightIntegrationOAuthUrlInput;
};


export type QueryInsightIntegrationsArgs = {
  input?: Maybe<InsightIntegrationsInput>;
};


export type QueryInsightsArgs = {
  filter?: Maybe<FilterInsightsInput>;
  sort?: Maybe<SortInsightsInput>;
};


export type QueryInsightsGeneratedItemArgs = {
  id: Scalars['String'];
};


export type QueryInsightsGeneratedTrendGraphArgs = {
  filter?: Maybe<FilterInsightGeneratedItemTrendGraphInput>;
};


export type QueryInsightsTrendItemArgs = {
  id: Scalars['String'];
};


export type QueryInsightsTrendItemGraphArgs = {
  filter?: Maybe<FilterInsightTrendItemGraphInput>;
};


export type QueryInsightsViewArgs = {
  id: Scalars['String'];
};


export type QueryIntegrationArgs = {
  id: Scalars['String'];
};


export type QueryIntegrationColumnsArgs = {
  input: IntegrationColumnsInput;
};


export type QueryIntegrationOAuthUrlArgs = {
  productName: Scalars['String'];
};


export type QueryIntegrationProjectArgs = {
  id: Scalars['String'];
};


export type QueryIntegrationProjectsArgs = {
  filter?: Maybe<FilterIntegrationProjectsInput>;
};


export type QueryIntegrationProjectsFetchStatusArgs = {
  id: Scalars['String'];
};


export type QueryIntegrationResourcesArgs = {
  integrationId: Scalars['String'];
};


export type QueryIntegrationResourcesFetchStatusArgs = {
  id: Scalars['String'];
};


export type QueryIntegrationSubTasksArgs = {
  parentIntegrationTaskId: Scalars['String'];
};


export type QueryIntegrationTasksArgs = {
  filter?: Maybe<FilterIntegrationTasksInput>;
};


export type QueryIntegrationTasksFetchStatusArgs = {
  id: Scalars['String'];
};


export type QueryIntegrationTasksRefreshTokenArgs = {
  id: Scalars['String'];
};


export type QueryIntegrationsTasksAssigneesArgs = {
  integrationsIds?: Maybe<Array<Scalars['String']>>;
};


export type QueryKpisArgs = {
  filter?: Maybe<KpiFilterInput>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryLaunchArgs = {
  id: Scalars['String'];
};


export type QueryLaunchContentArgs = {
  launchId: Scalars['String'];
};


export type QueryLaunchModuleArgs = {
  id: Scalars['String'];
};


export type QueryLaunchProgressArgs = {
  launchId: Scalars['String'];
};


export type QueryLaunchesArgs = {
  filter?: Maybe<FilterLaunchInput>;
  sort?: Maybe<SortLaunchInput>;
};


export type QueryMeasurementQueryArgs = {
  input: MeasurementIntegrationsQueryInput;
};


export type QueryMessageGroupArgs = {
  id: Scalars['String'];
};


export type QueryMessageGroupsArgs = {
  pagination?: Maybe<PaginationInput>;
};


export type QueryMilestonesArgs = {
  launchId: Scalars['String'];
};


export type QueryMilestonesBetweenDatesArgs = {
  input: DateRangeInput;
};


export type QueryNotificationChannelArgs = {
  input: FindNotificationChannelInput;
};


export type QueryOrganizationArgs = {
  id?: Maybe<Scalars['String']>;
};


export type QueryOrganizationIntegrationArgs = {
  id: Scalars['String'];
};


export type QueryOrganizationIntegrationsArgs = {
  filter?: Maybe<OrganizationIntegrationsQueryFilterInput>;
};


export type QueryOrganizationPhasesArgs = {
  filter?: Maybe<FilterPhaseInput>;
};


export type QueryPaginatedAnnouncementsArgs = {
  filter?: Maybe<FilterAnnouncementInput>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryPaginatedAssetGroupsArgs = {
  filter?: Maybe<FilterAssetsInput>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryPaginatedAssetsArgs = {
  filter?: Maybe<FilterAssetsInput>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<SortAssetsInput>;
};


export type QueryPaginatedCdpAccountsArgs = {
  filter?: Maybe<CdpAccountItemsFilterInput>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<CdpAccountItemsSortInput>;
};


export type QueryPaginatedCdpContactsArgs = {
  filter?: Maybe<CdpContactItemsFilterInput>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<CdpContactItemsSortInput>;
};


export type QueryPaginatedCdpDealsArgs = {
  filter?: Maybe<CdpDealItemsFilterInput>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<CdpDealItemsSortInput>;
};


export type QueryPaginatedCdpOwnersArgs = {
  filter?: Maybe<CdpOwnerItemsFilterInput>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<CdpOwnerItemsSortInput>;
};


export type QueryPaginatedClariCopilotInsightIntegrationItemsArgs = {
  filter: InsightIntegrationItemsFilterInput;
  pagination: ClariCopilotInsightIntegrationItemsPaginationInput;
};


export type QueryPaginatedCommentsArgs = {
  filter?: Maybe<FilterCommentInput>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryPaginatedCompaniesArgs = {
  filter?: Maybe<PaginatedCompaniesFilterInput>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<SortCompetitorCompaniesInput>;
};


export type QueryPaginatedCompaniesByGroupArgs = {
  filter?: Maybe<PaginatedCompaniesFilterInput>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<SortCompetitorCompaniesInput>;
};


export type QueryPaginatedCompanyGroupsArgs = {
  filter?: Maybe<PaginatedCompanyGroupsFilterInput>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<SortCompetitorCompaniesInput>;
};


export type QueryPaginatedCompetingCompaniesNewsArticlesArgs = {
  filter?: Maybe<FilterCompetingCompaniesNewsAticlesInput>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryPaginatedCompetitorsArgs = {
  pagination?: Maybe<PaginationInput>;
};


export type QueryPaginatedCrmIntegrationObjectsArgs = {
  filter: CrmIntegrationObjectsFilterInput;
  pagination?: Maybe<PaginationInput>;
};


export type QueryPaginatedDealsArgs = {
  filter?: Maybe<FilterDealsInput>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<SortDealsInput>;
};


export type QueryPaginatedDealsCompaniesArgs = {
  filter?: Maybe<FilterDealsCompaniesInput>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryPaginatedDealsOwnersArgs = {
  filter?: Maybe<FilterDealsOwnersInput>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryPaginatedExternalFeedbackPostsArgs = {
  filter?: Maybe<FilterExternalFeedbackPostsInput>;
  pagination: PaginationInput;
  sort?: Maybe<SortFeedbackPostsInput>;
};


export type QueryPaginatedFeedbackPostsArgs = {
  filter?: Maybe<FilterFeedbackPostsInput>;
  pagination: PaginationInput;
  sort?: Maybe<SortFeedbackPostsInput>;
};


export type QueryPaginatedG2UserReviewsArgs = {
  companyName: Scalars['String'];
  pagination?: Maybe<PaginationInput>;
};


export type QueryPaginatedGongInsightIntegrationItemsArgs = {
  filter: InsightIntegrationItemsFilterInput;
  pagination?: Maybe<GongInsightIntegrationItemsPaginationInput>;
};


export type QueryPaginatedInsightGeneratedItemsArgs = {
  filter?: Maybe<FilterInsightGeneratedItemInput>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<SortInsightGeneratedItemsInput>;
};


export type QueryPaginatedInsightTrendItemsArgs = {
  filter?: Maybe<FilterInsightTrendItemInput>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<SortInsightTrendItemsInput>;
};


export type QueryPaginatedInsightsArgs = {
  filter?: Maybe<FilterInsightsInput>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<SortInsightsInput>;
};


export type QueryPaginatedIntegrationTasksArgs = {
  filter?: Maybe<FilterIntegrationTasksInput>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryPaginatedIntercomInsightIntegrationItemsArgs = {
  filter: IntercomInsightIntegrationItemsFilterInput;
  pagination: IntercomInsightIntegrationItemsPaginationInput;
};


export type QueryPaginatedLaunchesArgs = {
  filter?: Maybe<FilterLaunchInput>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<SortLaunchInput>;
};


export type QueryPaginatedNewsDigestArgs = {
  createdAtGte: Scalars['DateTime'];
  pagination?: Maybe<PaginationInput>;
};


export type QueryPaginatedObjectivesArgs = {
  filter?: Maybe<ObjectiveFilterInput>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryPaginatedPersonasArgs = {
  input: PaginatedPersonasInput;
};


export type QueryPaginatedProductBoardItemsArgs = {
  filter?: Maybe<ProductBoardItemsFilterInput>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<ProductBoardItemsSortInput>;
  viewId?: Maybe<Scalars['String']>;
};


export type QueryPaginatedReleaseNotesArgs = {
  filter?: Maybe<ReleaseNotesFilterInput>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryPaginatedReviewsDigestArgs = {
  createdAtGte: Scalars['DateTime'];
  pagination?: Maybe<PaginationInput>;
};


export type QueryPaginatedSalesrepDigestArgs = {
  filter?: Maybe<FilterWinlossSalesrepDigestInput>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryPaginatedSlackInsightIntegrationItemsArgs = {
  filter: SlackInsightIntegrationItemsFilterInput;
  pagination: SlackInsightIntegrationItemsPaginationInput;
};


export type QueryPaginatedTagsArgs = {
  filter?: Maybe<PaginatedTagsFilterInput>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<SortTagsInput>;
};


export type QueryPaginatedTasksArgs = {
  filter?: Maybe<FilterTasksInput>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<SortTasksInput>;
};


export type QueryPaginatedTestimonialsArgs = {
  filter?: Maybe<TestimonialsFilterInput>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryPaginatedWinlossInsightsDigestArgs = {
  createdAtGte: Scalars['DateTime'];
  pagination?: Maybe<PaginationInput>;
};


export type QueryPaginatedWinlossTableArgs = {
  filter?: Maybe<FilterWinlossTableInput>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<SortWinlossTableInput>;
};


export type QueryPaginatedZendeskInsightIntegrationItemsArgs = {
  filter: ZendeskInsightIntegrationItemsFilterInput;
  pagination: ZendeskInsightIntegrationItemsPaginationInput;
};


export type QueryPaginatedZoomInsightIntegrationItemsArgs = {
  filter: InsightIntegrationItemsFilterInput;
  pagination: ZoomInsightIntegrationItemsPaginationInput;
};


export type QueryPendingApprovalAssetsArgs = {
  sort?: Maybe<SortAssetsInput>;
};


export type QueryPersonaArgs = {
  input: PersonaInput;
};


export type QueryPersonasArgs = {
  input?: Maybe<PersonasInput>;
};


export type QueryPreviewDefaultAssetsArgs = {
  launchId: Scalars['String'];
};


export type QueryPreviewDefaultChannelsArgs = {
  input: CreateDefaultChannelsInput;
};


export type QueryPreviewDefaultTasksArgs = {
  launchId: Scalars['String'];
};


export type QueryProductBoardItemArgs = {
  id: Scalars['String'];
};


export type QueryProductBoardItemsArgs = {
  filter?: Maybe<ProductBoardItemsFilterInput>;
};


export type QueryProductBoardItemsGroupsArgs = {
  filter?: Maybe<ProductBoardItemsFilterInput>;
  groupBy?: Maybe<ProductBoardItemsGroupBy>;
  pagination?: Maybe<PaginationInput>;
  viewId?: Maybe<Scalars['String']>;
};


export type QueryProductBoardItemsStatsArgs = {
  filter?: Maybe<ProductBoardItemsFilterInput>;
};


export type QueryProductBoardItemsViewArgs = {
  id: Scalars['String'];
};


export type QueryProductBoardKanbanMatrixArgs = {
  input: ProductBoardKanbanMatrixInput;
};


export type QueryProductBoardReleasesArgs = {
  dateRange?: Maybe<DateRangeInput>;
  input?: Maybe<ProductBoardReleasesInput>;
};


export type QueryProductBoardRoadmapArgs = {
  id: Scalars['String'];
};


export type QueryProductBoardRoadmapsArgs = {
  input?: Maybe<ProductBoardRoadmapsInput>;
};


export type QueryProductBoardSummaryArgs = {
  input?: Maybe<ProductBoardSummaryInput>;
};


export type QueryProductIntegrationTaskTypeValuesArgs = {
  integrationType: Scalars['String'];
};


export type QueryProductIntegrationTaskTypesArgs = {
  integrationIds: Array<Scalars['String']>;
};


export type QueryProductIntegrationTasksStatusArgs = {
  launchId: Scalars['String'];
};


export type QueryProductRoadmapSummaryArgs = {
  input?: Maybe<ProductBoardSummaryInput>;
};


export type QueryProposedChannelsArgs = {
  launchId: Scalars['String'];
};


export type QueryPublicLaunchPageKpisArgs = {
  filter?: Maybe<KpiFilterInput>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryPublicLaunchPageObjectivesArgs = {
  filter?: Maybe<ObjectiveFilterInput>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryPublicLaunchPagePaginatedAssetsArgs = {
  filter?: Maybe<FilterAssetsInput>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<SortAssetsInput>;
};


export type QueryPublicLaunchPagePaginatedTasksArgs = {
  filter?: Maybe<FilterTasksInput>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<SortTasksInput>;
};


export type QueryPublicLaunchPagePersonasArgs = {
  input?: Maybe<PersonasInput>;
};


export type QueryPublicLaunchPageTagsArgs = {
  input?: Maybe<FindTagsInput>;
};


export type QueryPublicOrganizationArgs = {
  domain?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};


export type QueryPublicPageArgs = {
  id: Scalars['String'];
};


export type QueryPublicPageFeedbackPostArgs = {
  publicPageId: Scalars['String'];
  publicPostId: Scalars['String'];
};


export type QueryPublicPageFeedbackPostsArgs = {
  pagination?: Maybe<PaginationInput>;
  publicPageId: Scalars['String'];
};


export type QueryPublicPagePaginatedReleaseNotesArgs = {
  pagination?: Maybe<PaginationInput>;
  publicPageId: Scalars['String'];
};


export type QueryPublicPageReleaseNoteArgs = {
  publicPageId: Scalars['String'];
  publicReleaseNoteId: Scalars['String'];
};


export type QueryPublicPagesArgs = {
  filter?: Maybe<PaginatedPublicPagesFilterInput>;
  pagination?: Maybe<PaginationInput>;
};


export type QueryPublicPaginatedProductRoadmapItemsArgs = {
  filter?: Maybe<ProductBoardItemsFilterInput>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<ProductBoardItemsSortInput>;
  viewId?: Maybe<Scalars['String']>;
};


export type QueryPublicProductRoadmapArgs = {
  id: Scalars['String'];
};


export type QueryPublicProductRoadmapItemArgs = {
  id: Scalars['String'];
};


export type QueryPublicProductRoadmapItemsArgs = {
  filter?: Maybe<ProductBoardItemsFilterInput>;
};


export type QueryPublicProductRoadmapKanbanMatrixArgs = {
  input: ProductBoardKanbanMatrixInput;
};


export type QueryPublicProductRoadmapReleasesArgs = {
  dateRange?: Maybe<DateRangeInput>;
  input?: Maybe<ProductBoardReleasesInput>;
};


export type QueryPublicProductRoadmapTagsArgs = {
  input?: Maybe<FindTagsInput>;
};


export type QueryPublicProductRoadmapsArgs = {
  input?: Maybe<ProductBoardRoadmapsInput>;
};


export type QueryPublicReleaseNoteArgs = {
  releaseId: Scalars['String'];
  slug: Scalars['String'];
};


export type QueryPublicReleaseNotesArgs = {
  filter?: Maybe<PublicReleaseNotesFilterInput>;
  pagination?: Maybe<PaginationInput>;
  slug: Scalars['String'];
};


export type QueryPublicReleaseNotesTagsArgs = {
  slug: Scalars['String'];
};


export type QueryRatingSummaryArgs = {
  companyName: Scalars['String'];
};


export type QueryRefreshTokenArgs = {
  id: Scalars['String'];
};


export type QueryRequestUserReviewsAppsmithArgs = {
  companyUrl: Scalars['String'];
};


export type QueryRetroArgs = {
  filter?: Maybe<FilterRetroInput>;
  sort?: Maybe<SortRetroInput>;
};


export type QueryRevenueDigestArgs = {
  createdAtGte: Scalars['DateTime'];
};


export type QueryRoadmapOkrProgressArgs = {
  ids?: Maybe<Array<Scalars['String']>>;
};


export type QuerySavedInsightsSummariesArgs = {
  input?: Maybe<SavedInsightsSummariesInput>;
};


export type QueryScrapeCompanyPagesArgs = {
  companyName: Scalars['String'];
  url: Scalars['String'];
};


export type QuerySearchAnnouncementRecipientsArgs = {
  input: SearchAnnouncementRecipientsInput;
};


export type QuerySearchMessagesGroupsParticipantsArgs = {
  input: SearchMessagesGroupsParticipantsInput;
};


export type QuerySurveyArgs = {
  id: Scalars['String'];
};


export type QuerySurveysArgs = {
  pagination?: Maybe<PaginationInput>;
};


export type QueryTagArgs = {
  input: FindTagInput;
};


export type QueryTagsArgs = {
  input?: Maybe<FindTagsInput>;
};


export type QueryTagsForTasksGroupByArgs = {
  isPreBuilt?: Maybe<Scalars['Boolean']>;
};


export type QueryTaskArgs = {
  id: Scalars['String'];
};


export type QueryTaskFilterOptionsArgs = {
  filter?: Maybe<FilterTasksInput>;
};


export type QueryTasksAssigneesArgs = {
  filter?: Maybe<FilterTasksInput>;
};


export type QueryTasksBetweenDatesArgs = {
  input: DateRangeInput;
};


export type QueryTasksProgressArgs = {
  launchId?: Maybe<Scalars['String']>;
};


export type QueryTasksTagsArgs = {
  filter?: Maybe<FilterTasksInput>;
};


export type QueryTemplateArgs = {
  id: Scalars['String'];
};


export type QueryTemplateModuleArgs = {
  id: Scalars['String'];
};


export type QueryTestAiResponseArgs = {
  prompt: Scalars['String'];
};


export type QueryTestAiArgs = {
  domainName: Scalars['String'];
};


export type QueryTestimonialArgs = {
  id: Scalars['String'];
};


export type QueryUpdateAiSettingsUsingScrappedWebsiteOrganizationArgs = {
  organizationId: Scalars['String'];
};


export type QueryUserArgs = {
  id?: Maybe<Scalars['String']>;
};


export type QueryUsersArgs = {
  filter?: Maybe<FilterUserInput>;
};


export type QueryUsersInOrganizationArgs = {
  pagination?: Maybe<PaginationInput>;
  search?: Maybe<Scalars['String']>;
};


export type QueryValidateExternalProjectUrLsArgs = {
  input: FetchIntegrationProjectsInput;
};


export type QueryWinLossGraphArgs = {
  filter?: Maybe<FilterWinlossGraphInput>;
};


export type QueryWinlossLostRevenueDigestArgs = {
  createdAtGte: Scalars['DateTime'];
};


export type QueryWinlossMetricsArgs = {
  filter?: Maybe<FilterWinlossMetricsInput>;
};

export enum RepeatNotificationTypes {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  ONCE = 'ONCE',
  WEEKLY = 'WEEKLY'
}

export enum RoadmapGroupKeys {
  ASSIGNEE = 'ASSIGNEE',
  LAUNCH = 'LAUNCH',
  RELEASE = 'RELEASE',
  STATUS = 'STATUS'
}

export enum RoadmapItemPriority {
  P0 = 'P0',
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3'
}

export type RatingSummaryOutput = {
  __typename?: 'RatingSummaryOutput';
  noOfReviews?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

export type RecipientDataObj = {
  __typename?: 'RecipientDataObj';
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type RecipientObj = {
  __typename?: 'RecipientObj';
  id: Scalars['String'];
  messageGroupIds: Array<Scalars['String']>;
  nonUserIds: Array<Scalars['String']>;
  userIds: Array<Scalars['String']>;
};

export type ReferrelsOutput = {
  __typename?: 'ReferrelsOutput';
  change?: Maybe<Scalars['Float']>;
  domain: Scalars['String'];
  share: Scalars['Float'];
};

export type RegisterNotificationChannelInput = {
  accessToken: Scalars['String'];
  accessTokenOwnerId?: Maybe<Scalars['String']>;
  lastRefresedOn?: Maybe<Scalars['DateTime']>;
  refreshToken?: Maybe<Scalars['String']>;
  scope?: Maybe<NotificationTokenScope>;
  source?: Maybe<NotificationSources>;
  validTill?: Maybe<Scalars['DateTime']>;
};

export type RegisterUserInput = {
  email: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  origin?: Maybe<OrganizationOrigins>;
  password?: Maybe<Scalars['String']>;
  profileImage?: Maybe<Scalars['String']>;
};

export type ReleaseNoteObj = {
  __typename?: 'ReleaseNoteObj';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  internal?: Maybe<Scalars['Boolean']>;
  launch?: Maybe<LaunchObj>;
  launchId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  owner?: Maybe<UserObj>;
  ownerId?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<TagObj>>;
  tagsIds?: Maybe<Array<Scalars['String']>>;
  updatedAt: Scalars['DateTime'];
};

export type ReleaseNotesFilterInput = {
  dueDateExists?: Maybe<Scalars['Boolean']>;
  endDueDate?: Maybe<Scalars['DateTime']>;
  internal?: Maybe<Scalars['Boolean']>;
  launchIds?: Maybe<Array<Scalars['String']>>;
  live?: Maybe<Scalars['Boolean']>;
  ownerIds?: Maybe<Array<Scalars['String']>>;
  query?: Maybe<Scalars['String']>;
  startDueDate?: Maybe<Scalars['DateTime']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};

export type ReleaseNotesFiltersInput = {
  dueDateExists?: Maybe<Scalars['Boolean']>;
  endDueDate?: Maybe<Scalars['DateTime']>;
  internal?: Maybe<Scalars['Boolean']>;
  launchIds?: Maybe<Array<Scalars['String']>>;
  live?: Maybe<Scalars['Boolean']>;
  ownerIds?: Maybe<Array<Scalars['String']>>;
  query?: Maybe<Scalars['String']>;
  startDueDate?: Maybe<Scalars['DateTime']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};

export type ReleaseNotesFiltersObj = {
  __typename?: 'ReleaseNotesFiltersObj';
  dueDateExists?: Maybe<Scalars['Boolean']>;
  endDueDate?: Maybe<Scalars['DateTime']>;
  internal?: Maybe<Scalars['Boolean']>;
  launchIds: Array<Scalars['String']>;
  live?: Maybe<Scalars['Boolean']>;
  ownerIds: Array<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  startDueDate?: Maybe<Scalars['DateTime']>;
  tagIds: Array<Scalars['String']>;
};

export type ReleaseNotesSubscriberObj = {
  __typename?: 'ReleaseNotesSubscriberObj';
  email: Scalars['String'];
  id: Scalars['String'];
  isVerified: Scalars['Boolean'];
  organizationId: Scalars['String'];
};

export type RemoveLaunchPhaseApproversInput = {
  approvers: Array<Scalars['String']>;
  launchId: Scalars['String'];
  phaseId: Scalars['String'];
};

export type RemovePhaseApproversInput = {
  approvers: Array<Scalars['String']>;
  id: Scalars['String'];
};

export type RemoveProductBoardItemDependencyInput = {
  blockedById: Scalars['String'];
  blockingId: Scalars['String'];
};

export type RemoveProductBoardItemDependencyResultObj = {
  __typename?: 'RemoveProductBoardItemDependencyResultObj';
  blockedByItem: ProductBoardItemObj;
  blockingItem: ProductBoardItemObj;
};

export type RemoveUsersFromLaunchInput = {
  launchId: Scalars['String'];
  launchModuleIds: Array<Scalars['String']>;
  userIds: Array<Scalars['String']>;
};

export type RequestApproveAssetInput = {
  assetId: Scalars['String'];
  assetURL: Scalars['String'];
  recipients: Array<RequestApproveAssetRecipientsInput>;
};

export type RequestApproveAssetRecipientsInput = {
  approveAssetURL: Scalars['String'];
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type ResetPasswordInput = {
  currentPassword?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  newPassword: Scalars['String'];
  newPasswordToken?: Maybe<Scalars['String']>;
};

export type RetroAnswersObj = {
  __typename?: 'RetroAnswersObj';
  id?: Maybe<Scalars['String']>;
  internalScore?: Maybe<RetroScoreObj>;
  respondentAnswers?: Maybe<Array<RetroRespondentAnswerObj>>;
};

export type RetroObj = {
  __typename?: 'RetroObj';
  emailBody?: Maybe<Scalars['String']>;
  emailSubject?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isAnonymous?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  recipientsData: Array<RecipientDataObj>;
  resultLink?: Maybe<Scalars['String']>;
  sentOn?: Maybe<Scalars['DateTime']>;
  status?: Maybe<SurveyStatus>;
  surveyType?: Maybe<SurveyTypes>;
  takeaways?: Maybe<Scalars['String']>;
  webLink?: Maybe<Scalars['String']>;
};

export type RetroRespondentAnswerObj = {
  __typename?: 'RetroRespondentAnswerObj';
  answerImprovement: Scalars['String'];
  answerLearning: Scalars['String'];
  answerWell: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  score: Scalars['String'];
};

export type RetroResultsInput = {
  launchId?: Maybe<Scalars['String']>;
  retroId?: Maybe<Scalars['String']>;
};

export type RetroScoreObj = {
  __typename?: 'RetroScoreObj';
  negative: Scalars['Float'];
  neutral: Scalars['Float'];
  nps: Scalars['Float'];
  positive: Scalars['Float'];
};

export type RoadmappingSectionObj = {
  __typename?: 'RoadmappingSectionObj';
  isCompletedConnectCRM: Scalars['Boolean'];
  isCompletedConnectTasksIntegration: Scalars['Boolean'];
  isCompletedCreateRoadmapItem: Scalars['Boolean'];
  isCompletedImportRoadmapData: Scalars['Boolean'];
};

export type RoadmapsPagesSettingsObj = {
  __typename?: 'RoadmapsPagesSettingsObj';
  ids: Array<Scalars['String']>;
  live: Scalars['Boolean'];
};

export type RssFeedDataObj = {
  __typename?: 'RssFeedDataObj';
  createdAt?: Maybe<Scalars['DateTime']>;
  key?: Maybe<Scalars['String']>;
  pageUrl?: Maybe<Scalars['String']>;
  rssFeedData?: Maybe<Array<RssFeedLinkDataObj>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RssFeedLinkDataObj = {
  __typename?: 'RssFeedLinkDataObj';
  description?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  published_date?: Maybe<Scalars['String']>;
  sourceTitle?: Maybe<Scalars['String']>;
  sourceUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type RssFeedUrlObj = {
  __typename?: 'RssFeedUrlObj';
  key?: Maybe<Scalars['String']>;
  pageUrl?: Maybe<Scalars['String']>;
};

export enum SalesforceCompetitorType {
  CUSTOMFIELD = 'CUSTOMFIELD',
  CUSTOMOBJECT = 'CUSTOMOBJECT'
}

export enum SampleDataEntities {
  BATTLE_CARDS = 'BATTLE_CARDS',
  IDEAS = 'IDEAS',
  INSIGHTS = 'INSIGHTS',
  LAUNCH = 'LAUNCH',
  OKRS = 'OKRS',
  PERSONAS = 'PERSONAS',
  PRODUCT_BOARD_ITEM = 'PRODUCT_BOARD_ITEM',
  RELEASE_NOTES = 'RELEASE_NOTES',
  TESTIMONIALS = 'TESTIMONIALS'
}

export enum SimilarwebKeywordsTypes {
  ORGANIC = 'ORGANIC',
  PAID = 'PAID'
}

export enum SimilarwebTimeFrame {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY'
}

export enum SlackConversationType {
  GROUP = 'GROUP',
  IM = 'IM',
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export enum StakeholderTypes {
  APPROVER = 'APPROVER',
  EDITOR = 'EDITOR',
  OWNER = 'OWNER',
  VIEWER = 'VIEWER'
}

export enum StrategicApproach {
  CATEGORY_CREATION = 'CATEGORY_CREATION',
  CATEGORY_GROWTH = 'CATEGORY_GROWTH',
  CATEGORY_PENETRATION = 'CATEGORY_PENETRATION',
  COMPETITIVE_SWITCHING = 'COMPETITIVE_SWITCHING',
  GENERAL_ADOPTION = 'GENERAL_ADOPTION'
}

export enum SubscriptionPayloadEventType {
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  UPDATED = 'UPDATED'
}

export enum SurveyStatus {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  SENT = 'SENT'
}

export enum SurveyTypes {
  BRAND_PERFORMANCE_STUDY = 'BRAND_PERFORMANCE_STUDY',
  FEATURE_IMPORTANCE_STUDY_MAXDIFF = 'FEATURE_IMPORTANCE_STUDY_MAXDIFF',
  MESSAGE_TESTING = 'MESSAGE_TESTING',
  NET_PROMOTER_SCORE = 'NET_PROMOTER_SCORE',
  NET_PROMOTER_SCORE_INTERNAL_RETRO = 'NET_PROMOTER_SCORE_INTERNAL_RETRO',
  PRICING_STUDY_GABOR_GRANGER = 'PRICING_STUDY_GABOR_GRANGER',
  PRICING_STUDY_VAN_WESTENDORP = 'PRICING_STUDY_VAN_WESTENDORP',
  PRODUCT_MARKET_FIT = 'PRODUCT_MARKET_FIT',
  SIMPLE_PERSONA_MEDIA_CONSUMPTION = 'SIMPLE_PERSONA_MEDIA_CONSUMPTION'
}

export type SalesforceCompetitorsDataObj = {
  __typename?: 'SalesforceCompetitorsDataObj';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type SalesforceIntegrationFields = {
  __typename?: 'SalesforceIntegrationFields';
  competitorFieldType?: Maybe<SalesforceCompetitorType>;
  competitorObjectName?: Maybe<Scalars['String']>;
  dealNotesFieldName?: Maybe<Scalars['String']>;
  lostNotesFieldName?: Maybe<Scalars['String']>;
};

export type SampleDataDeleteDetailsInput = {
  battleCards?: Maybe<SampleDataFlagInput>;
  ideas?: Maybe<SampleDataFlagInput>;
  insights?: Maybe<SampleDataFlagInput>;
  launch?: Maybe<SampleDataFlagInput>;
  okrs?: Maybe<SampleDataFlagInput>;
  personas?: Maybe<SampleDataFlagInput>;
  productBoardItems?: Maybe<SampleDataFlagInput>;
  releaseNotes?: Maybe<SampleDataFlagInput>;
  testimonials?: Maybe<SampleDataFlagInput>;
};

export type SampleDataDeleteDetailsObj = {
  __typename?: 'SampleDataDeleteDetailsObj';
  battleCards: SampleDataFlagObj;
  ideas: SampleDataFlagObj;
  insights: SampleDataFlagObj;
  launch: SampleDataFlagObj;
  okrs: SampleDataFlagObj;
  personas: SampleDataFlagObj;
  productBoardItems: SampleDataFlagObj;
  releaseNotes: SampleDataFlagObj;
  testimonials: SampleDataFlagObj;
};

export type SampleDataFlagInput = {
  sampleDataDeleted?: Maybe<Scalars['Boolean']>;
  showSampleDataDeleteFlag?: Maybe<Scalars['Boolean']>;
};

export type SampleDataFlagObj = {
  __typename?: 'SampleDataFlagObj';
  sampleDataDeleted: Scalars['Boolean'];
  showSampleDataDeleteFlag: Scalars['Boolean'];
};

export type SaveFailedCsvUploadInput = {
  errorMessage: Scalars['String'];
  fieldMappings: Array<SaveFailedCsvUploadInputFieldMapping>;
  type: CsvUploadType;
  url: Scalars['String'];
};

export type SaveFailedCsvUploadInputFieldMapping = {
  columnName: Scalars['String'];
  field: Scalars['String'];
};

export type SaveInsightsSummaryInput = {
  name: Scalars['String'];
  summaryId: Scalars['String'];
  type: InsightsSummaryType;
};

export type SavedInsightsSummariesInput = {
  query?: Maybe<Scalars['String']>;
  savedById?: Maybe<Scalars['String']>;
};

export type ScreenshotImageVersionObj = {
  __typename?: 'ScreenshotImageVersionObj';
  createdAt?: Maybe<Scalars['String']>;
  screenshotUrl?: Maybe<Scalars['String']>;
};

export type Screenshots = {
  __typename?: 'Screenshots';
  key?: Maybe<Scalars['String']>;
  pageUrl?: Maybe<Scalars['String']>;
};

export type ScreenshotsData = {
  __typename?: 'ScreenshotsData';
  id?: Maybe<Scalars['String']>;
  screenshotsObj?: Maybe<Array<ScreenshotsObj>>;
};

export type ScreenshotsObj = {
  __typename?: 'ScreenshotsObj';
  createdAt?: Maybe<Scalars['DateTime']>;
  key?: Maybe<Scalars['String']>;
  pageUrl?: Maybe<Scalars['String']>;
  screenshotUrls?: Maybe<Array<ScreenshotImageVersionObj>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SearchAnnouncementRecipientsInput = {
  limit?: Maybe<Scalars['Float']>;
  search: Scalars['String'];
};

export type SearchMessagesGroupsParticipantsInput = {
  limit?: Maybe<Scalars['Float']>;
  search: Scalars['String'];
};

export type SectionVisibilityPreferencesInput = {
  assets: Scalars['Boolean'];
  modules: Scalars['Boolean'];
  objectives: Scalars['Boolean'];
  tasks: Scalars['Boolean'];
  timeline: Scalars['Boolean'];
};

export type SectionVisibilityPreferencesObj = {
  __typename?: 'SectionVisibilityPreferencesObj';
  assets: Scalars['Boolean'];
  modules: Scalars['Boolean'];
  objectives: Scalars['Boolean'];
  tasks: Scalars['Boolean'];
  timeline: Scalars['Boolean'];
};

export type SelectInsightIntegrationItemsInput = {
  generateFeedbackPosts?: Maybe<Scalars['Boolean']>;
  integrationId: Scalars['String'];
  itemIds: Array<Scalars['String']>;
};

export type SelectIntegrationProjectInput = {
  id: Scalars['String'];
  roadmapTasks?: Maybe<Scalars['Boolean']>;
};

export type SendSurveyInput = {
  surveyId: Scalars['String'];
};

export type SimilarWebChartQueryInput = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  timeFrameSelected: SimilarwebTimeFrame;
  websiteName: Scalars['String'];
};

export type SimilarWebChartQueryOutput = {
  __typename?: 'SimilarWebChartQueryOutput';
  dates: Array<Scalars['String']>;
  visits: Array<Scalars['Float']>;
};

export type SimilarWebKeywordsQueryInput = {
  type: SimilarwebKeywordsTypes;
  websiteName: Scalars['String'];
};

export type SimilarWebOutput = {
  __typename?: 'SimilarWebOutput';
  createdAt?: Maybe<Scalars['DateTime']>;
  organicKeywordVisits?: Maybe<Scalars['Float']>;
  paidKeywordVisits?: Maybe<Scalars['Float']>;
  totalVisits?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteName?: Maybe<Scalars['String']>;
};

export type SlackInsightIntegrationItemsFilterInput = {
  channelId: Scalars['String'];
  endDate: Scalars['Timestamp'];
  integrationId: Scalars['String'];
  startDate: Scalars['Timestamp'];
};

export type SlackInsightIntegrationItemsPaginationInput = {
  cursor?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
};

export type SortAssetsInput = {
  createdAt?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['Float']>;
  orderIndex?: Maybe<Scalars['Float']>;
};

export type SortCompetitorCompaniesInput = {
  docsSort?: Maybe<BattlecardsDocsSortKeys>;
  groupBy?: Maybe<BattlecardsGroupByKeys>;
};

export type SortDealsInput = {
  sort: SortOrder;
  sortBy: DealsSortBy;
};

export type SortFeedbackPostsInput = {
  sort: SortOrder;
  sortBy: FeedbackPostsSortBy;
};

export type SortInsightGeneratedItemsInput = {
  createdAt?: Maybe<FieldSortInput>;
  noOfInsights?: Maybe<FieldSortInput>;
  text?: Maybe<FieldSortInput>;
};

export type SortInsightTrendItemsInput = {
  createdAt?: Maybe<FieldSortInput>;
  noOfInsights?: Maybe<FieldSortInput>;
  text?: Maybe<FieldSortInput>;
};

export type SortInsightsInput = {
  sort: SortOrder;
  sortBy: InsightsSortBy;
};

export type SortKeywordsInput = {
  sort: SortOrder;
  sortBy: KeywordsSortKeys;
};

export type SortLaunchInput = {
  launchDate?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['Float']>;
};

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type SortRetroInput = {
  createdAt?: Maybe<Scalars['Float']>;
};

export type SortTagsInput = {
  sort: SortOrder;
  sortBy: TagsSortKeys;
};

export type SortTasksInput = {
  docsSort?: Maybe<TasksDocsSortKeys>;
  groupBy?: Maybe<TasksGroupByKeys>;
  groupValues?: Maybe<Array<Scalars['String']>>;
  groupsSort?: Maybe<TasksDocsSortKeys>;
};

export type SortWinlossTableInput = {
  sort: SortOrder;
  sortBy: WinlossTableSortBy;
};

export type StageObj = {
  __typename?: 'StageObj';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type StripeAccessObj = {
  __typename?: 'StripeAccessObj';
  canAddEditor: Scalars['Boolean'];
  canCreateBattleCard: Scalars['Boolean'];
  canCreateLaunch: Scalars['Boolean'];
  canCreateProductIdeaBoard: Scalars['Boolean'];
  canCreateRoadmap: Scalars['Boolean'];
  canCreateRoadmapItem: Scalars['Boolean'];
  canCreateSurvey: Scalars['Boolean'];
  organizationId: Scalars['String'];
};

export type StripeCheckoutLinkV2Input = {
  priceIds?: Maybe<Array<Scalars['String']>>;
};

export type StripeCheckoutLinkV3Input = {
  priceIds?: Maybe<Array<Scalars['String']>>;
  quantity?: Maybe<Scalars['Float']>;
};

export type StripeInvoiceObj = {
  __typename?: 'StripeInvoiceObj';
  amount_due: Scalars['Float'];
  amount_paid: Scalars['Float'];
  amount_remaining: Scalars['Float'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  invoice_pdf?: Maybe<Scalars['String']>;
};

export type StripePaymentMethod = {
  __typename?: 'StripePaymentMethod';
  cardBrand: Scalars['String'];
  cardLast4: Scalars['String'];
  id: Scalars['String'];
};

export type StripePriceObj = {
  __typename?: 'StripePriceObj';
  amount: Scalars['Float'];
  id: Scalars['String'];
  interval?: Maybe<Scalars['String']>;
  tiers?: Maybe<Array<StripePriceTierObj>>;
};

export type StripePriceTierObj = {
  __typename?: 'StripePriceTierObj';
  flatAmount: Scalars['Float'];
  upTo?: Maybe<Scalars['Float']>;
};

export type StripeProductObj = {
  __typename?: 'StripeProductObj';
  appsumo?: Maybe<Scalars['Boolean']>;
  daysInFreeTrial?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  displayType?: Maybe<Scalars['String']>;
  downgradable?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isSubscribed?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Float']>;
  prices?: Maybe<Array<StripePriceObj>>;
  subscription?: Maybe<StripeSubscriptionObj>;
  upgradable?: Maybe<Scalars['Boolean']>;
};

export type StripeSubscriptionObj = {
  __typename?: 'StripeSubscriptionObj';
  createdAt?: Maybe<Scalars['DateTime']>;
  currentPeriodEnd?: Maybe<Scalars['DateTime']>;
  currentPeriodStart?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  itemId: Scalars['String'];
  price?: Maybe<StripePriceObj>;
  priceIds?: Maybe<Array<Scalars['String']>>;
  prices?: Maybe<Array<StripePriceObj>>;
  productIds?: Maybe<Array<Scalars['String']>>;
  products: Array<StripeProductObj>;
  quantity?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
};

export type StyleSettingsInput = {
  accentColor: Scalars['String'];
  backgroundColor: Scalars['String'];
  customCss: Scalars['String'];
  font?: Maybe<Scalars['String']>;
  textColor: Scalars['String'];
};

export type StyleSettingsObj = {
  __typename?: 'StyleSettingsObj';
  accentColor: Scalars['String'];
  backgroundColor: Scalars['String'];
  customCss: Scalars['String'];
  font?: Maybe<Scalars['String']>;
  textColor: Scalars['String'];
};

export type Subscription = {
  __typename?: 'Subscription';
  alteredLaunch: LaunchObj;
  alteredLaunchModule: LaunchModuleObj;
  alteredLaunchModuleUserInput: LaunchModuleObj;
  alteredLaunchTask: TaskObj;
  channelsUpdated: ChannelsSubscriptionResponse;
  commentCreated: CommentObj;
  commentUpdated: CommentObj;
  crmIntegrationCreated: CrmIntegrationObj;
  customDomainScreenshot: ScreenshotsObj;
  integrationCreated: Integration;
  integrationRemoved: Integration;
  keyPeopleFetched: Array<KeyPeople>;
  launchTypesUpdated: LaunchTypesSubscriptionResponse;
  marketingInsightsSummaryCreated: Scalars['Boolean'];
  milestonesUpdated: MilestonesSubscriptionResponse;
  newsFetched: PaginatedCompetingCompaniesNewsArticlesObj;
  productInsightsSummaryCreated: Scalars['Boolean'];
  projects: Array<IntegrationProjectObj>;
  projectsFetchStatus: Scalars['Float'];
  rssFeedSubscription: RssFeedDataObj;
  salesforceloginSuccessfull: Scalars['String'];
  tasks: Array<IntegrationTaskObj>;
  tasksFetchedStatus: Scalars['Float'];
  timeframesUpdated: ChannelTimeframesSubscriptionResponse;
};


export type SubscriptionChannelsUpdatedArgs = {
  launchId: Scalars['String'];
};


export type SubscriptionCommentCreatedArgs = {
  parentIds: Array<Scalars['String']>;
};


export type SubscriptionCommentUpdatedArgs = {
  parentIds: Array<Scalars['String']>;
};


export type SubscriptionCrmIntegrationCreatedArgs = {
  input: CrmIntegrationCreatedSubscriptionInput;
};


export type SubscriptionCustomDomainScreenshotArgs = {
  id: Scalars['String'];
};


export type SubscriptionIntegrationCreatedArgs = {
  productName?: Maybe<IntegrationProductNames>;
};


export type SubscriptionIntegrationRemovedArgs = {
  productName?: Maybe<IntegrationProductNames>;
};


export type SubscriptionKeyPeopleFetchedArgs = {
  id: Scalars['String'];
};


export type SubscriptionMilestonesUpdatedArgs = {
  launchId: Scalars['String'];
};


export type SubscriptionNewsFetchedArgs = {
  id: Scalars['String'];
};


export type SubscriptionProjectsArgs = {
  integrationId: Scalars['String'];
};


export type SubscriptionProjectsFetchStatusArgs = {
  integrationId: Scalars['String'];
};


export type SubscriptionRssFeedSubscriptionArgs = {
  id: Scalars['String'];
};


export type SubscriptionTasksArgs = {
  integrationId: Scalars['String'];
};


export type SubscriptionTasksFetchedStatusArgs = {
  integrationId: Scalars['String'];
};


export type SubscriptionTimeframesUpdatedArgs = {
  channelId?: Maybe<Scalars['String']>;
  launchId: Scalars['String'];
};

export type SubscriptionRestrictionsCompetitiveIntelligence = {
  __typename?: 'SubscriptionRestrictionsCompetitiveIntelligence';
  refreshNewsAfterDays?: Maybe<Scalars['Float']>;
  refreshScreenshotsAfterDays?: Maybe<Scalars['Float']>;
};

export type SubscriptionRestrictionsObj = {
  __typename?: 'SubscriptionRestrictionsObj';
  numberOfEditorsAllowed?: Maybe<Scalars['Float']>;
  refreshNewsAfterDays?: Maybe<SubscriptionRestrictionsCompetitiveIntelligence>;
  researchHubAllowed?: Maybe<Scalars['Boolean']>;
};

export type SummaryUnion = InsightsMarketingSummaryObj | InsightsProductSummaryObj;

export type SupportedIntegration = {
  __typename?: 'SupportedIntegration';
  apiKeyInstructions?: Maybe<Array<Scalars['String']>>;
  displayName: Scalars['String'];
  exampleProjectURL?: Maybe<Scalars['String']>;
  logoUrl: Scalars['String'];
  manualProjectSelectionSupported?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  oAuthSupported: Scalars['Boolean'];
};

export type SurveyInputObj = {
  __typename?: 'SurveyInputObj';
  answers?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  leastImportantLabel: Scalars['String'];
  mostImportantLabel: Scalars['String'];
  opinionLeast: Scalars['String'];
  opinionMost: Scalars['String'];
  required: Scalars['Boolean'];
  slideMax: Scalars['Float'];
  slideMin: Scalars['Float'];
  slideScale: Scalars['Float'];
  title: Scalars['String'];
  type: Scalars['String'];
};

export type SurveyObj = {
  __typename?: 'SurveyObj';
  emailBody?: Maybe<Scalars['String']>;
  emailSignature?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  inputs: Array<SurveyInputObj>;
  name: Scalars['String'];
  recipients: Array<SurveyRecipientObj>;
  resultLink?: Maybe<Scalars['String']>;
  sentOn?: Maybe<Scalars['DateTime']>;
  status?: Maybe<SurveyStatus>;
  surveyType?: Maybe<SurveyTypes>;
  webLink?: Maybe<Scalars['String']>;
};

export type SurveyQuestionInputObj = {
  __typename?: 'SurveyQuestionInputObj';
  key: Scalars['String'];
  label: Scalars['String'];
  maxLength?: Maybe<Scalars['Float']>;
  minLength?: Maybe<Scalars['Float']>;
  placeholder: Scalars['String'];
  required: Scalars['Boolean'];
  type: Scalars['String'];
};

export type SurveyRecipientObj = {
  __typename?: 'SurveyRecipientObj';
  email: Scalars['String'];
  firstname: Scalars['String'];
  id: Scalars['String'];
  lastname: Scalars['String'];
  sent: Scalars['Boolean'];
};

export type SurveyTypeObj = {
  __typename?: 'SurveyTypeObj';
  inputs: Array<SurveyQuestionInputObj>;
  type: Scalars['String'];
};

export type SwapModuleSectionInput = {
  id: Scalars['String'];
  index: Scalars['Float'];
  launchId: Scalars['String'];
  sectionId: Scalars['String'];
};

export enum TagsSortKeys {
  DESCRIPTION = 'DESCRIPTION',
  LABEL = 'LABEL'
}

export enum TagParentName {
  ASSETS = 'ASSETS',
  LAUNCH = 'LAUNCH',
  TASKS = 'TASKS'
}

export enum TagTypes {
  ASSET = 'ASSET',
  CHANNEL = 'CHANNEL',
  COMPANY = 'COMPANY',
  FEEDBACK_POST = 'FEEDBACK_POST',
  LAUNCH_NAME = 'LAUNCH_NAME',
  PRODUCT_LINE = 'PRODUCT_LINE',
  RELEASE_NOTE = 'RELEASE_NOTE',
  RESEARCH_HUB_INSIGHTS = 'RESEARCH_HUB_INSIGHTS',
  RESEARCH_HUB_PERSONAS = 'RESEARCH_HUB_PERSONAS',
  RESEARCH_HUB_TESTIMONIALS = 'RESEARCH_HUB_TESTIMONIALS',
  ROADMAP_ITEM = 'ROADMAP_ITEM',
  TASK = 'TASK'
}

export enum TasksDocsSortKeys {
  ASSIGNEE = 'ASSIGNEE',
  DUE_DATE = 'DUE_DATE',
  STATUS = 'STATUS'
}

export enum TasksGroupByKeys {
  ASSIGNEE = 'ASSIGNEE',
  STATUS = 'STATUS',
  TAGS = 'TAGS'
}

export enum TasksIntegrationProductName {
  ASANA = 'ASANA',
  CLICKUP = 'CLICKUP',
  GITLAB = 'GITLAB',
  JIRA = 'JIRA',
  LINEAR = 'LINEAR',
  MONDAY = 'MONDAY',
  PRODUCTBOARD = 'PRODUCTBOARD',
  ROADMUNK = 'ROADMUNK',
  SHORTCUT = 'SHORTCUT',
  TRELLO = 'TRELLO',
  WRIKE = 'WRIKE',
  ZOHO_SPRINTS = 'ZOHO_SPRINTS'
}

export enum TaskStatusTypes {
  CANCELED = 'CANCELED',
  DELAYED = 'DELAYED',
  DONE = 'DONE',
  IN_PROCESS = 'IN_PROCESS',
  IN_REVIEW = 'IN_REVIEW',
  NOT_STARTED = 'NOT_STARTED'
}

export enum TaskTypes {
  LAUNCH = 'LAUNCH',
  POST_LAUNCH = 'POST_LAUNCH',
  PRE_LAUNCH = 'PRE_LAUNCH'
}

export enum TemplateModulesTypes {
  IGNITION_APPROVED_TEMPLATE_MODULE = 'IGNITION_APPROVED_TEMPLATE_MODULE',
  ORGANIZATION_TEMPLATE_MODULE = 'ORGANIZATION_TEMPLATE_MODULE'
}

export enum TestimonialStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export type TagFilterOptionObj = {
  __typename?: 'TagFilterOptionObj';
  color: Scalars['String'];
  label: Scalars['String'];
  value: Scalars['String'];
};

export type TagObj = {
  __typename?: 'TagObj';
  color: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isPreBuilt: Scalars['Boolean'];
  label: Scalars['String'];
  organizationId: Scalars['String'];
  type: TagTypes;
};

export type TalkingPoints = {
  __typename?: 'TalkingPoints';
  placeholder?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type TaskFilterOptionsObj = {
  __typename?: 'TaskFilterOptionsObj';
  assigneeOptions: Array<UserFilterOptionObj>;
  launchOptions: Array<LaunchFilterOptionObj>;
  ownerOptions: Array<UserFilterOptionObj>;
  priorities: Array<Scalars['Int']>;
  statuses: Array<TaskStatusTypes>;
  tagOptions: Array<TagFilterOptionObj>;
  types: Array<TaskTypes>;
};

export type TaskIdsWithSubTaskIdsInput = {
  integrationSubTaskIds?: Maybe<Array<Scalars['String']>>;
  integrationTaskId: Scalars['String'];
};

export type TaskObj = {
  __typename?: 'TaskObj';
  assets?: Maybe<Array<UserInputAssetFileObj>>;
  assignee?: Maybe<UserObj>;
  blockerTasks?: Maybe<Array<TaskObj>>;
  blockingTasks?: Maybe<Array<TaskObj>>;
  completedOn?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  externalSubTaskId?: Maybe<Scalars['String']>;
  externalTaskId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  launch?: Maybe<LaunchObj>;
  launchId?: Maybe<Scalars['String']>;
  launchModuleId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  owner?: Maybe<UserObj>;
  paginatedSubtasks: PaginatedTaskObj;
  parentId?: Maybe<Scalars['String']>;
  plainDescription: Scalars['String'];
  priority: Scalars['Int'];
  startDate?: Maybe<Scalars['DateTime']>;
  status: TaskStatusTypes;
  subtasks: Array<TaskObj>;
  tags?: Maybe<Array<TagObj>>;
  templateModuleId?: Maybe<Scalars['String']>;
  type?: Maybe<TaskTypes>;
};


export type TaskObjPaginatedSubtasksArgs = {
  filter?: Maybe<FilterTasksInput>;
  pagination?: Maybe<PaginationInput>;
  sort?: Maybe<SortTasksInput>;
};


export type TaskObjSubtasksArgs = {
  filter?: Maybe<FilterTasksInput>;
};

export type TaskTitleAndDescription = {
  __typename?: 'TaskTitleAndDescription';
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type TasksProgressObj = {
  __typename?: 'TasksProgressObj';
  canceledCount: Scalars['Float'];
  canceledPercentage?: Maybe<Scalars['Float']>;
  completedCount: Scalars['Float'];
  completedPercentage?: Maybe<Scalars['Float']>;
  delayedCount: Scalars['Float'];
  delayedPercentage?: Maybe<Scalars['Float']>;
  inProgressCount: Scalars['Float'];
  inProgressPercentage?: Maybe<Scalars['Float']>;
  inReviewCount: Scalars['Float'];
  inReviewPercentage?: Maybe<Scalars['Float']>;
  notStartedCount: Scalars['Float'];
  notStartedPercentage?: Maybe<Scalars['Float']>;
  progressPercentage: Scalars['Float'];
  totalCount: Scalars['Float'];
};

export type TemplateGtmTimelineObj = {
  __typename?: 'TemplateGtmTimelineObj';
  channelTemplates?: Maybe<Array<ChannelTemplatesObj>>;
  templateMilestones?: Maybe<Array<TemplateMilestonesObj>>;
};

export type TemplateMilestonesObj = {
  __typename?: 'TemplateMilestonesObj';
  defaultEndDateDuration?: Maybe<Scalars['Float']>;
  defaultStartDateDuration?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  type: MilestoneType;
};

export type TemplateModuleObj = {
  __typename?: 'TemplateModuleObj';
  canGenerateWithAI?: Maybe<Scalars['Boolean']>;
  editor: EditorsTypes;
  hint?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  templateModuleTasks?: Maybe<Array<TemplateTaskObj>>;
  userInput?: Maybe<UserInputObj>;
};

export type TemplateObj = {
  __typename?: 'TemplateObj';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserObj>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  launchTier?: Maybe<LaunchTiers>;
  launchTierDetails?: Maybe<Array<LaunchTierDetailsObj>>;
  launchType?: Maybe<LaunchTypeObj>;
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  phaseIds?: Maybe<Array<Scalars['String']>>;
  supportsCopilot: Scalars['Boolean'];
  templateSections: Array<TemplateSectionObj>;
  templateTasks?: Maybe<Array<TemplateTaskObj>>;
};

export type TemplateSectionObj = {
  __typename?: 'TemplateSectionObj';
  hideModules?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  templateModuleIds: Array<Scalars['String']>;
  templateModules?: Maybe<Array<TemplateModuleObj>>;
};

export type TemplateSubTaskObj = {
  __typename?: 'TemplateSubTaskObj';
  defaultDueDateDuration?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  tags: Array<Scalars['String']>;
  type?: Maybe<TaskTypes>;
};

export type TemplateTaskObj = {
  __typename?: 'TemplateTaskObj';
  defaultDueDateDuration?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  subTasks?: Maybe<Array<TemplateSubTaskObj>>;
  tags?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<TaskTypes>;
};

export type TestimonialFromInsightObj = {
  __typename?: 'TestimonialFromInsightObj';
  company?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  insightSource?: Maybe<InsightSource>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  quote?: Maybe<Scalars['String']>;
  registeredOn?: Maybe<Scalars['DateTime']>;
};

export type TestimonialObj = {
  __typename?: 'TestimonialObj';
  company?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  insightSource?: Maybe<InsightSource>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  quote?: Maybe<Scalars['String']>;
  registeredOn?: Maybe<Scalars['DateTime']>;
  status: TestimonialStatus;
  tags?: Maybe<Array<TagObj>>;
  updatedAt: Scalars['DateTime'];
};

export type TestimonialsFilterInput = {
  query?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};

export enum Theme {
  DARK = 'DARK',
  LIGHT = 'LIGHT'
}


export type ToggleLaunchPhaseApprovalInput = {
  approve: Scalars['Boolean'];
  launchId: Scalars['String'];
  phaseId: Scalars['String'];
};

export type ToggleLaunchPrivateInput = {
  isPrivate: Scalars['Boolean'];
  launchId: Scalars['String'];
};

export type ToggleModuleLockInput = {
  locked: Scalars['Boolean'];
  moduleId: Scalars['String'];
};

export type TranslateInput = {
  language: Language;
  text: Scalars['String'];
};

export type TurnFeedbackPostIntoProductBoardItemInput = {
  feedbackPostId: Scalars['String'];
  roadmapId: Scalars['String'];
};

export enum UserRolesInOrganizationTypes {
  ADMIN = 'ADMIN',
  EDITOR = 'EDITOR',
  VIEWER = 'VIEWER'
}

export type UpdateAiCopywritingSectionInput = {
  isCompletedMarketingOrAssetGeneration: Scalars['Boolean'];
};

export type UpdateAiSettingsInput = {
  brandGuidelines: Scalars['String'];
  companyDescription: Scalars['String'];
  companyName: Scalars['String'];
  companyWebsite: Scalars['String'];
  tone: Scalars['String'];
};

export type UpdateAnnouncementInput = {
  destinations?: Maybe<Array<NotificationDestinations>>;
  id: Scalars['String'];
  launchId?: Maybe<Scalars['String']>;
  launchModulesIds?: Maybe<Array<Scalars['String']>>;
  message?: Maybe<Scalars['String']>;
  repeatOn?: Maybe<Scalars['DateTime']>;
  repeatType?: Maybe<RepeatNotificationTypes>;
  sendAs?: Maybe<NotificationSendAsTypes>;
  status?: Maybe<NotificationStatus>;
  subject?: Maybe<Scalars['String']>;
};

export type UpdateAnnouncementUsersInput = {
  action: MsgGrpUserUpdateTypes;
  id: Scalars['String'];
  messageGroupIds?: Maybe<Array<Scalars['String']>>;
  nonUserIds?: Maybe<Array<Scalars['String']>>;
  userIds?: Maybe<Array<Scalars['String']>>;
};

export type UpdateApprovalRequestStatusInput = {
  approverId: Scalars['String'];
  launchId: Scalars['String'];
  phaseId: Scalars['String'];
};

export type UpdateApproversInput = {
  required: Scalars['Boolean'];
  userId: Scalars['String'];
};

export type UpdateAssetApproverInput = {
  action: AssetActionTypes;
  assetId: Scalars['String'];
  invitedUsers?: Maybe<Array<Scalars['String']>>;
  userIds?: Maybe<Array<Scalars['String']>>;
};

export type UpdateAssetInput = {
  assets?: Maybe<Array<AssetsFile>>;
  brandAsset?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  lastEditDetails?: Maybe<LastEditDetailsInput>;
  launchIds?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Scalars['String']>;
  opened?: Maybe<Scalars['Boolean']>;
  tagsIds?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<AssetTypes>;
  userInput?: Maybe<Scalars['String']>;
};

export type UpdateCalendarPublicPageSettingsInput = {
  live: Scalars['Boolean'];
};

export type UpdateCampaignPlanningSectionInput = {
  isCompletedConfigureTemplate: Scalars['Boolean'];
  isCompletedCreateFirstLaunch: Scalars['Boolean'];
};

export type UpdateChannelInput = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  launchId: Scalars['String'];
  logoSrc?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type UpdateChannelTimeframeInput = {
  budget?: Maybe<Scalars['Float']>;
  channelId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Timestamp']>;
  id: Scalars['String'];
  launchId: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Timestamp']>;
};

export type UpdateChecklistInput = {
  aiCopywriting?: Maybe<UpdateAiCopywritingSectionInput>;
  campaignPlanning?: Maybe<UpdateCampaignPlanningSectionInput>;
  competitiveIntel?: Maybe<UpdateCompetitiveIntelSectionInput>;
  roadmapping?: Maybe<UpdateRoadmappingSectionInput>;
  selectedFeatures?: Maybe<Array<ChecklistFeature>>;
  voiceOfCustomer?: Maybe<UpdateVoiceOfCustomerSectionInput>;
  winloss?: Maybe<UpdateWinLossAnalysisSectionInput>;
  workspaceConfig?: Maybe<UpdateWorkspaceConfigSectionInput>;
};

export type UpdateCommentInput = {
  assets?: Maybe<Array<AssetsFile>>;
  id: Scalars['String'];
  json: Scalars['String'];
  text: Scalars['String'];
};

export type UpdateCompanyInput = {
  attachments?: Maybe<AttachmentsInput>;
  avgG2ScoreHistory?: Maybe<Array<AvgG2ScoreHistory>>;
  battlecardScreenshots?: Maybe<Array<UpdateScreenshots>>;
  clearbitId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  employees?: Maybe<Scalars['String']>;
  employeesCountHistory?: Maybe<Array<EmployeesCountHistory>>;
  estimatedAnnualRevenue?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  keyPeople?: Maybe<Array<UpdateKeyPeople>>;
  launchIds?: Maybe<Array<Scalars['String']>>;
  location?: Maybe<Scalars['String']>;
  messagingSummary?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  news?: Maybe<Array<UpdateNews>>;
  publicPageConfig?: Maybe<UpdateCompanyPublicPageConfigInput>;
  raised?: Maybe<Scalars['String']>;
  rssFeed?: Maybe<Array<UpdateRssFeeds>>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  talkingPoints?: Maybe<Array<UpdateTalkingPoints>>;
  talkingPointsUpdatedAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<Scalars['String']>;
};

export type UpdateCompanyPublicPageConfigInput = {
  live: Scalars['Boolean'];
  viewsCount: Scalars['Float'];
};

export type UpdateCompetitiveIntelSectionInput = {
  isCompletedCreateBattleCard: Scalars['Boolean'];
};

export type UpdateCompetitiveIntelligenceFeaturesInput = {
  categoryId?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['Boolean']>;
  competitor?: Maybe<Scalars['Boolean']>;
  competitorBattlecardId?: Maybe<Scalars['String']>;
  competitorBattlecardUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type UpdateCopywriteV2FavoriteInput = {
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  templateIds?: Maybe<Array<Scalars['String']>>;
};

export type UpdateFeatureTableCategoryInput = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type UpdateFeedbackBoardInput = {
  emailDomain?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  internal?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notifyingUserIds?: Maybe<Array<Scalars['String']>>;
  password?: Maybe<Scalars['String']>;
  productLineTagId?: Maybe<Scalars['String']>;
  sendNotification?: Maybe<Scalars['Boolean']>;
  subHeading?: Maybe<Scalars['String']>;
};

export type UpdateFeedbackCommentInput = {
  id: Scalars['String'];
  internal?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export type UpdateFeedbackCustomColumnInput = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type UpdateFeedbackPostAsAdminInput = {
  accountIds?: Maybe<Array<Scalars['String']>>;
  assigneeId?: Maybe<Scalars['String']>;
  customColumns?: Maybe<Array<FeedbackPostCustomColumnInput>>;
  dealIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  importance?: Maybe<FeedbackPostImportance>;
  insightIds?: Maybe<Array<Scalars['String']>>;
  internal?: Maybe<Scalars['Boolean']>;
  productBoardItemsIds?: Maybe<Array<Scalars['String']>>;
  productLineTagIds?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<FeedbackPostStatus>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
};

export type UpdateFeedbackPostInput = {
  accountIds?: Maybe<Array<Scalars['String']>>;
  customColumns?: Maybe<Array<FeedbackPostCustomColumnInput>>;
  dealIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  importance?: Maybe<FeedbackPostImportance>;
  internal?: Maybe<Scalars['Boolean']>;
  productBoardItemsIds?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<FeedbackPostStatus>;
  title?: Maybe<Scalars['String']>;
};

export type UpdateFeedbackUserInput = {
  avatarSrc?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
};

export type UpdateInsightGeneratedItemInput = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  insightIds?: Maybe<Array<Scalars['String']>>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<InsightGeneratedItemsType>;
};

export type UpdateInsightInput = {
  accountId?: Maybe<Scalars['String']>;
  assigneeId?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  competitorIds?: Maybe<Array<Scalars['String']>>;
  contactId?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  conversationType?: Maybe<Scalars['String']>;
  customerType?: Maybe<Scalars['String']>;
  feedbackPostIds?: Maybe<Array<Scalars['String']>>;
  id?: Maybe<Scalars['String']>;
  launchIds?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Scalars['String']>;
  personasIds?: Maybe<Array<Scalars['String']>>;
  productBoardItemsIds?: Maybe<Array<Scalars['String']>>;
  productLineTagIds?: Maybe<Array<Scalars['String']>>;
  registeredOn?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  taskIds?: Maybe<Array<Scalars['String']>>;
  user?: Maybe<Scalars['String']>;
};

export type UpdateInsightIntegrationInput = {
  feedbackBoardId?: Maybe<Scalars['String']>;
  feedbackPostMappings?: Maybe<Array<UpdateInsightIntegrationInputFeedbackPostMapping>>;
  generateFeedbackPosts?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  insightMappings?: Maybe<Array<UpdateInsightIntegrationInputInsightMapping>>;
  webhookEnabled?: Maybe<Scalars['Boolean']>;
};

export type UpdateInsightIntegrationInputFeedbackPostMapping = {
  channelId: Scalars['String'];
  feedbackBoardId: Scalars['String'];
};

export type UpdateInsightIntegrationInputInsightMapping = {
  channelId: Scalars['String'];
  productLineTagId: Scalars['String'];
};

export type UpdateInsightTrendItemInput = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  insightIds?: Maybe<Array<Scalars['String']>>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<InsightTrendItemsType>;
};

export type UpdateInsightsMarketingSummaryInput = {
  commonTerms?: Maybe<Array<Scalars['String']>>;
  confusionPoints?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  solvedProblems?: Maybe<Array<Scalars['String']>>;
  valueDrivers?: Maybe<Array<Scalars['String']>>;
};

export type UpdateInsightsProductSummaryInput = {
  featureRequests?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  overallSentiment?: Maybe<Scalars['String']>;
  strengths?: Maybe<Array<Scalars['String']>>;
  weaknesses?: Maybe<Array<Scalars['String']>>;
};

export type UpdateInsightsTagsInput = {
  ids: Array<Scalars['String']>;
  tagIds: Array<Scalars['String']>;
};

export type UpdateKeyPeople = {
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  linkedIn?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  subRole?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type UpdateKpiInput = {
  currentValue?: Maybe<Scalars['Float']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  format?: Maybe<KpiMetrics>;
  id?: Maybe<Scalars['String']>;
  launchId?: Maybe<Scalars['String']>;
  objectiveId?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  qualitativeStatus?: Maybe<OkrQualitativeStatus>;
  targetValue?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
};

export type UpdateLaunchApprovalStatusInput = {
  approvalStatus: Scalars['Boolean'];
  launchId: Scalars['String'];
  launchModuleIds: Array<Scalars['String']>;
};

export type UpdateLaunchCopilotOptionsInput = {
  lastOnBoardingStep?: Maybe<CopilotOnBoardingSteps>;
  launchId: Scalars['String'];
  preferBuildAssets?: Maybe<Scalars['Boolean']>;
  preferBuildChannels?: Maybe<Scalars['Boolean']>;
  preferBuildTasks?: Maybe<Scalars['Boolean']>;
};

export type UpdateLaunchDetailsInput = {
  budget?: Maybe<Scalars['Float']>;
  customProgress?: Maybe<CustomProgressInput>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastUpdateSentAt?: Maybe<Scalars['DateTime']>;
  launchDate?: Maybe<Scalars['DateTime']>;
  launchTier?: Maybe<LaunchTiers>;
  launchTypeId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  productIntegrationSubTaskIds?: Maybe<Array<Scalars['String']>>;
  productIntegrationTaskIds?: Maybe<Array<Scalars['String']>>;
  readinessNote?: Maybe<Scalars['String']>;
  sectionVisibilityPreferences?: Maybe<SectionVisibilityPreferencesInput>;
  shiftChannelsDates?: Maybe<Scalars['Boolean']>;
  shiftMilestonesDate?: Maybe<Scalars['Boolean']>;
  shiftTasksDates?: Maybe<Scalars['Boolean']>;
  stageId?: Maybe<Scalars['String']>;
  strategicApproach?: Maybe<StrategicApproach>;
  tagsIds?: Maybe<Array<Scalars['String']>>;
};

export type UpdateLaunchLaunchTypeInput = {
  id: Scalars['String'];
  launchTypeId: Scalars['String'];
};

export type UpdateLaunchModuleApprovalStatusInput = {
  approvalStatus: Scalars['Boolean'];
  launchId: Scalars['String'];
  launchModuleId: Scalars['String'];
};

export type UpdateLaunchModuleDetailsInput = {
  approvalStatus?: Maybe<LaunchModuleApprovalStatus>;
  dueDate?: Maybe<Scalars['DateTime']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  launchModuleIds: Array<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  tagsIds?: Maybe<Array<Scalars['String']>>;
};

export type UpdateLaunchModuleUserInputInput = {
  id: Scalars['String'];
  userInput?: Maybe<UserInput>;
};

export type UpdateLaunchPhaseInput = {
  approvalRequestSent?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['DateTime']>;
  launchId: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phaseId: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<LaunchPhaseStatus>;
};

export type UpdateLaunchPublicCopyAndAssetsPageSettingsInput = {
  assetsModules?: Maybe<Array<Scalars['String']>>;
  live?: Maybe<Scalars['Boolean']>;
};

export type UpdateLaunchPublicLaunchPlanPageSettingsInput = {
  launchModules?: Maybe<Array<Scalars['String']>>;
  live?: Maybe<Scalars['Boolean']>;
};

export type UpdateLaunchPublicPageConfigInput = {
  id: Scalars['String'];
  live?: Maybe<Scalars['Boolean']>;
  settings?: Maybe<UpdateLaunchPublicPagesSettingsInput>;
};

export type UpdateLaunchPublicPageSettingsInput = {
  live?: Maybe<Scalars['Boolean']>;
};

export type UpdateLaunchPublicPagesSettingsInput = {
  competitiveIntelligence?: Maybe<UpdateLaunchPublicPageSettingsInput>;
  copyAndAssets?: Maybe<UpdateLaunchPublicCopyAndAssetsPageSettingsInput>;
  customersResearch?: Maybe<UpdateLaunchPublicPageSettingsInput>;
  gtmTimeline?: Maybe<UpdateLaunchPublicPageSettingsInput>;
  launchPlan?: Maybe<UpdateLaunchPublicLaunchPlanPageSettingsInput>;
  measurements?: Maybe<UpdateLaunchPublicPageSettingsInput>;
  missionControl?: Maybe<UpdateLaunchPublicPageSettingsInput>;
  productStatus?: Maybe<UpdateLaunchPublicPageSettingsInput>;
  tasks?: Maybe<UpdateLaunchPublicPageSettingsInput>;
};

export type UpdateLaunchSectionInput = {
  id?: Maybe<Scalars['String']>;
  launchId?: Maybe<Scalars['String']>;
  launchModuleIds?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
};

export type UpdateLaunchSectionsInput = {
  launchId: Scalars['String'];
  launchSection: UpdateLaunchSectionInput;
};

export type UpdateMeasurementIntegrationMetricInput = {
  eventName?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<MeasurementIntegrationMetricFilterInput>>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type UpdateMessageGroupInput = {
  emails?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  nonUserIds?: Maybe<Array<Scalars['String']>>;
  userIds?: Maybe<Array<Scalars['String']>>;
};

export type UpdateMessageGroupUsersInput = {
  action: MsgGrpUserUpdateTypes;
  id: Scalars['String'];
  nonUserId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UpdateMessagingLibraryInput = {
  customMessaging?: Maybe<Array<CustomMessagingInput>>;
  id: Scalars['String'];
  isViewed?: Maybe<Scalars['Boolean']>;
  messaging?: Maybe<Scalars['String']>;
  positioningStrategy?: Maybe<Scalars['String']>;
};

export type UpdateMilestoneInput = {
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Timestamp']>;
  id: Scalars['String'];
  launchId: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Timestamp']>;
};

export type UpdateNews = {
  description?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  publishedDate?: Maybe<Scalars['String']>;
  sourceTitle?: Maybe<Scalars['String']>;
  sourceUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type UpdateObjectiveInput = {
  assignee?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  kpis?: Maybe<Array<Scalars['String']>>;
  launchId?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  releaseId?: Maybe<Scalars['String']>;
  roadmapId?: Maybe<Scalars['String']>;
  tagsIds?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
  type: OkrType;
};

export type UpdateOrganizationExternalPageInput = {
  accentColor?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<Scalars['String']>;
  dismissedWantToPublish?: Maybe<Scalars['Boolean']>;
  domain?: Maybe<Scalars['String']>;
  font?: Maybe<Scalars['String']>;
  live?: Maybe<Scalars['Boolean']>;
  textColor?: Maybe<Scalars['String']>;
};

export type UpdateOrganizationExternalPageReleaseNotesInput = {
  description?: Maybe<Scalars['String']>;
  indexInSearchEngines?: Maybe<Scalars['Boolean']>;
  live?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type UpdateOrganizationInput = {
  admin?: Maybe<Scalars['String']>;
  aiSettings?: Maybe<UpdateAiSettingsInput>;
  allowUsersFromSameDomain?: Maybe<Scalars['Boolean']>;
  appsumoInvoiceUuid?: Maybe<Scalars['String']>;
  appsumoPlanId?: Maybe<Scalars['String']>;
  appsumoUuid?: Maybe<Scalars['String']>;
  billingEmailId?: Maybe<Scalars['String']>;
  chatGTMEnabled?: Maybe<Scalars['Boolean']>;
  companyType?: Maybe<OrganizationTypeOfCompany>;
  currentSubscriptionPlanName?: Maybe<Scalars['String']>;
  currentSubscriptionPlanStripePriceId?: Maybe<Scalars['String']>;
  customerTemplateUrls?: Maybe<Array<Scalars['String']>>;
  deleted?: Maybe<Scalars['Boolean']>;
  hasCreatedFirstLaunch?: Maybe<Scalars['Boolean']>;
  hasExpiredFreeTrial?: Maybe<Scalars['Boolean']>;
  hasPaidSubscription?: Maybe<Scalars['Boolean']>;
  haveGtm?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isUnderFreeTrial?: Maybe<Scalars['Boolean']>;
  launchesPerYear?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationEmailDomain?: Maybe<Scalars['String']>;
  peopleRange?: Maybe<Scalars['String']>;
  sampleDataFlag?: Maybe<SampleDataDeleteDetailsInput>;
  showSampleDataDeleteFlag?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  subscriptionRestrictions?: Maybe<UpdateSubscriptionRestrictionsObj>;
  users?: Maybe<Array<UpdateUserInOrganizationInput>>;
};

export type UpdatePersonaDemographicsCategoryInput = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  personaId: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type UpdatePersonaInput = {
  age?: Maybe<Array<Scalars['Float']>>;
  avatar?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  launchesIds?: Maybe<Array<Scalars['String']>>;
  messagingLibraryIds?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Scalars['String']>;
  occupation?: Maybe<Scalars['String']>;
  primary?: Maybe<Scalars['Boolean']>;
  tagsIds?: Maybe<Array<Scalars['String']>>;
};

export type UpdatePersonaNoteInput = {
  id: Scalars['String'];
  personaId: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type UpdatePhaseInput = {
  daysAfterLaunch?: Maybe<Scalars['Float']>;
  durationInDays?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type UpdateProductBoardCustomColumnInput = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type UpdateProductBoardFactorInput = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  scale?: Maybe<ProductBoardFactorScales>;
  weight?: Maybe<Scalars['Int']>;
};

export type UpdateProductBoardItemInput = {
  accountIds?: Maybe<Array<Scalars['String']>>;
  assigneeId?: Maybe<Scalars['String']>;
  blockedByItemIds?: Maybe<Array<Scalars['String']>>;
  competitorIds?: Maybe<Array<Scalars['String']>>;
  customColumns?: Maybe<Array<ProductBoardItemCustomColumnInput>>;
  customFileUrls?: Maybe<Array<Scalars['String']>>;
  dealIds?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  designFileUrls?: Maybe<Array<Scalars['String']>>;
  effort?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['DateTime']>;
  factors?: Maybe<Array<ProductBoardItemFactorInput>>;
  feedbackPostIds?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  insightIds?: Maybe<Array<Scalars['String']>>;
  launchIds?: Maybe<Array<Scalars['String']>>;
  personaIds?: Maybe<Array<Scalars['String']>>;
  priority?: Maybe<RoadmapItemPriority>;
  productDocUrls?: Maybe<Array<Scalars['String']>>;
  productLineTagIds?: Maybe<Array<Scalars['String']>>;
  releaseId?: Maybe<Scalars['String']>;
  roadmapId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  statusId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
};

export type UpdateProductBoardItemsViewInput = {
  filter?: Maybe<CreateProductBoardItemsViewFilterInput>;
  groupBy?: Maybe<ProductBoardItemsGroupBy>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  orderIndexes?: Maybe<Array<ProductBoardItemsViewItemOrderIndexInput>>;
  sort?: Maybe<ProductBoardItemsSortInput>;
  view?: Maybe<ProductBoardView>;
  visibleProperties: Array<Scalars['String']>;
};

export type UpdateProductBoardReleaseInput = {
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  iconColor?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  launchIds?: Maybe<Array<Scalars['String']>>;
  milestoneIds?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  productLineTagId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type UpdateProductBoardRoadmapInput = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  productLineTagId?: Maybe<Scalars['String']>;
  publicPageConfig?: Maybe<UpdatePublicPageConfigInput>;
};

export type UpdateProductBoardStatusInput = {
  description?: Maybe<Scalars['String']>;
  iconColor?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type UpdatePublicPageConfigInput = {
  live: Scalars['Boolean'];
};

export type UpdatePublicPageInput = {
  coverImage?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  headerDescription?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isProductIdeasLive?: Maybe<Scalars['Boolean']>;
  isReleaseNotesLive?: Maybe<Scalars['Boolean']>;
  live?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  productIdeaBoardSettings?: Maybe<Array<ProductIdeaBoardSettingsInput>>;
  releaseNotesFilters?: Maybe<ReleaseNotesFiltersInput>;
  releaseNotesPassword?: Maybe<Scalars['String']>;
  styleSettings?: Maybe<StyleSettingsInput>;
};

export type UpdateReleaseNoteInput = {
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  internal?: Maybe<Scalars['Boolean']>;
  launchId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationSent?: Maybe<Scalars['Boolean']>;
};

export type UpdateReleaseNoteTagInput = {
  releaseNoteId: Scalars['String'];
  tagId: Scalars['String'];
};

export type UpdateRetroInput = {
  id: Scalars['String'];
  takeaways?: Maybe<Scalars['String']>;
};

export type UpdateRoadmappingSectionInput = {
  isCompletedConnectCRM: Scalars['Boolean'];
  isCompletedConnectTasksIntegration: Scalars['Boolean'];
  isCompletedCreateRoadmapItem: Scalars['Boolean'];
  isCompletedImportRoadmapData: Scalars['Boolean'];
};

export type UpdateRoadmapsPublicPagesSettingsInput = {
  ids: Array<Scalars['String']>;
  live: Scalars['Boolean'];
};

export type UpdateRssFeeds = {
  key?: Maybe<Scalars['String']>;
  pageUrl?: Maybe<Scalars['String']>;
};

export type UpdateSavedInsightsSummaryInput = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
};

export type UpdateScreenshots = {
  key?: Maybe<Scalars['String']>;
  pageUrl?: Maybe<Scalars['String']>;
};

export type UpdateSectionInput = {
  name: Scalars['String'];
  templateModuleIds: Array<Scalars['String']>;
};

export type UpdateSubscriptionRestrictionsCompetitiveIntelligenceInput = {
  refreshNewsAfterDays?: Maybe<Scalars['Float']>;
  refreshScreenshotsAfterDays?: Maybe<Scalars['Float']>;
};

export type UpdateSubscriptionRestrictionsObj = {
  numberOfEditorsAllowed?: Maybe<Scalars['Float']>;
  refreshNewsAfterDays?: Maybe<UpdateSubscriptionRestrictionsCompetitiveIntelligenceInput>;
  researchHubAllowed?: Maybe<Scalars['Boolean']>;
};

export type UpdateSurveyInput = {
  emailBody?: Maybe<Scalars['String']>;
  emailSignature?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  inputs?: Maybe<Array<CreateSurveyInputObj>>;
  name?: Maybe<Scalars['String']>;
  surveyType?: Maybe<SurveyTypes>;
};

export type UpdateTagInput = {
  color?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  label?: Maybe<Scalars['String']>;
};

export type UpdateTagToTestimonialsInput = {
  tagId: Scalars['String'];
  testimonialsIds: Array<Scalars['String']>;
};

export type UpdateTagsOfFeedbackPostInput = {
  feedbackPostId: Scalars['String'];
  tagIds: Array<Scalars['String']>;
};

export type UpdateTagsOfFeedbackPostsInput = {
  feedbackPostIds: Array<Scalars['String']>;
  tagIds: Array<Scalars['String']>;
};

export type UpdateTalkingPoints = {
  placeholder?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type UpdateTaskInput = {
  assets?: Maybe<Array<AssetFile>>;
  assigneeId?: Maybe<Scalars['String']>;
  blockedByTaskIds?: Maybe<Array<Scalars['String']>>;
  completedOn?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  externalSubTaskId?: Maybe<Scalars['String']>;
  externalTaskId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  launchId?: Maybe<Scalars['String']>;
  launchModuleId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<TaskStatusTypes>;
  tagsIds?: Maybe<Array<Scalars['String']>>;
  templateModuleId?: Maybe<Scalars['String']>;
  type?: Maybe<TaskTypes>;
};

export type UpdateTemplateInput = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  launchTier?: Maybe<LaunchTiers>;
  name?: Maybe<Scalars['String']>;
  templateSections?: Maybe<Array<UpdateSectionInput>>;
  templateTasks?: Maybe<Array<UpdateTemplateTask>>;
};

export type UpdateTemplateModuleInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  templateModuleTasks?: Maybe<Array<UpdateTemplateTask>>;
  userInput?: Maybe<UserInput>;
};

export type UpdateTemplateTask = {
  defaultDueDateDuration?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<TaskTypes>;
};

export type UpdateTestimonialInput = {
  company?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  quote?: Maybe<Scalars['String']>;
  registeredOn?: Maybe<Scalars['DateTime']>;
  status?: Maybe<TestimonialStatus>;
  tags?: Maybe<Array<Scalars['String']>>;
};

export type UpdateUserInOrganizationInput = {
  inviteAccepted: Scalars['Boolean'];
  role: UserRolesInOrganizationTypes;
  userId: Scalars['String'];
};

export type UpdateUserInput = {
  appsumoInvoiceUuid?: Maybe<Scalars['String']>;
  appsumoPlanId?: Maybe<Scalars['String']>;
  appsumoUuid?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isEmailVerified?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationPreferences?: Maybe<NotificationPreferencesInput>;
  onboardingGoals?: Maybe<Array<OnboardingGoal>>;
  password?: Maybe<Scalars['String']>;
  primaryOnboardingGoal?: Maybe<OnboardingGoal>;
  profileImage?: Maybe<Scalars['String']>;
  slackId?: Maybe<Scalars['String']>;
  theme?: Maybe<Theme>;
  timeZone?: Maybe<Scalars['String']>;
};

export type UpdateUsersInLaunchInput = {
  launchId: Scalars['String'];
  launchModuleIds: Array<Scalars['String']>;
  requestEditAccess?: Maybe<Scalars['Boolean']>;
  role: StakeholderTypes;
  userIds: Array<Scalars['String']>;
};

export type UpdateVoiceOfCustomerSectionInput = {
  isClickedConfigurePublicBoard: Scalars['Boolean'];
  isClickedConnectIntegration: Scalars['Boolean'];
};

export type UpdateWinLossAnalysisSectionInput = {
  isCompletedWinLossSync: Scalars['Boolean'];
};

export type UpdateWorkspaceConfigSectionInput = {
  isWorkspaceConfigured: Scalars['Boolean'];
};

export type UserFilterOptionObj = {
  __typename?: 'UserFilterOptionObj';
  label: Scalars['String'];
  profileImage?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type UserInOrganizationObj = {
  __typename?: 'UserInOrganizationObj';
  avatarColor: Scalars['String'];
  canResendInvite?: Maybe<Scalars['Boolean']>;
  displayedBanners: DisplayedBannersObj;
  email: Scalars['String'];
  id: Scalars['String'];
  inviteAccepted: Scalars['Boolean'];
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<Scalars['String']>;
  isEmailVerified?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastInvitedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  primaryOnboardingGoal: OnboardingGoal;
  profileImage?: Maybe<Scalars['String']>;
  role: UserRolesInOrganizationTypes;
  theme: Theme;
  userDetails?: Maybe<UserObj>;
  userId: Scalars['String'];
};

export type UserInput = {
  ASSETS_EDITOR?: Maybe<UserInputAssets>;
  BUDGET_EDITOR?: Maybe<UserInputBudget>;
  COPY_ASSETS_EDITOR?: Maybe<UserInputCopyAssets>;
  FEATURES_EDITOR?: Maybe<Array<UserInputFeatures>>;
  KPI_EDITOR?: Maybe<Array<UserInputKpi>>;
  LAUNCHTEAM_EDITOR?: Maybe<Array<UserInputLaunchTeam>>;
  POSITIONING_EDITOR?: Maybe<UserInputPositioning>;
  POSITIONING_EDITOR_NEW?: Maybe<Array<UserInputPositioningNew>>;
  TAGS_EDITOR?: Maybe<UserInputTags>;
  WYSIWYG_EDITOR?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type UserInputAssetFileObj = {
  __typename?: 'UserInputAssetFileObj';
  format: Scalars['String'];
  name: Scalars['String'];
  size: Scalars['String'];
  url: Scalars['String'];
};

export type UserInputAssetFilesObj = {
  __typename?: 'UserInputAssetFilesObj';
  format: Scalars['String'];
  name: Scalars['String'];
  size: Scalars['String'];
  url: Scalars['String'];
};

export type UserInputAssets = {
  assets: Array<UserInputAssetsDetail>;
  id?: Maybe<Scalars['String']>;
};

export type UserInputAssetsDetail = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  url: Scalars['String'];
};

export type UserInputAssetsDetailObj = {
  __typename?: 'UserInputAssetsDetailObj';
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  url: Scalars['String'];
};

export type UserInputAssetsObj = {
  __typename?: 'UserInputAssetsObj';
  assets: Array<UserInputAssetsDetailObj>;
  id?: Maybe<Scalars['String']>;
};

export type UserInputBudget = {
  allocationNotes: Scalars['String'];
  budget: Array<UserInputBudgetDetail>;
  id?: Maybe<Scalars['String']>;
};

export type UserInputBudgetDetail = {
  activities: Array<UserInputBudgetDetailActivities>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  value: Scalars['Float'];
};

export type UserInputBudgetDetailActivities = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  value: Scalars['Float'];
};

export type UserInputBudgetDetailActivitiesObj = {
  __typename?: 'UserInputBudgetDetailActivitiesObj';
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  value: Scalars['Float'];
};

export type UserInputBudgetDetailObj = {
  __typename?: 'UserInputBudgetDetailObj';
  activities: Array<UserInputBudgetDetailActivitiesObj>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  value: Scalars['Float'];
};

export type UserInputBudgetObj = {
  __typename?: 'UserInputBudgetObj';
  allocationNotes: Scalars['String'];
  budget: Array<UserInputBudgetDetailObj>;
  id?: Maybe<Scalars['String']>;
};

export type UserInputCopyAssets = {
  assets?: Maybe<Array<AssetFile>>;
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  opened?: Maybe<Scalars['Boolean']>;
  type?: Maybe<AssetTypes>;
};

export type UserInputCopyAssetsObj = {
  __typename?: 'UserInputCopyAssetsObj';
  assets?: Maybe<Array<UserInputAssetFileObj>>;
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  opened?: Maybe<Scalars['Boolean']>;
  type?: Maybe<AssetTypes>;
};

export type UserInputFeatures = {
  featureName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  tag: Scalars['String'];
};

export type UserInputFeaturesObj = {
  __typename?: 'UserInputFeaturesObj';
  featureName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  tag: Scalars['String'];
};

export type UserInputKpi = {
  actual: Scalars['Float'];
  format: KpiMetrics;
  id?: Maybe<Scalars['String']>;
  metric: Scalars['String'];
  target: Scalars['Float'];
};

export type UserInputKpiObj = {
  __typename?: 'UserInputKPIObj';
  actual: Scalars['Float'];
  format: KpiMetrics;
  id?: Maybe<Scalars['String']>;
  metric: Scalars['String'];
  target: Scalars['Float'];
};

export type UserInputLastEditDetailsObj = {
  __typename?: 'UserInputLastEditDetailsObj';
  timestamp?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserInputLaunchTeam = {
  email: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  role: LaunchTeamModuleRoles;
};

export type UserInputLaunchTeamObj = {
  __typename?: 'UserInputLaunchTeamObj';
  email: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  role: LaunchTeamModuleRoles;
};

export type UserInputObj = {
  __typename?: 'UserInputObj';
  ASSETS_EDITOR?: Maybe<UserInputAssetsObj>;
  BUDGET_EDITOR?: Maybe<UserInputBudgetObj>;
  COPY_ASSETS_EDITOR?: Maybe<UserInputCopyAssetsObj>;
  FEATURES_EDITOR?: Maybe<Array<UserInputFeaturesObj>>;
  KPI_EDITOR?: Maybe<Array<UserInputKpiObj>>;
  LAUNCHTEAM_EDITOR?: Maybe<Array<UserInputLaunchTeamObj>>;
  POSITIONING_EDITOR?: Maybe<UserInputPositioningObj>;
  POSITIONING_EDITOR_NEW?: Maybe<Array<UserInputPositioningNewObj>>;
  TAGS_EDITOR?: Maybe<UserInputTagsObj>;
  TARGET_AUDIENCE_EDITOR_NEW?: Maybe<Array<PersonaDto>>;
  WYSIWYG_EDITOR?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  tasks?: Maybe<Array<TaskObj>>;
  updatedAt?: Maybe<Scalars['Timestamp']>;
};

export type UserInputPositioning = {
  alternatives?: Maybe<Scalars['String']>;
  attributes?: Maybe<Scalars['String']>;
  audience?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  problem?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type UserInputPositioningNew = {
  placeholder?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type UserInputPositioningNewObj = {
  __typename?: 'UserInputPositioningNewObj';
  placeholder?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type UserInputPositioningObj = {
  __typename?: 'UserInputPositioningObj';
  alternatives?: Maybe<Scalars['String']>;
  attributes?: Maybe<Scalars['String']>;
  audience?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  problem?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type UserInputTag = {
  key: Scalars['String'];
  name: Scalars['String'];
};

export type UserInputTagObj = {
  __typename?: 'UserInputTagObj';
  key: Scalars['String'];
  name: Scalars['String'];
};

export type UserInputTags = {
  id?: Maybe<Scalars['String']>;
  productLine?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<UserInputTag>>;
};

export type UserInputTagsObj = {
  __typename?: 'UserInputTagsObj';
  id?: Maybe<Scalars['String']>;
  productLine?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<UserInputTagObj>>;
};

export type UserModuleRoleObj = {
  __typename?: 'UserModuleRoleObj';
  hasApproved?: Maybe<Scalars['Boolean']>;
  launchModuleId: Scalars['String'];
  role: StakeholderTypes;
  saved?: Maybe<Scalars['Boolean']>;
};

export type UserObj = {
  __typename?: 'UserObj';
  appsumoInvoiceUuid?: Maybe<Scalars['String']>;
  appsumoPlanId?: Maybe<Scalars['String']>;
  appsumoUuid?: Maybe<Scalars['String']>;
  avatarColor: Scalars['String'];
  email: Scalars['String'];
  homepage: Homepage;
  id: Scalars['String'];
  isEmailVerified?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationPreferences?: Maybe<NotificationPreferences>;
  password: Scalars['String'];
  primaryOnboardingGoal: OnboardingGoal;
  profileImage?: Maybe<Scalars['String']>;
  theme: Theme;
  timeZone?: Maybe<Scalars['String']>;
};

export type UserWithModulesObj = {
  __typename?: 'UserWithModulesObj';
  modules?: Maybe<Array<UserModuleRoleObj>>;
  saved?: Maybe<Scalars['Boolean']>;
  userDetails?: Maybe<UserObj>;
  userId: Scalars['String'];
};

export type VerifyEmailInput = {
  email: Scalars['String'];
  origin?: Maybe<OrganizationOrigins>;
};

export type VoiceOfCustomerSectionObj = {
  __typename?: 'VoiceOfCustomerSectionObj';
  isClickedConfigurePublicBoard: Scalars['Boolean'];
  isClickedConnectIntegration: Scalars['Boolean'];
};

export enum WinlossStage {
  CLOSED_LOST = 'CLOSED_LOST',
  CLOSED_WON = 'CLOSED_WON'
}

export type WinLossAnalysisSectionObj = {
  __typename?: 'WinLossAnalysisSectionObj';
  isCompletedWinLossSync: Scalars['Boolean'];
};

export type WinLossCompetitorObj = {
  __typename?: 'WinLossCompetitorObj';
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type WinLossGraphDataObj = {
  __typename?: 'WinLossGraphDataObj';
  dealsLostArray?: Maybe<Array<Scalars['Float']>>;
  dealsWonArray?: Maybe<Array<Scalars['Float']>>;
  labels?: Maybe<Array<Scalars['String']>>;
};

export type WinLossMetricsObj = {
  __typename?: 'WinLossMetricsObj';
  acv?: Maybe<Scalars['Float']>;
  averageDealVelocity?: Maybe<Scalars['Float']>;
  wonTotalRatio?: Maybe<Scalars['Float']>;
};

export type WinLossRevenueDigestObj = {
  __typename?: 'WinLossRevenueDigestObj';
  lostDeals?: Maybe<Scalars['Float']>;
  lostRevenue?: Maybe<Scalars['Float']>;
  totalDeals?: Maybe<Scalars['Float']>;
  totalRevenue?: Maybe<Scalars['Float']>;
  wonDeals?: Maybe<Scalars['Float']>;
  wonRevenue?: Maybe<Scalars['Float']>;
};

export type WinLossTableObj = {
  __typename?: 'WinLossTableObj';
  account?: Maybe<DealCompanyObj>;
  amount?: Maybe<Scalars['String']>;
  closedDate?: Maybe<Scalars['DateTime']>;
  competitor?: Maybe<CompetitorNamesObj>;
  dealId: Scalars['String'];
  dealNotes?: Maybe<Scalars['String']>;
  lostReason?: Maybe<Scalars['String']>;
  organizatonId: Scalars['String'];
  owner?: Maybe<DealOwnerObj>;
  status?: Maybe<Scalars['String']>;
  totalLostAmount?: Maybe<Scalars['String']>;
  totalWonAmount?: Maybe<Scalars['String']>;
};

export enum WinlossTableSortBy {
  ACCOUNT = 'ACCOUNT',
  CLOSED_AT = 'CLOSED_AT',
  OPPORTUNITY_SIZE = 'OPPORTUNITY_SIZE',
  OWNER = 'OWNER',
  STAGE = 'STAGE'
}

export type WinlossTakeawaysSummaryObj = {
  __typename?: 'WinlossTakeawaysSummaryObj';
  id: Scalars['String'];
  loosingPoints: Array<Scalars['String']>;
  recommendations: Array<Scalars['String']>;
  segmentInsights: Array<Scalars['String']>;
  winningPoints: Array<Scalars['String']>;
};

export type WorkspaceConfigSectionObj = {
  __typename?: 'WorkspaceConfigSectionObj';
  isWorkspaceConfigured: Scalars['Boolean'];
};

export type ZendeskInsightIntegrationItemsFilterInput = {
  endDate: Scalars['Timestamp'];
  integrationId: Scalars['String'];
  onlySolved?: Maybe<Scalars['Boolean']>;
  startDate: Scalars['Timestamp'];
};

export type ZendeskInsightIntegrationItemsPaginationInput = {
  cursor?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
};

export type ZoomInsightIntegrationItemsPaginationInput = {
  cursor?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
};
